export default {
  contractName: "PixelChainMax",
  abi: [
    {
      inputs: [],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "approved",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "ApprovalForAll",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "data",
          type: "bytes",
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "palette",
          type: "bytes",
        },
        {
          indexed: false,
          internalType: "uint8",
          name: "version",
          type: "uint8",
        },
      ],
      name: "PixelChainCreated",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [],
      name: "baseURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getApproved",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
      ],
      name: "isApprovedForAll",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "ownerOf",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      name: "pixelChains",
      outputs: [
        {
          internalType: "string",
          name: "name",
          type: "string",
        },
        {
          internalType: "address",
          name: "author",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "blockNumber",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "bytes",
          name: "_data",
          type: "bytes",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "setApprovalForAll",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "bytes4",
          name: "interfaceId",
          type: "bytes4",
        },
      ],
      name: "supportsInterface",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenOfOwnerByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "tokenURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: "string",
              name: "name",
              type: "string",
            },
            {
              internalType: "bytes",
              name: "data",
              type: "bytes",
            },
            {
              internalType: "bytes",
              name: "palette",
              type: "bytes",
            },
            {
              internalType: "uint8",
              name: "version",
              type: "uint8",
            },
          ],
          internalType: "struct PixelChainMax.NewPixelChain",
          name: "_pixelChain",
          type: "tuple",
        },
      ],
      name: "create",
      outputs: [],
      stateMutability: "payable",
      type: "function",
      payable: true,
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "_start",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "_end",
          type: "uint256",
        },
      ],
      name: "retrieveAll",
      outputs: [
        {
          components: [
            {
              internalType: "string",
              name: "name",
              type: "string",
            },
            {
              internalType: "address",
              name: "author",
              type: "address",
            },
            {
              internalType: "uint256",
              name: "blockNumber",
              type: "uint256",
            },
          ],
          internalType: "struct PixelChainMax.PixelChain[]",
          name: "",
          type: "tuple[]",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "_id",
          type: "uint256",
        },
      ],
      name: "retrieve",
      outputs: [
        {
          components: [
            {
              internalType: "string",
              name: "name",
              type: "string",
            },
            {
              internalType: "address",
              name: "author",
              type: "address",
            },
            {
              internalType: "uint256",
              name: "blockNumber",
              type: "uint256",
            },
          ],
          internalType: "struct PixelChainMax.PixelChain",
          name: "",
          type: "tuple",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
    {
      inputs: [
        {
          internalType: "string",
          name: "_uri",
          type: "string",
        },
      ],
      name: "setBaseTokenURI",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "withdraw",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "_price",
          type: "uint256",
        },
      ],
      name: "setDefaultMintPrice",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint8",
          name: "_version",
          type: "uint8",
        },
        {
          internalType: "uint256",
          name: "_price",
          type: "uint256",
        },
      ],
      name: "setMintPricePerVersion",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_address",
          type: "address",
        },
      ],
      name: "addAddressToBlacklist",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_address",
          type: "address",
        },
      ],
      name: "removeAddressFromBlacklist",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_address",
          type: "address",
        },
      ],
      name: "addAddressToWhitelist",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_address",
          type: "address",
        },
      ],
      name: "removeAddressFromWhitelist",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint8",
          name: "_version",
          type: "uint8",
        },
      ],
      name: "addVersionToWhitelist",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint8",
          name: "_version",
          type: "uint8",
        },
      ],
      name: "removeVersionFromWhitelist",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "baseTokenURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
      constant: true,
    },
  ],
  metadata:
    '{"compiler":{"version":"0.7.5+commit.eb77ed08"},"language":"Solidity","output":{"abi":[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"bytes","name":"data","type":"bytes"},{"indexed":false,"internalType":"bytes","name":"palette","type":"bytes"},{"indexed":false,"internalType":"uint8","name":"version","type":"uint8"}],"name":"PixelChainCreated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"addAddressToBlacklist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"addAddressToWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint8","name":"_version","type":"uint8"}],"name":"addVersionToWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseTokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"bytes","name":"data","type":"bytes"},{"internalType":"bytes","name":"palette","type":"bytes"},{"internalType":"uint8","name":"version","type":"uint8"}],"internalType":"struct PixelChainMax.NewPixelChain","name":"_pixelChain","type":"tuple"}],"name":"create","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"pixelChains","outputs":[{"internalType":"string","name":"name","type":"string"},{"internalType":"address","name":"author","type":"address"},{"internalType":"uint256","name":"blockNumber","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"removeAddressFromBlacklist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"removeAddressFromWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint8","name":"_version","type":"uint8"}],"name":"removeVersionFromWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_id","type":"uint256"}],"name":"retrieve","outputs":[{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"address","name":"author","type":"address"},{"internalType":"uint256","name":"blockNumber","type":"uint256"}],"internalType":"struct PixelChainMax.PixelChain","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_start","type":"uint256"},{"internalType":"uint256","name":"_end","type":"uint256"}],"name":"retrieveAll","outputs":[{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"address","name":"author","type":"address"},{"internalType":"uint256","name":"blockNumber","type":"uint256"}],"internalType":"struct PixelChainMax.PixelChain[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_uri","type":"string"}],"name":"setBaseTokenURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_price","type":"uint256"}],"name":"setDefaultMintPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint8","name":"_version","type":"uint8"},{"internalType":"uint256","name":"_price","type":"uint256"}],"name":"setMintPricePerVersion","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}],"devdoc":{"kind":"dev","methods":{"approve(address,uint256)":{"details":"See {IERC721-approve}."},"balanceOf(address)":{"details":"See {IERC721-balanceOf}."},"baseURI()":{"details":"Returns the base URI set via {_setBaseURI}. This will be automatically added as a prefix in {tokenURI} to each token\'s URI, or to the token ID if no specific URI is set for that token ID."},"getApproved(uint256)":{"details":"See {IERC721-getApproved}."},"isApprovedForAll(address,address)":{"details":"See {IERC721-isApprovedForAll}."},"name()":{"details":"See {IERC721Metadata-name}."},"owner()":{"details":"Returns the address of the current owner."},"ownerOf(uint256)":{"details":"See {IERC721-ownerOf}."},"renounceOwnership()":{"details":"Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner."},"safeTransferFrom(address,address,uint256)":{"details":"See {IERC721-safeTransferFrom}."},"safeTransferFrom(address,address,uint256,bytes)":{"details":"See {IERC721-safeTransferFrom}."},"setApprovalForAll(address,bool)":{"details":"See {IERC721-setApprovalForAll}."},"supportsInterface(bytes4)":{"details":"See {IERC165-supportsInterface}. Time complexity O(1), guaranteed to always use less than 30 000 gas."},"symbol()":{"details":"See {IERC721Metadata-symbol}."},"tokenByIndex(uint256)":{"details":"See {IERC721Enumerable-tokenByIndex}."},"tokenOfOwnerByIndex(address,uint256)":{"details":"See {IERC721Enumerable-tokenOfOwnerByIndex}."},"tokenURI(uint256)":{"details":"See {IERC721Metadata-tokenURI}."},"totalSupply()":{"details":"See {IERC721Enumerable-totalSupply}."},"transferFrom(address,address,uint256)":{"details":"See {IERC721-transferFrom}."},"transferOwnership(address)":{"details":"Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner."}},"version":1},"userdoc":{"kind":"user","methods":{},"version":1}},"settings":{"compilationTarget":{"/home/nahuel/3dge/PixelChainMax-Contract/contracts/PixelChainMax.sol":"PixelChainMax"},"evmVersion":"istanbul","libraries":{},"metadata":{"bytecodeHash":"ipfs"},"optimizer":{"enabled":false,"runs":200},"remappings":[]},"sources":{"/home/nahuel/3dge/PixelChainMax-Contract/contracts/PixelChainMax.sol":{"keccak256":"0xc050813b5bcb311a5f8c8ea5c524463f72b0e2417874e8681910bb39f46367b1","license":"MIT","urls":["bzz-raw://3c11a3f4dec7f247b41fae55cf1db1cc1825b2688f89cebcac4a76afb6fb92f3","dweb:/ipfs/QmdiJsB9zbuBLZoUiWva6WeP3Rtz7tCbGGyye8U573iD2i"]},"@openzeppelin/contracts/GSN/Context.sol":{"keccak256":"0x910a2e625b71168563edf9eeef55a50d6d699acfe27ceba3921f291829a8f938","license":"MIT","urls":["bzz-raw://248246ac66e6479dce1ad7d4945ec5540c98ceb09881e93c93f7c48d5772925c","dweb:/ipfs/QmXr8tmUiZgEYid6ixeeBRmTdUnASWjKzhP3KRxMPy8fRt"]},"@openzeppelin/contracts/access/Ownable.sol":{"keccak256":"0x46d2453e9db55eae25c9abdae2c42229086c54f1a6a247e8ce32658bb785f6ae","license":"MIT","urls":["bzz-raw://198ef77ef5d9f7a7709d6bbfba1d4d54d82ccc15358e9dced37f1376dac887fa","dweb:/ipfs/QmQHFvCA74s3AHU3NMn4AAYzFTt6UotWq7yk3WzLQs1oJS"]},"@openzeppelin/contracts/introspection/ERC165.sol":{"keccak256":"0x79926f3bb41403a854bdc13f3f2a38d1345d7854a52b9a92ddd18c07fa688879","license":"MIT","urls":["bzz-raw://3ede10dc2139be174e1bf5c0126d51c8cc5ce2832bf5ce3ecf4aa669958528b2","dweb:/ipfs/QmPSZzxwc6YLgetK6fumhdfgR8K58XeFpw275m2vvMcbsy"]},"@openzeppelin/contracts/introspection/IERC165.sol":{"keccak256":"0xd2f30fad5b24c4120f96dbac83aacdb7993ee610a9092bc23c44463da292bf8d","license":"MIT","urls":["bzz-raw://e3d4e72409e392c7694b6405a0136cf073d8da016df33ef8f9ad195f724ebfea","dweb:/ipfs/QmPGcddKq6CgsiKnxUUif2q76wRqP3dmdQ6bKuHCLmb8Wa"]},"@openzeppelin/contracts/math/SafeMath.sol":{"keccak256":"0xba96bc371ba999f452985a98717cca1e4c4abb598dc038a9a9c3db08129b1ba4","license":"MIT","urls":["bzz-raw://26e50e3f7b6482fb6f598f2e006994a74aa492687daa4b3eee7fd4fb5398ce7f","dweb:/ipfs/QmZudqoPSkA4USLMFsBBmt19dDPZFS8aaAmL5R7pECXu6t"]},"@openzeppelin/contracts/token/ERC721/ERC721.sol":{"keccak256":"0x67716273a28145b606d139db21f98b9eceff1815be19cf5d461d20d180236b6e","license":"MIT","urls":["bzz-raw://fc8763d06bb85e1f9fec0f0e62a1a38128ebe26f7a5e7bad26b1ac54d1987b0f","dweb:/ipfs/QmUCi79A9N6SMTYbGAWKdCTWnArKzwoAC3d718f5utU9c3"]},"@openzeppelin/contracts/token/ERC721/IERC721.sol":{"keccak256":"0x5fd853592d6a9a1d1fdd6bd258098fb0f4632a32ea90f565661c9ba3191b5a1e","license":"MIT","urls":["bzz-raw://8b1ae36e53cab51ce9094557f8f759288768d2ae5fa117cb7ef1edf697cc7c85","dweb:/ipfs/QmS2cpinhv9DLtAQAwFpR5gTr3Q8mWwWu2t39RAzgQCkjY"]},"@openzeppelin/contracts/token/ERC721/IERC721Enumerable.sol":{"keccak256":"0x2789dfea2d73182683d637db5729201f6730dae6113030a94c828f8688f38f2f","license":"MIT","urls":["bzz-raw://36374eaa68c0737bf7e1ae13d55327b4868fb0825e971ee729f4b8d355ededb4","dweb:/ipfs/QmYN9yuzz4P5SumiT6rgYgTEY8MhnPQapMwx2LHxRKju7r"]},"@openzeppelin/contracts/token/ERC721/IERC721Metadata.sol":{"keccak256":"0xc82c7d1d732081d9bd23f1555ebdf8f3bc1738bc42c2bfc4b9aa7564d9fa3573","license":"MIT","urls":["bzz-raw://5cb07e4ff3352161510a0d1536fe93f3c62526358e073a8bab2a8abbb27d0da1","dweb:/ipfs/QmX7K1JjnWKT1JzZT92Qx5zNJQYbssE533TLFHP88hj2fb"]},"@openzeppelin/contracts/token/ERC721/IERC721Receiver.sol":{"keccak256":"0x07eeb4699ff35c761508ead6962f7cce3e297c243beb2896652ac5da6a8306b1","license":"MIT","urls":["bzz-raw://dba32efe3ecd273b58c009b1ab4fdb33d7fcd597e77ff2648a0630948257d24f","dweb:/ipfs/QmPtwp5ArRuzjnHJ1RpfE8DouB86E3hXthbk5ojLk3UhRF"]},"@openzeppelin/contracts/utils/Address.sol":{"keccak256":"0x698f929f1097637d051976b322a2d532c27df022b09010e8d091e2888a5ebdf8","license":"MIT","urls":["bzz-raw://4bd4c9419d1182612ef415c60a83a9039b227fccb799937963448114c0473b58","dweb:/ipfs/Qmat1U571v55F5JDDHHX7igGcmLF8Ehk9CzsWpjbdx3RTH"]},"@openzeppelin/contracts/utils/EnumerableMap.sol":{"keccak256":"0xf7d3b7568241563b988779a2d99351bfb87144ccc1554c92ce7f333d0d1443a3","license":"MIT","urls":["bzz-raw://b24c06a7849e33696e1725383edff80f795e121d96fb757344546a4c5337900b","dweb:/ipfs/QmSe1heSWs6hEJvgaaEEeoWkMrYSgn1YEVtb9qZWBpFUMp"]},"@openzeppelin/contracts/utils/EnumerableSet.sol":{"keccak256":"0x5420cb92cf72960b0be9dacec46b15a5558f89688d846cc6e53ec1c2d807f673","license":"MIT","urls":["bzz-raw://f6dd826d43bc5d033e6197236f8b55e56dfdda6d1a364f5ddfa79c134a664875","dweb:/ipfs/Qmcztt4dk38dzvUtDQoJrnWNvafotNRttyah1zRVmsNyB6"]},"@openzeppelin/contracts/utils/Strings.sol":{"keccak256":"0xb4866e6e88d0933a1043d55107736cc3fa1a3d57fc3aa76d140bff525fdd3568","license":"MIT","urls":["bzz-raw://7149f17b33870900cfdd73fa352a3f80396d773a53ce8d8460b8f2e5748ea5a2","dweb:/ipfs/QmdiUnEpKgeJPr5NBYVs77p1vanJbeF5SXajGwYi4Y5VAY"]}},"version":1}',
  bytecode:
    "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",
  deployedBytecode:
    "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",
  immutableReferences: {},
  generatedSources: [],
  deployedGeneratedSources: [
    {
      ast: {
        nodeType: "YulBlock",
        src: "0:21165:16",
        statements: [
          {
            body: {
              nodeType: "YulBlock",
              src: "59:87:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "69:29:16",
                  value: {
                    arguments: [
                      {
                        name: "offset",
                        nodeType: "YulIdentifier",
                        src: "91:6:16",
                      },
                    ],
                    functionName: {
                      name: "calldataload",
                      nodeType: "YulIdentifier",
                      src: "78:12:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "78:20:16",
                  },
                  variableNames: [
                    {
                      name: "value",
                      nodeType: "YulIdentifier",
                      src: "69:5:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "134:5:16",
                      },
                    ],
                    functionName: {
                      name: "validator_revert_t_address",
                      nodeType: "YulIdentifier",
                      src: "107:26:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "107:33:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "107:33:16",
                },
              ],
            },
            name: "abi_decode_t_address",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "offset",
                nodeType: "YulTypedName",
                src: "37:6:16",
                type: "",
              },
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "45:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "53:5:16",
                type: "",
              },
            ],
            src: "7:139:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "201:84:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "211:29:16",
                  value: {
                    arguments: [
                      {
                        name: "offset",
                        nodeType: "YulIdentifier",
                        src: "233:6:16",
                      },
                    ],
                    functionName: {
                      name: "calldataload",
                      nodeType: "YulIdentifier",
                      src: "220:12:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "220:20:16",
                  },
                  variableNames: [
                    {
                      name: "value",
                      nodeType: "YulIdentifier",
                      src: "211:5:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "273:5:16",
                      },
                    ],
                    functionName: {
                      name: "validator_revert_t_bool",
                      nodeType: "YulIdentifier",
                      src: "249:23:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "249:30:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "249:30:16",
                },
              ],
            },
            name: "abi_decode_t_bool",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "offset",
                nodeType: "YulTypedName",
                src: "179:6:16",
                type: "",
              },
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "187:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "195:5:16",
                type: "",
              },
            ],
            src: "152:133:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "342:86:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "352:29:16",
                  value: {
                    arguments: [
                      {
                        name: "offset",
                        nodeType: "YulIdentifier",
                        src: "374:6:16",
                      },
                    ],
                    functionName: {
                      name: "calldataload",
                      nodeType: "YulIdentifier",
                      src: "361:12:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "361:20:16",
                  },
                  variableNames: [
                    {
                      name: "value",
                      nodeType: "YulIdentifier",
                      src: "352:5:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "416:5:16",
                      },
                    ],
                    functionName: {
                      name: "validator_revert_t_bytes4",
                      nodeType: "YulIdentifier",
                      src: "390:25:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "390:32:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "390:32:16",
                },
              ],
            },
            name: "abi_decode_t_bytes4",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "offset",
                nodeType: "YulTypedName",
                src: "320:6:16",
                type: "",
              },
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "328:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "336:5:16",
                type: "",
              },
            ],
            src: "291:137:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "495:403:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "544:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "553:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "556:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "546:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "546:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "546:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "523:6:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "531:4:16",
                                type: "",
                                value: "0x1f",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "519:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "519:17:16",
                          },
                          {
                            name: "end",
                            nodeType: "YulIdentifier",
                            src: "538:3:16",
                          },
                        ],
                        functionName: {
                          name: "slt",
                          nodeType: "YulIdentifier",
                          src: "515:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "515:27:16",
                      },
                    ],
                    functionName: {
                      name: "iszero",
                      nodeType: "YulIdentifier",
                      src: "508:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "508:35:16",
                  },
                  nodeType: "YulIf",
                  src: "505:2:16",
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "569:34:16",
                  value: {
                    arguments: [
                      {
                        name: "offset",
                        nodeType: "YulIdentifier",
                        src: "596:6:16",
                      },
                    ],
                    functionName: {
                      name: "calldataload",
                      nodeType: "YulIdentifier",
                      src: "583:12:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "583:20:16",
                  },
                  variables: [
                    {
                      name: "length",
                      nodeType: "YulTypedName",
                      src: "573:6:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "612:73:16",
                  value: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "677:6:16",
                          },
                        ],
                        functionName: {
                          name: "array_allocation_size_t_bytes_memory_ptr",
                          nodeType: "YulIdentifier",
                          src: "636:40:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "636:48:16",
                      },
                    ],
                    functionName: {
                      name: "allocateMemory",
                      nodeType: "YulIdentifier",
                      src: "621:14:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "621:64:16",
                  },
                  variableNames: [
                    {
                      name: "array",
                      nodeType: "YulIdentifier",
                      src: "612:5:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "array",
                        nodeType: "YulIdentifier",
                        src: "701:5:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "708:6:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "694:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "694:21:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "694:21:16",
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "724:28:16",
                  value: {
                    arguments: [
                      {
                        name: "offset",
                        nodeType: "YulIdentifier",
                        src: "739:6:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "747:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "735:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "735:17:16",
                  },
                  variables: [
                    {
                      name: "src",
                      nodeType: "YulTypedName",
                      src: "728:3:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "761:27:16",
                  value: {
                    arguments: [
                      {
                        name: "array",
                        nodeType: "YulIdentifier",
                        src: "776:5:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "783:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "772:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "772:16:16",
                  },
                  variables: [
                    {
                      name: "dst",
                      nodeType: "YulTypedName",
                      src: "765:3:16",
                      type: "",
                    },
                  ],
                },
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "826:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "835:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "838:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "828:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "828:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "828:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "src",
                            nodeType: "YulIdentifier",
                            src: "807:3:16",
                          },
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "812:6:16",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "803:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "803:16:16",
                      },
                      {
                        name: "end",
                        nodeType: "YulIdentifier",
                        src: "821:3:16",
                      },
                    ],
                    functionName: {
                      name: "gt",
                      nodeType: "YulIdentifier",
                      src: "800:2:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "800:25:16",
                  },
                  nodeType: "YulIf",
                  src: "797:2:16",
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "src",
                        nodeType: "YulIdentifier",
                        src: "875:3:16",
                      },
                      {
                        name: "dst",
                        nodeType: "YulIdentifier",
                        src: "880:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "885:6:16",
                      },
                    ],
                    functionName: {
                      name: "copy_calldata_to_memory",
                      nodeType: "YulIdentifier",
                      src: "851:23:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "851:41:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "851:41:16",
                },
              ],
            },
            name: "abi_decode_t_bytes_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "offset",
                nodeType: "YulTypedName",
                src: "473:6:16",
                type: "",
              },
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "481:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "array",
                nodeType: "YulTypedName",
                src: "489:5:16",
                type: "",
              },
            ],
            src: "434:464:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "966:404:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "1015:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "1024:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "1027:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "1017:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "1017:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "1017:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "994:6:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "1002:4:16",
                                type: "",
                                value: "0x1f",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "990:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "990:17:16",
                          },
                          {
                            name: "end",
                            nodeType: "YulIdentifier",
                            src: "1009:3:16",
                          },
                        ],
                        functionName: {
                          name: "slt",
                          nodeType: "YulIdentifier",
                          src: "986:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "986:27:16",
                      },
                    ],
                    functionName: {
                      name: "iszero",
                      nodeType: "YulIdentifier",
                      src: "979:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "979:35:16",
                  },
                  nodeType: "YulIf",
                  src: "976:2:16",
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "1040:34:16",
                  value: {
                    arguments: [
                      {
                        name: "offset",
                        nodeType: "YulIdentifier",
                        src: "1067:6:16",
                      },
                    ],
                    functionName: {
                      name: "calldataload",
                      nodeType: "YulIdentifier",
                      src: "1054:12:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "1054:20:16",
                  },
                  variables: [
                    {
                      name: "length",
                      nodeType: "YulTypedName",
                      src: "1044:6:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "1083:74:16",
                  value: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "1149:6:16",
                          },
                        ],
                        functionName: {
                          name: "array_allocation_size_t_string_memory_ptr",
                          nodeType: "YulIdentifier",
                          src: "1107:41:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "1107:49:16",
                      },
                    ],
                    functionName: {
                      name: "allocateMemory",
                      nodeType: "YulIdentifier",
                      src: "1092:14:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "1092:65:16",
                  },
                  variableNames: [
                    {
                      name: "array",
                      nodeType: "YulIdentifier",
                      src: "1083:5:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "array",
                        nodeType: "YulIdentifier",
                        src: "1173:5:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "1180:6:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "1166:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "1166:21:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "1166:21:16",
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "1196:28:16",
                  value: {
                    arguments: [
                      {
                        name: "offset",
                        nodeType: "YulIdentifier",
                        src: "1211:6:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "1219:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "1207:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "1207:17:16",
                  },
                  variables: [
                    {
                      name: "src",
                      nodeType: "YulTypedName",
                      src: "1200:3:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "1233:27:16",
                  value: {
                    arguments: [
                      {
                        name: "array",
                        nodeType: "YulIdentifier",
                        src: "1248:5:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "1255:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "1244:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "1244:16:16",
                  },
                  variables: [
                    {
                      name: "dst",
                      nodeType: "YulTypedName",
                      src: "1237:3:16",
                      type: "",
                    },
                  ],
                },
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "1298:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "1307:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "1310:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "1300:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "1300:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "1300:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "src",
                            nodeType: "YulIdentifier",
                            src: "1279:3:16",
                          },
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "1284:6:16",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "1275:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "1275:16:16",
                      },
                      {
                        name: "end",
                        nodeType: "YulIdentifier",
                        src: "1293:3:16",
                      },
                    ],
                    functionName: {
                      name: "gt",
                      nodeType: "YulIdentifier",
                      src: "1272:2:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "1272:25:16",
                  },
                  nodeType: "YulIf",
                  src: "1269:2:16",
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "src",
                        nodeType: "YulIdentifier",
                        src: "1347:3:16",
                      },
                      {
                        name: "dst",
                        nodeType: "YulIdentifier",
                        src: "1352:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "1357:6:16",
                      },
                    ],
                    functionName: {
                      name: "copy_calldata_to_memory",
                      nodeType: "YulIdentifier",
                      src: "1323:23:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "1323:41:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "1323:41:16",
                },
              ],
            },
            name: "abi_decode_t_string_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "offset",
                nodeType: "YulTypedName",
                src: "944:6:16",
                type: "",
              },
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "952:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "array",
                nodeType: "YulTypedName",
                src: "960:5:16",
                type: "",
              },
            ],
            src: "904:466:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "1502:1055:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "1546:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "1555:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "1558:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "1548:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "1548:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "1548:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "end",
                            nodeType: "YulIdentifier",
                            src: "1523:3:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "1528:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "1519:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "1519:19:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "1540:4:16",
                        type: "",
                        value: "0x80",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "1515:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "1515:30:16",
                  },
                  nodeType: "YulIf",
                  src: "1512:2:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "1571:29:16",
                  value: {
                    arguments: [
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "1595:4:16",
                        type: "",
                        value: "0x80",
                      },
                    ],
                    functionName: {
                      name: "allocateMemory",
                      nodeType: "YulIdentifier",
                      src: "1580:14:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "1580:20:16",
                  },
                  variableNames: [
                    {
                      name: "value",
                      nodeType: "YulIdentifier",
                      src: "1571:5:16",
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "1610:252:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "1645:45:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "1676:9:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "1687:1:16",
                                type: "",
                                value: "0",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "1672:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "1672:17:16",
                          },
                        ],
                        functionName: {
                          name: "calldataload",
                          nodeType: "YulIdentifier",
                          src: "1659:12:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "1659:31:16",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "1649:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      body: {
                        nodeType: "YulBlock",
                        src: "1737:16:16",
                        statements: [
                          {
                            expression: {
                              arguments: [
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "1746:1:16",
                                  type: "",
                                  value: "0",
                                },
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "1749:1:16",
                                  type: "",
                                  value: "0",
                                },
                              ],
                              functionName: {
                                name: "revert",
                                nodeType: "YulIdentifier",
                                src: "1739:6:16",
                              },
                              nodeType: "YulFunctionCall",
                              src: "1739:12:16",
                            },
                            nodeType: "YulExpressionStatement",
                            src: "1739:12:16",
                          },
                        ],
                      },
                      condition: {
                        arguments: [
                          {
                            name: "offset",
                            nodeType: "YulIdentifier",
                            src: "1709:6:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "1717:18:16",
                            type: "",
                            value: "0xffffffffffffffff",
                          },
                        ],
                        functionName: {
                          name: "gt",
                          nodeType: "YulIdentifier",
                          src: "1706:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "1706:30:16",
                      },
                      nodeType: "YulIf",
                      src: "1703:2:16",
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "1777:5:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "1784:4:16",
                                type: "",
                                value: "0x00",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "1773:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "1773:16:16",
                          },
                          {
                            arguments: [
                              {
                                arguments: [
                                  {
                                    name: "headStart",
                                    nodeType: "YulIdentifier",
                                    src: "1826:9:16",
                                  },
                                  {
                                    name: "offset",
                                    nodeType: "YulIdentifier",
                                    src: "1837:6:16",
                                  },
                                ],
                                functionName: {
                                  name: "add",
                                  nodeType: "YulIdentifier",
                                  src: "1822:3:16",
                                },
                                nodeType: "YulFunctionCall",
                                src: "1822:22:16",
                              },
                              {
                                name: "end",
                                nodeType: "YulIdentifier",
                                src: "1846:3:16",
                              },
                            ],
                            functionName: {
                              name: "abi_decode_t_string_memory_ptr",
                              nodeType: "YulIdentifier",
                              src: "1791:30:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "1791:59:16",
                          },
                        ],
                        functionName: {
                          name: "mstore",
                          nodeType: "YulIdentifier",
                          src: "1766:6:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "1766:85:16",
                      },
                      nodeType: "YulExpressionStatement",
                      src: "1766:85:16",
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "1872:252:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "1907:46:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "1938:9:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "1949:2:16",
                                type: "",
                                value: "32",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "1934:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "1934:18:16",
                          },
                        ],
                        functionName: {
                          name: "calldataload",
                          nodeType: "YulIdentifier",
                          src: "1921:12:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "1921:32:16",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "1911:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      body: {
                        nodeType: "YulBlock",
                        src: "2000:16:16",
                        statements: [
                          {
                            expression: {
                              arguments: [
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "2009:1:16",
                                  type: "",
                                  value: "0",
                                },
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "2012:1:16",
                                  type: "",
                                  value: "0",
                                },
                              ],
                              functionName: {
                                name: "revert",
                                nodeType: "YulIdentifier",
                                src: "2002:6:16",
                              },
                              nodeType: "YulFunctionCall",
                              src: "2002:12:16",
                            },
                            nodeType: "YulExpressionStatement",
                            src: "2002:12:16",
                          },
                        ],
                      },
                      condition: {
                        arguments: [
                          {
                            name: "offset",
                            nodeType: "YulIdentifier",
                            src: "1972:6:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "1980:18:16",
                            type: "",
                            value: "0xffffffffffffffff",
                          },
                        ],
                        functionName: {
                          name: "gt",
                          nodeType: "YulIdentifier",
                          src: "1969:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "1969:30:16",
                      },
                      nodeType: "YulIf",
                      src: "1966:2:16",
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "2040:5:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "2047:4:16",
                                type: "",
                                value: "0x20",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "2036:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "2036:16:16",
                          },
                          {
                            arguments: [
                              {
                                arguments: [
                                  {
                                    name: "headStart",
                                    nodeType: "YulIdentifier",
                                    src: "2088:9:16",
                                  },
                                  {
                                    name: "offset",
                                    nodeType: "YulIdentifier",
                                    src: "2099:6:16",
                                  },
                                ],
                                functionName: {
                                  name: "add",
                                  nodeType: "YulIdentifier",
                                  src: "2084:3:16",
                                },
                                nodeType: "YulFunctionCall",
                                src: "2084:22:16",
                              },
                              {
                                name: "end",
                                nodeType: "YulIdentifier",
                                src: "2108:3:16",
                              },
                            ],
                            functionName: {
                              name: "abi_decode_t_bytes_memory_ptr",
                              nodeType: "YulIdentifier",
                              src: "2054:29:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "2054:58:16",
                          },
                        ],
                        functionName: {
                          name: "mstore",
                          nodeType: "YulIdentifier",
                          src: "2029:6:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "2029:84:16",
                      },
                      nodeType: "YulExpressionStatement",
                      src: "2029:84:16",
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "2134:255:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "2172:46:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "2203:9:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "2214:2:16",
                                type: "",
                                value: "64",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "2199:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "2199:18:16",
                          },
                        ],
                        functionName: {
                          name: "calldataload",
                          nodeType: "YulIdentifier",
                          src: "2186:12:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "2186:32:16",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "2176:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      body: {
                        nodeType: "YulBlock",
                        src: "2265:16:16",
                        statements: [
                          {
                            expression: {
                              arguments: [
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "2274:1:16",
                                  type: "",
                                  value: "0",
                                },
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "2277:1:16",
                                  type: "",
                                  value: "0",
                                },
                              ],
                              functionName: {
                                name: "revert",
                                nodeType: "YulIdentifier",
                                src: "2267:6:16",
                              },
                              nodeType: "YulFunctionCall",
                              src: "2267:12:16",
                            },
                            nodeType: "YulExpressionStatement",
                            src: "2267:12:16",
                          },
                        ],
                      },
                      condition: {
                        arguments: [
                          {
                            name: "offset",
                            nodeType: "YulIdentifier",
                            src: "2237:6:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "2245:18:16",
                            type: "",
                            value: "0xffffffffffffffff",
                          },
                        ],
                        functionName: {
                          name: "gt",
                          nodeType: "YulIdentifier",
                          src: "2234:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "2234:30:16",
                      },
                      nodeType: "YulIf",
                      src: "2231:2:16",
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "2305:5:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "2312:4:16",
                                type: "",
                                value: "0x40",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "2301:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "2301:16:16",
                          },
                          {
                            arguments: [
                              {
                                arguments: [
                                  {
                                    name: "headStart",
                                    nodeType: "YulIdentifier",
                                    src: "2353:9:16",
                                  },
                                  {
                                    name: "offset",
                                    nodeType: "YulIdentifier",
                                    src: "2364:6:16",
                                  },
                                ],
                                functionName: {
                                  name: "add",
                                  nodeType: "YulIdentifier",
                                  src: "2349:3:16",
                                },
                                nodeType: "YulFunctionCall",
                                src: "2349:22:16",
                              },
                              {
                                name: "end",
                                nodeType: "YulIdentifier",
                                src: "2373:3:16",
                              },
                            ],
                            functionName: {
                              name: "abi_decode_t_bytes_memory_ptr",
                              nodeType: "YulIdentifier",
                              src: "2319:29:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "2319:58:16",
                          },
                        ],
                        functionName: {
                          name: "mstore",
                          nodeType: "YulIdentifier",
                          src: "2294:6:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "2294:84:16",
                      },
                      nodeType: "YulExpressionStatement",
                      src: "2294:84:16",
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "2399:151:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "2437:16:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "2451:2:16",
                        type: "",
                        value: "96",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "2441:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "2477:5:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "2484:4:16",
                                type: "",
                                value: "0x60",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "2473:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "2473:16:16",
                          },
                          {
                            arguments: [
                              {
                                arguments: [
                                  {
                                    name: "headStart",
                                    nodeType: "YulIdentifier",
                                    src: "2514:9:16",
                                  },
                                  {
                                    name: "offset",
                                    nodeType: "YulIdentifier",
                                    src: "2525:6:16",
                                  },
                                ],
                                functionName: {
                                  name: "add",
                                  nodeType: "YulIdentifier",
                                  src: "2510:3:16",
                                },
                                nodeType: "YulFunctionCall",
                                src: "2510:22:16",
                              },
                              {
                                name: "end",
                                nodeType: "YulIdentifier",
                                src: "2534:3:16",
                              },
                            ],
                            functionName: {
                              name: "abi_decode_t_uint8",
                              nodeType: "YulIdentifier",
                              src: "2491:18:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "2491:47:16",
                          },
                        ],
                        functionName: {
                          name: "mstore",
                          nodeType: "YulIdentifier",
                          src: "2466:6:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "2466:73:16",
                      },
                      nodeType: "YulExpressionStatement",
                      src: "2466:73:16",
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_t_struct$_NewPixelChain_$67_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "1477:9:16",
                type: "",
              },
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "1488:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "1496:5:16",
                type: "",
              },
            ],
            src: "1418:1139:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "2615:87:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "2625:29:16",
                  value: {
                    arguments: [
                      {
                        name: "offset",
                        nodeType: "YulIdentifier",
                        src: "2647:6:16",
                      },
                    ],
                    functionName: {
                      name: "calldataload",
                      nodeType: "YulIdentifier",
                      src: "2634:12:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "2634:20:16",
                  },
                  variableNames: [
                    {
                      name: "value",
                      nodeType: "YulIdentifier",
                      src: "2625:5:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "2690:5:16",
                      },
                    ],
                    functionName: {
                      name: "validator_revert_t_uint256",
                      nodeType: "YulIdentifier",
                      src: "2663:26:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "2663:33:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "2663:33:16",
                },
              ],
            },
            name: "abi_decode_t_uint256",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "offset",
                nodeType: "YulTypedName",
                src: "2593:6:16",
                type: "",
              },
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "2601:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "2609:5:16",
                type: "",
              },
            ],
            src: "2563:139:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "2758:85:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "2768:29:16",
                  value: {
                    arguments: [
                      {
                        name: "offset",
                        nodeType: "YulIdentifier",
                        src: "2790:6:16",
                      },
                    ],
                    functionName: {
                      name: "calldataload",
                      nodeType: "YulIdentifier",
                      src: "2777:12:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "2777:20:16",
                  },
                  variableNames: [
                    {
                      name: "value",
                      nodeType: "YulIdentifier",
                      src: "2768:5:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "2831:5:16",
                      },
                    ],
                    functionName: {
                      name: "validator_revert_t_uint8",
                      nodeType: "YulIdentifier",
                      src: "2806:24:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "2806:31:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "2806:31:16",
                },
              ],
            },
            name: "abi_decode_t_uint8",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "offset",
                nodeType: "YulTypedName",
                src: "2736:6:16",
                type: "",
              },
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "2744:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "2752:5:16",
                type: "",
              },
            ],
            src: "2708:135:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "2915:194:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "2961:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "2970:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "2973:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "2963:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "2963:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "2963:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "2936:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "2945:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "2932:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "2932:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "2957:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "2928:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "2928:32:16",
                  },
                  nodeType: "YulIf",
                  src: "2925:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "2987:115:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "3001:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "3015:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "3005:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "3029:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "3064:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "3075:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "3060:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "3060:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "3084:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_address",
                          nodeType: "YulIdentifier",
                          src: "3039:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "3039:53:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "3029:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_address",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "2885:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "2896:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "2908:6:16",
                type: "",
              },
            ],
            src: "2849:260:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "3198:320:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "3244:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "3253:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "3256:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "3246:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "3246:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "3246:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "3219:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "3228:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "3215:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "3215:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "3240:2:16",
                        type: "",
                        value: "64",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "3211:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "3211:32:16",
                  },
                  nodeType: "YulIf",
                  src: "3208:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "3270:115:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "3284:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "3298:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "3288:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "3312:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "3347:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "3358:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "3343:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "3343:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "3367:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_address",
                          nodeType: "YulIdentifier",
                          src: "3322:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "3322:53:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "3312:6:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "3395:116:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "3409:16:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "3423:2:16",
                        type: "",
                        value: "32",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "3413:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "3438:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "3473:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "3484:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "3469:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "3469:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "3493:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_address",
                          nodeType: "YulIdentifier",
                          src: "3448:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "3448:53:16",
                      },
                      variableNames: [
                        {
                          name: "value1",
                          nodeType: "YulIdentifier",
                          src: "3438:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_addresst_address",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "3160:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "3171:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "3183:6:16",
                type: "",
              },
              {
                name: "value1",
                nodeType: "YulTypedName",
                src: "3191:6:16",
                type: "",
              },
            ],
            src: "3115:403:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "3624:446:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "3670:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "3679:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "3682:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "3672:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "3672:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "3672:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "3645:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "3654:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "3641:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "3641:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "3666:2:16",
                        type: "",
                        value: "96",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "3637:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "3637:32:16",
                  },
                  nodeType: "YulIf",
                  src: "3634:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "3696:115:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "3710:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "3724:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "3714:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "3738:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "3773:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "3784:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "3769:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "3769:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "3793:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_address",
                          nodeType: "YulIdentifier",
                          src: "3748:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "3748:53:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "3738:6:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "3821:116:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "3835:16:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "3849:2:16",
                        type: "",
                        value: "32",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "3839:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "3864:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "3899:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "3910:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "3895:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "3895:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "3919:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_address",
                          nodeType: "YulIdentifier",
                          src: "3874:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "3874:53:16",
                      },
                      variableNames: [
                        {
                          name: "value1",
                          nodeType: "YulIdentifier",
                          src: "3864:6:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "3947:116:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "3961:16:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "3975:2:16",
                        type: "",
                        value: "64",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "3965:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "3990:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "4025:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "4036:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "4021:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "4021:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "4045:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "4000:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "4000:53:16",
                      },
                      variableNames: [
                        {
                          name: "value2",
                          nodeType: "YulIdentifier",
                          src: "3990:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_addresst_addresst_uint256",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "3578:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "3589:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "3601:6:16",
                type: "",
              },
              {
                name: "value1",
                nodeType: "YulTypedName",
                src: "3609:6:16",
                type: "",
              },
              {
                name: "value2",
                nodeType: "YulTypedName",
                src: "3617:6:16",
                type: "",
              },
            ],
            src: "3524:546:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "4202:675:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "4249:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "4258:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "4261:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "4251:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "4251:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "4251:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "4223:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "4232:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "4219:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "4219:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "4244:3:16",
                        type: "",
                        value: "128",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "4215:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "4215:33:16",
                  },
                  nodeType: "YulIf",
                  src: "4212:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "4275:115:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "4289:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "4303:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "4293:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "4317:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "4352:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "4363:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "4348:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "4348:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "4372:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_address",
                          nodeType: "YulIdentifier",
                          src: "4327:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "4327:53:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "4317:6:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "4400:116:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "4414:16:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "4428:2:16",
                        type: "",
                        value: "32",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "4418:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "4443:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "4478:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "4489:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "4474:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "4474:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "4498:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_address",
                          nodeType: "YulIdentifier",
                          src: "4453:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "4453:53:16",
                      },
                      variableNames: [
                        {
                          name: "value1",
                          nodeType: "YulIdentifier",
                          src: "4443:6:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "4526:116:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "4540:16:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "4554:2:16",
                        type: "",
                        value: "64",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "4544:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "4569:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "4604:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "4615:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "4600:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "4600:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "4624:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "4579:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "4579:53:16",
                      },
                      variableNames: [
                        {
                          name: "value2",
                          nodeType: "YulIdentifier",
                          src: "4569:6:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "4652:218:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "4666:46:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "4697:9:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "4708:2:16",
                                type: "",
                                value: "96",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "4693:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "4693:18:16",
                          },
                        ],
                        functionName: {
                          name: "calldataload",
                          nodeType: "YulIdentifier",
                          src: "4680:12:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "4680:32:16",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "4670:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      body: {
                        nodeType: "YulBlock",
                        src: "4759:16:16",
                        statements: [
                          {
                            expression: {
                              arguments: [
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "4768:1:16",
                                  type: "",
                                  value: "0",
                                },
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "4771:1:16",
                                  type: "",
                                  value: "0",
                                },
                              ],
                              functionName: {
                                name: "revert",
                                nodeType: "YulIdentifier",
                                src: "4761:6:16",
                              },
                              nodeType: "YulFunctionCall",
                              src: "4761:12:16",
                            },
                            nodeType: "YulExpressionStatement",
                            src: "4761:12:16",
                          },
                        ],
                      },
                      condition: {
                        arguments: [
                          {
                            name: "offset",
                            nodeType: "YulIdentifier",
                            src: "4731:6:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "4739:18:16",
                            type: "",
                            value: "0xffffffffffffffff",
                          },
                        ],
                        functionName: {
                          name: "gt",
                          nodeType: "YulIdentifier",
                          src: "4728:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "4728:30:16",
                      },
                      nodeType: "YulIf",
                      src: "4725:2:16",
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "4788:72:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "4832:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "4843:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "4828:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "4828:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "4852:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_bytes_memory_ptr",
                          nodeType: "YulIdentifier",
                          src: "4798:29:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "4798:62:16",
                      },
                      variableNames: [
                        {
                          name: "value3",
                          nodeType: "YulIdentifier",
                          src: "4788:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_addresst_addresst_uint256t_bytes_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "4148:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "4159:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "4171:6:16",
                type: "",
              },
              {
                name: "value1",
                nodeType: "YulTypedName",
                src: "4179:6:16",
                type: "",
              },
              {
                name: "value2",
                nodeType: "YulTypedName",
                src: "4187:6:16",
                type: "",
              },
              {
                name: "value3",
                nodeType: "YulTypedName",
                src: "4195:6:16",
                type: "",
              },
            ],
            src: "4076:801:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "4963:317:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "5009:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "5018:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "5021:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "5011:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "5011:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "5011:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "4984:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "4993:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "4980:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "4980:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "5005:2:16",
                        type: "",
                        value: "64",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "4976:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "4976:32:16",
                  },
                  nodeType: "YulIf",
                  src: "4973:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "5035:115:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "5049:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "5063:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "5053:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "5077:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "5112:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "5123:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "5108:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "5108:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "5132:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_address",
                          nodeType: "YulIdentifier",
                          src: "5087:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "5087:53:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "5077:6:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "5160:113:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "5174:16:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "5188:2:16",
                        type: "",
                        value: "32",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "5178:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "5203:60:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "5235:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "5246:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "5231:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "5231:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "5255:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_bool",
                          nodeType: "YulIdentifier",
                          src: "5213:17:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "5213:50:16",
                      },
                      variableNames: [
                        {
                          name: "value1",
                          nodeType: "YulIdentifier",
                          src: "5203:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_addresst_bool",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "4925:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "4936:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "4948:6:16",
                type: "",
              },
              {
                name: "value1",
                nodeType: "YulTypedName",
                src: "4956:6:16",
                type: "",
              },
            ],
            src: "4883:397:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "5369:320:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "5415:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "5424:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "5427:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "5417:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "5417:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "5417:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "5390:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "5399:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "5386:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "5386:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "5411:2:16",
                        type: "",
                        value: "64",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "5382:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "5382:32:16",
                  },
                  nodeType: "YulIf",
                  src: "5379:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "5441:115:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "5455:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "5469:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "5459:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "5483:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "5518:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "5529:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "5514:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "5514:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "5538:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_address",
                          nodeType: "YulIdentifier",
                          src: "5493:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "5493:53:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "5483:6:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "5566:116:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "5580:16:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "5594:2:16",
                        type: "",
                        value: "32",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "5584:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "5609:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "5644:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "5655:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "5640:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "5640:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "5664:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "5619:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "5619:53:16",
                      },
                      variableNames: [
                        {
                          name: "value1",
                          nodeType: "YulIdentifier",
                          src: "5609:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_addresst_uint256",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "5331:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "5342:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "5354:6:16",
                type: "",
              },
              {
                name: "value1",
                nodeType: "YulTypedName",
                src: "5362:6:16",
                type: "",
              },
            ],
            src: "5286:403:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "5760:193:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "5806:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "5815:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "5818:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "5808:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "5808:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "5808:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "5781:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "5790:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "5777:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "5777:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "5802:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "5773:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "5773:32:16",
                  },
                  nodeType: "YulIf",
                  src: "5770:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "5832:114:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "5846:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "5860:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "5850:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "5874:62:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "5908:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "5919:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "5904:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "5904:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "5928:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_bytes4",
                          nodeType: "YulIdentifier",
                          src: "5884:19:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "5884:52:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "5874:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_bytes4",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "5730:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "5741:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "5753:6:16",
                type: "",
              },
            ],
            src: "5695:258:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "6035:297:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "6081:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "6090:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "6093:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "6083:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "6083:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "6083:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "6056:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "6065:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "6052:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "6052:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "6077:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "6048:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "6048:32:16",
                  },
                  nodeType: "YulIf",
                  src: "6045:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "6107:218:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "6121:45:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "6152:9:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "6163:1:16",
                                type: "",
                                value: "0",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "6148:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "6148:17:16",
                          },
                        ],
                        functionName: {
                          name: "calldataload",
                          nodeType: "YulIdentifier",
                          src: "6135:12:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "6135:31:16",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "6125:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      body: {
                        nodeType: "YulBlock",
                        src: "6213:16:16",
                        statements: [
                          {
                            expression: {
                              arguments: [
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "6222:1:16",
                                  type: "",
                                  value: "0",
                                },
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "6225:1:16",
                                  type: "",
                                  value: "0",
                                },
                              ],
                              functionName: {
                                name: "revert",
                                nodeType: "YulIdentifier",
                                src: "6215:6:16",
                              },
                              nodeType: "YulFunctionCall",
                              src: "6215:12:16",
                            },
                            nodeType: "YulExpressionStatement",
                            src: "6215:12:16",
                          },
                        ],
                      },
                      condition: {
                        arguments: [
                          {
                            name: "offset",
                            nodeType: "YulIdentifier",
                            src: "6185:6:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "6193:18:16",
                            type: "",
                            value: "0xffffffffffffffff",
                          },
                        ],
                        functionName: {
                          name: "gt",
                          nodeType: "YulIdentifier",
                          src: "6182:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "6182:30:16",
                      },
                      nodeType: "YulIf",
                      src: "6179:2:16",
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "6242:73:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "6287:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "6298:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "6283:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "6283:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "6307:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_string_memory_ptr",
                          nodeType: "YulIdentifier",
                          src: "6252:30:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "6252:63:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "6242:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_string_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "6005:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "6016:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "6028:6:16",
                type: "",
              },
            ],
            src: "5959:373:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "6433:316:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "6479:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "6488:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "6491:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "6481:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "6481:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "6481:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "6454:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "6463:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "6450:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "6450:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "6475:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "6446:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "6446:32:16",
                  },
                  nodeType: "YulIf",
                  src: "6443:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "6505:237:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "6519:45:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "6550:9:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "6561:1:16",
                                type: "",
                                value: "0",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "6546:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "6546:17:16",
                          },
                        ],
                        functionName: {
                          name: "calldataload",
                          nodeType: "YulIdentifier",
                          src: "6533:12:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "6533:31:16",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "6523:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      body: {
                        nodeType: "YulBlock",
                        src: "6611:16:16",
                        statements: [
                          {
                            expression: {
                              arguments: [
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "6620:1:16",
                                  type: "",
                                  value: "0",
                                },
                                {
                                  kind: "number",
                                  nodeType: "YulLiteral",
                                  src: "6623:1:16",
                                  type: "",
                                  value: "0",
                                },
                              ],
                              functionName: {
                                name: "revert",
                                nodeType: "YulIdentifier",
                                src: "6613:6:16",
                              },
                              nodeType: "YulFunctionCall",
                              src: "6613:12:16",
                            },
                            nodeType: "YulExpressionStatement",
                            src: "6613:12:16",
                          },
                        ],
                      },
                      condition: {
                        arguments: [
                          {
                            name: "offset",
                            nodeType: "YulIdentifier",
                            src: "6583:6:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "6591:18:16",
                            type: "",
                            value: "0xffffffffffffffff",
                          },
                        ],
                        functionName: {
                          name: "gt",
                          nodeType: "YulIdentifier",
                          src: "6580:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "6580:30:16",
                      },
                      nodeType: "YulIf",
                      src: "6577:2:16",
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "6640:92:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "6704:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "6715:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "6700:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "6700:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "6724:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_struct$_NewPixelChain_$67_memory_ptr",
                          nodeType: "YulIdentifier",
                          src: "6650:49:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "6650:82:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "6640:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_struct$_NewPixelChain_$67_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "6403:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "6414:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "6426:6:16",
                type: "",
              },
            ],
            src: "6338:411:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "6821:194:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "6867:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "6876:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "6879:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "6869:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "6869:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "6869:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "6842:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "6851:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "6838:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "6838:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "6863:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "6834:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "6834:32:16",
                  },
                  nodeType: "YulIf",
                  src: "6831:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "6893:115:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "6907:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "6921:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "6911:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "6935:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "6970:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "6981:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "6966:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "6966:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "6990:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "6945:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "6945:53:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "6935:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_uint256",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "6791:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "6802:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "6814:6:16",
                type: "",
              },
            ],
            src: "6755:260:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "7104:320:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "7150:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "7159:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "7162:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "7152:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "7152:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "7152:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "7125:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "7134:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "7121:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "7121:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "7146:2:16",
                        type: "",
                        value: "64",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "7117:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "7117:32:16",
                  },
                  nodeType: "YulIf",
                  src: "7114:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "7176:115:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "7190:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "7204:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "7194:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "7218:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "7253:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "7264:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "7249:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "7249:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "7273:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "7228:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "7228:53:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "7218:6:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "7301:116:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "7315:16:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "7329:2:16",
                        type: "",
                        value: "32",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "7319:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "7344:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "7379:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "7390:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "7375:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "7375:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "7399:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "7354:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "7354:53:16",
                      },
                      variableNames: [
                        {
                          name: "value1",
                          nodeType: "YulIdentifier",
                          src: "7344:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_uint256t_uint256",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "7066:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "7077:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "7089:6:16",
                type: "",
              },
              {
                name: "value1",
                nodeType: "YulTypedName",
                src: "7097:6:16",
                type: "",
              },
            ],
            src: "7021:403:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "7494:192:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "7540:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "7549:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "7552:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "7542:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "7542:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "7542:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "7515:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "7524:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "7511:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "7511:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "7536:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "7507:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "7507:32:16",
                  },
                  nodeType: "YulIf",
                  src: "7504:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "7566:113:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "7580:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "7594:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "7584:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "7608:61:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "7641:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "7652:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "7637:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "7637:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "7661:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_uint8",
                          nodeType: "YulIdentifier",
                          src: "7618:18:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "7618:51:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "7608:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_uint8",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "7464:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "7475:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "7487:6:16",
                type: "",
              },
            ],
            src: "7430:256:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "7773:318:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "7819:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "7828:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "7831:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "7821:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "7821:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "7821:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "7794:7:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "7803:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "7790:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "7790:23:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "7815:2:16",
                        type: "",
                        value: "64",
                      },
                    ],
                    functionName: {
                      name: "slt",
                      nodeType: "YulIdentifier",
                      src: "7786:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "7786:32:16",
                  },
                  nodeType: "YulIf",
                  src: "7783:2:16",
                },
                {
                  nodeType: "YulBlock",
                  src: "7845:113:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "7859:15:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "7873:1:16",
                        type: "",
                        value: "0",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "7863:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "7887:61:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "7920:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "7931:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "7916:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "7916:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "7940:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_uint8",
                          nodeType: "YulIdentifier",
                          src: "7897:18:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "7897:51:16",
                      },
                      variableNames: [
                        {
                          name: "value0",
                          nodeType: "YulIdentifier",
                          src: "7887:6:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "7968:116:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "7982:16:16",
                      value: {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "7996:2:16",
                        type: "",
                        value: "32",
                      },
                      variables: [
                        {
                          name: "offset",
                          nodeType: "YulTypedName",
                          src: "7986:6:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "8011:63:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "headStart",
                                nodeType: "YulIdentifier",
                                src: "8046:9:16",
                              },
                              {
                                name: "offset",
                                nodeType: "YulIdentifier",
                                src: "8057:6:16",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "8042:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "8042:22:16",
                          },
                          {
                            name: "dataEnd",
                            nodeType: "YulIdentifier",
                            src: "8066:7:16",
                          },
                        ],
                        functionName: {
                          name: "abi_decode_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "8021:20:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "8021:53:16",
                      },
                      variableNames: [
                        {
                          name: "value1",
                          nodeType: "YulIdentifier",
                          src: "8011:6:16",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            name: "abi_decode_tuple_t_uint8t_uint256",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "7735:9:16",
                type: "",
              },
              {
                name: "dataEnd",
                nodeType: "YulTypedName",
                src: "7746:7:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "7758:6:16",
                type: "",
              },
              {
                name: "value1",
                nodeType: "YulTypedName",
                src: "7766:6:16",
                type: "",
              },
            ],
            src: "7692:399:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "8229:128:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "8239:112:16",
                  value: {
                    arguments: [
                      {
                        name: "value0",
                        nodeType: "YulIdentifier",
                        src: "8339:6:16",
                      },
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "8347:3:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr",
                      nodeType: "YulIdentifier",
                      src: "8253:85:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "8253:98:16",
                  },
                  variableNames: [
                    {
                      name: "updatedPos",
                      nodeType: "YulIdentifier",
                      src: "8239:10:16",
                    },
                  ],
                },
              ],
            },
            name: "abi_encodeUpdatedPos_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "8202:6:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "8210:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "updatedPos",
                nodeType: "YulTypedName",
                src: "8218:10:16",
                type: "",
              },
            ],
            src: "8097:260:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "8418:53:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "8435:3:16",
                      },
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "8458:5:16",
                          },
                        ],
                        functionName: {
                          name: "cleanup_t_address",
                          nodeType: "YulIdentifier",
                          src: "8440:17:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "8440:24:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "8428:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "8428:37:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "8428:37:16",
                },
              ],
            },
            name: "abi_encode_t_address_to_t_address",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "8406:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "8413:3:16",
                type: "",
              },
            ],
            src: "8363:108:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "8542:53:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "8559:3:16",
                      },
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "8582:5:16",
                          },
                        ],
                        functionName: {
                          name: "cleanup_t_address",
                          nodeType: "YulIdentifier",
                          src: "8564:17:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "8564:24:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "8552:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "8552:37:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "8552:37:16",
                },
              ],
            },
            name: "abi_encode_t_address_to_t_address_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "8530:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "8537:3:16",
                type: "",
              },
            ],
            src: "8477:118:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "8855:943:16",
              statements: [
                {
                  nodeType: "YulVariableDeclaration",
                  src: "8865:94:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "8953:5:16",
                      },
                    ],
                    functionName: {
                      name: "array_length_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                      nodeType: "YulIdentifier",
                      src: "8879:73:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "8879:80:16",
                  },
                  variables: [
                    {
                      name: "length",
                      nodeType: "YulTypedName",
                      src: "8869:6:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "8968:119:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "9075:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "9080:6:16",
                      },
                    ],
                    functionName: {
                      name:
                        "array_storeLengthForEncoding_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "8975:99:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "8975:112:16",
                  },
                  variableNames: [
                    {
                      name: "pos",
                      nodeType: "YulIdentifier",
                      src: "8968:3:16",
                    },
                  ],
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "9096:20:16",
                  value: {
                    name: "pos",
                    nodeType: "YulIdentifier",
                    src: "9113:3:16",
                  },
                  variables: [
                    {
                      name: "headStart",
                      nodeType: "YulTypedName",
                      src: "9100:9:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "9125:39:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "9141:3:16",
                      },
                      {
                        arguments: [
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "9150:6:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "9158:4:16",
                            type: "",
                            value: "0x20",
                          },
                        ],
                        functionName: {
                          name: "mul",
                          nodeType: "YulIdentifier",
                          src: "9146:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "9146:17:16",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "9137:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "9137:27:16",
                  },
                  variables: [
                    {
                      name: "tail",
                      nodeType: "YulTypedName",
                      src: "9129:4:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "9173:97:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "9264:5:16",
                      },
                    ],
                    functionName: {
                      name: "array_dataslot_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                      nodeType: "YulIdentifier",
                      src: "9188:75:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "9188:82:16",
                  },
                  variables: [
                    {
                      name: "baseRef",
                      nodeType: "YulTypedName",
                      src: "9177:7:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "9279:21:16",
                  value: {
                    name: "baseRef",
                    nodeType: "YulIdentifier",
                    src: "9293:7:16",
                  },
                  variables: [
                    {
                      name: "srcPtr",
                      nodeType: "YulTypedName",
                      src: "9283:6:16",
                      type: "",
                    },
                  ],
                },
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "9369:384:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              name: "pos",
                              nodeType: "YulIdentifier",
                              src: "9390:3:16",
                            },
                            {
                              arguments: [
                                {
                                  name: "tail",
                                  nodeType: "YulIdentifier",
                                  src: "9399:4:16",
                                },
                                {
                                  name: "headStart",
                                  nodeType: "YulIdentifier",
                                  src: "9405:9:16",
                                },
                              ],
                              functionName: {
                                name: "sub",
                                nodeType: "YulIdentifier",
                                src: "9395:3:16",
                              },
                              nodeType: "YulFunctionCall",
                              src: "9395:20:16",
                            },
                          ],
                          functionName: {
                            name: "mstore",
                            nodeType: "YulIdentifier",
                            src: "9383:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "9383:33:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "9383:33:16",
                      },
                      {
                        nodeType: "YulVariableDeclaration",
                        src: "9429:34:16",
                        value: {
                          arguments: [
                            {
                              name: "srcPtr",
                              nodeType: "YulIdentifier",
                              src: "9456:6:16",
                            },
                          ],
                          functionName: {
                            name: "mload",
                            nodeType: "YulIdentifier",
                            src: "9450:5:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "9450:13:16",
                        },
                        variables: [
                          {
                            name: "elementValue0",
                            nodeType: "YulTypedName",
                            src: "9433:13:16",
                            type: "",
                          },
                        ],
                      },
                      {
                        nodeType: "YulAssignment",
                        src: "9476:124:16",
                        value: {
                          arguments: [
                            {
                              name: "elementValue0",
                              nodeType: "YulIdentifier",
                              src: "9580:13:16",
                            },
                            {
                              name: "tail",
                              nodeType: "YulIdentifier",
                              src: "9595:4:16",
                            },
                          ],
                          functionName: {
                            name:
                              "abi_encodeUpdatedPos_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr",
                            nodeType: "YulIdentifier",
                            src: "9484:95:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "9484:116:16",
                        },
                        variableNames: [
                          {
                            name: "tail",
                            nodeType: "YulIdentifier",
                            src: "9476:4:16",
                          },
                        ],
                      },
                      {
                        nodeType: "YulAssignment",
                        src: "9613:96:16",
                        value: {
                          arguments: [
                            {
                              name: "srcPtr",
                              nodeType: "YulIdentifier",
                              src: "9702:6:16",
                            },
                          ],
                          functionName: {
                            name: "array_nextElement_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                            nodeType: "YulIdentifier",
                            src: "9623:78:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "9623:86:16",
                        },
                        variableNames: [
                          {
                            name: "srcPtr",
                            nodeType: "YulIdentifier",
                            src: "9613:6:16",
                          },
                        ],
                      },
                      {
                        nodeType: "YulAssignment",
                        src: "9722:21:16",
                        value: {
                          arguments: [
                            {
                              name: "pos",
                              nodeType: "YulIdentifier",
                              src: "9733:3:16",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "9738:4:16",
                              type: "",
                              value: "0x20",
                            },
                          ],
                          functionName: {
                            name: "add",
                            nodeType: "YulIdentifier",
                            src: "9729:3:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "9729:14:16",
                        },
                        variableNames: [
                          {
                            name: "pos",
                            nodeType: "YulIdentifier",
                            src: "9722:3:16",
                          },
                        ],
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        name: "i",
                        nodeType: "YulIdentifier",
                        src: "9331:1:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "9334:6:16",
                      },
                    ],
                    functionName: {
                      name: "lt",
                      nodeType: "YulIdentifier",
                      src: "9328:2:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "9328:13:16",
                  },
                  nodeType: "YulForLoop",
                  post: {
                    nodeType: "YulBlock",
                    src: "9342:18:16",
                    statements: [
                      {
                        nodeType: "YulAssignment",
                        src: "9344:14:16",
                        value: {
                          arguments: [
                            {
                              name: "i",
                              nodeType: "YulIdentifier",
                              src: "9353:1:16",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "9356:1:16",
                              type: "",
                              value: "1",
                            },
                          ],
                          functionName: {
                            name: "add",
                            nodeType: "YulIdentifier",
                            src: "9349:3:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "9349:9:16",
                        },
                        variableNames: [
                          {
                            name: "i",
                            nodeType: "YulIdentifier",
                            src: "9344:1:16",
                          },
                        ],
                      },
                    ],
                  },
                  pre: {
                    nodeType: "YulBlock",
                    src: "9313:14:16",
                    statements: [
                      {
                        nodeType: "YulVariableDeclaration",
                        src: "9315:10:16",
                        value: {
                          kind: "number",
                          nodeType: "YulLiteral",
                          src: "9324:1:16",
                          type: "",
                          value: "0",
                        },
                        variables: [
                          {
                            name: "i",
                            nodeType: "YulTypedName",
                            src: "9319:1:16",
                            type: "",
                          },
                        ],
                      },
                    ],
                  },
                  src: "9309:444:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "9762:11:16",
                  value: {
                    name: "tail",
                    nodeType: "YulIdentifier",
                    src: "9769:4:16",
                  },
                  variableNames: [
                    {
                      name: "pos",
                      nodeType: "YulIdentifier",
                      src: "9762:3:16",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "9782:10:16",
                  value: {
                    name: "pos",
                    nodeType: "YulIdentifier",
                    src: "9789:3:16",
                  },
                  variableNames: [
                    {
                      name: "end",
                      nodeType: "YulIdentifier",
                      src: "9782:3:16",
                    },
                  ],
                },
              ],
            },
            name:
              "abi_encode_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "8834:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "8841:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "8850:3:16",
                type: "",
              },
            ],
            src: "8679:1119:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "9863:50:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "9880:3:16",
                      },
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "9900:5:16",
                          },
                        ],
                        functionName: {
                          name: "cleanup_t_bool",
                          nodeType: "YulIdentifier",
                          src: "9885:14:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "9885:21:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "9873:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "9873:34:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "9873:34:16",
                },
              ],
            },
            name: "abi_encode_t_bool_to_t_bool_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "9851:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "9858:3:16",
                type: "",
              },
            ],
            src: "9804:109:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "10009:270:16",
              statements: [
                {
                  nodeType: "YulVariableDeclaration",
                  src: "10019:52:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "10065:5:16",
                      },
                    ],
                    functionName: {
                      name: "array_length_t_bytes_memory_ptr",
                      nodeType: "YulIdentifier",
                      src: "10033:31:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10033:38:16",
                  },
                  variables: [
                    {
                      name: "length",
                      nodeType: "YulTypedName",
                      src: "10023:6:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "10080:77:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "10145:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "10150:6:16",
                      },
                    ],
                    functionName: {
                      name: "array_storeLengthForEncoding_t_bytes_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "10087:57:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10087:70:16",
                  },
                  variableNames: [
                    {
                      name: "pos",
                      nodeType: "YulIdentifier",
                      src: "10080:3:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "10192:5:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "10199:4:16",
                            type: "",
                            value: "0x20",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "10188:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "10188:16:16",
                      },
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "10206:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "10211:6:16",
                      },
                    ],
                    functionName: {
                      name: "copy_memory_to_memory",
                      nodeType: "YulIdentifier",
                      src: "10166:21:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10166:52:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "10166:52:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "10227:46:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "10238:3:16",
                      },
                      {
                        arguments: [
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "10265:6:16",
                          },
                        ],
                        functionName: {
                          name: "round_up_to_mul_of_32",
                          nodeType: "YulIdentifier",
                          src: "10243:21:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "10243:29:16",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "10234:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10234:39:16",
                  },
                  variableNames: [
                    {
                      name: "end",
                      nodeType: "YulIdentifier",
                      src: "10227:3:16",
                    },
                  ],
                },
              ],
            },
            name: "abi_encode_t_bytes_memory_ptr_to_t_bytes_memory_ptr_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "9990:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "9997:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "10005:3:16",
                type: "",
              },
            ],
            src: "9919:360:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "10367:262:16",
              statements: [
                {
                  nodeType: "YulVariableDeclaration",
                  src: "10377:53:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "10424:5:16",
                      },
                    ],
                    functionName: {
                      name: "array_length_t_string_memory_ptr",
                      nodeType: "YulIdentifier",
                      src: "10391:32:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10391:39:16",
                  },
                  variables: [
                    {
                      name: "length",
                      nodeType: "YulTypedName",
                      src: "10381:6:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "10439:68:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "10495:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "10500:6:16",
                      },
                    ],
                    functionName: {
                      name: "array_storeLengthForEncoding_t_string_memory_ptr",
                      nodeType: "YulIdentifier",
                      src: "10446:48:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10446:61:16",
                  },
                  variableNames: [
                    {
                      name: "pos",
                      nodeType: "YulIdentifier",
                      src: "10439:3:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "10542:5:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "10549:4:16",
                            type: "",
                            value: "0x20",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "10538:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "10538:16:16",
                      },
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "10556:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "10561:6:16",
                      },
                    ],
                    functionName: {
                      name: "copy_memory_to_memory",
                      nodeType: "YulIdentifier",
                      src: "10516:21:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10516:52:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "10516:52:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "10577:46:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "10588:3:16",
                      },
                      {
                        arguments: [
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "10615:6:16",
                          },
                        ],
                        functionName: {
                          name: "round_up_to_mul_of_32",
                          nodeType: "YulIdentifier",
                          src: "10593:21:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "10593:29:16",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "10584:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10584:39:16",
                  },
                  variableNames: [
                    {
                      name: "end",
                      nodeType: "YulIdentifier",
                      src: "10577:3:16",
                    },
                  ],
                },
              ],
            },
            name: "abi_encode_t_string_memory_ptr_to_t_string_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "10348:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "10355:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "10363:3:16",
                type: "",
              },
            ],
            src: "10285:344:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "10727:272:16",
              statements: [
                {
                  nodeType: "YulVariableDeclaration",
                  src: "10737:53:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "10784:5:16",
                      },
                    ],
                    functionName: {
                      name: "array_length_t_string_memory_ptr",
                      nodeType: "YulIdentifier",
                      src: "10751:32:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10751:39:16",
                  },
                  variables: [
                    {
                      name: "length",
                      nodeType: "YulTypedName",
                      src: "10741:6:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "10799:78:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "10865:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "10870:6:16",
                      },
                    ],
                    functionName: {
                      name: "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "10806:58:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10806:71:16",
                  },
                  variableNames: [
                    {
                      name: "pos",
                      nodeType: "YulIdentifier",
                      src: "10799:3:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "10912:5:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "10919:4:16",
                            type: "",
                            value: "0x20",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "10908:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "10908:16:16",
                      },
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "10926:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "10931:6:16",
                      },
                    ],
                    functionName: {
                      name: "copy_memory_to_memory",
                      nodeType: "YulIdentifier",
                      src: "10886:21:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10886:52:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "10886:52:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "10947:46:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "10958:3:16",
                      },
                      {
                        arguments: [
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "10985:6:16",
                          },
                        ],
                        functionName: {
                          name: "round_up_to_mul_of_32",
                          nodeType: "YulIdentifier",
                          src: "10963:21:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "10963:29:16",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "10954:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "10954:39:16",
                  },
                  variableNames: [
                    {
                      name: "end",
                      nodeType: "YulIdentifier",
                      src: "10947:3:16",
                    },
                  ],
                },
              ],
            },
            name: "abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "10708:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "10715:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "10723:3:16",
                type: "",
              },
            ],
            src: "10635:364:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "11151:222:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "11161:74:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "11227:3:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "11232:2:16",
                        type: "",
                        value: "36",
                      },
                    ],
                    functionName: {
                      name: "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "11168:58:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "11168:67:16",
                  },
                  variableNames: [
                    {
                      name: "pos",
                      nodeType: "YulIdentifier",
                      src: "11161:3:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "pos",
                            nodeType: "YulIdentifier",
                            src: "11256:3:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "11261:1:16",
                            type: "",
                            value: "0",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "11252:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "11252:11:16",
                      },
                      {
                        kind: "string",
                        nodeType: "YulLiteral",
                        src: "11265:34:16",
                        type: "",
                        value: "Not enough ether to mint this to",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "11245:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "11245:55:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "11245:55:16",
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "pos",
                            nodeType: "YulIdentifier",
                            src: "11321:3:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "11326:2:16",
                            type: "",
                            value: "32",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "11317:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "11317:12:16",
                      },
                      {
                        kind: "string",
                        nodeType: "YulLiteral",
                        src: "11331:6:16",
                        type: "",
                        value: "ken!",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "11310:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "11310:28:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "11310:28:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "11348:19:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "11359:3:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "11364:2:16",
                        type: "",
                        value: "64",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "11355:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "11355:12:16",
                  },
                  variableNames: [
                    {
                      name: "end",
                      nodeType: "YulIdentifier",
                      src: "11348:3:16",
                    },
                  ],
                },
              ],
            },
            name:
              "abi_encode_t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f_to_t_string_memory_ptr_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "11139:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "11147:3:16",
                type: "",
              },
            ],
            src: "11005:368:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "11569:665:16",
              statements: [
                {
                  nodeType: "YulVariableDeclaration",
                  src: "11579:26:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "11595:3:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "11600:4:16",
                        type: "",
                        value: "0x60",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "11591:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "11591:14:16",
                  },
                  variables: [
                    {
                      name: "tail",
                      nodeType: "YulTypedName",
                      src: "11583:4:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "11615:235:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "11650:43:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "11680:5:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "11687:4:16",
                                type: "",
                                value: "0x00",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "11676:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "11676:16:16",
                          },
                        ],
                        functionName: {
                          name: "mload",
                          nodeType: "YulIdentifier",
                          src: "11670:5:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "11670:23:16",
                      },
                      variables: [
                        {
                          name: "memberValue0",
                          nodeType: "YulTypedName",
                          src: "11654:12:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "pos",
                                nodeType: "YulIdentifier",
                                src: "11718:3:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "11723:4:16",
                                type: "",
                                value: "0x00",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "11714:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "11714:14:16",
                          },
                          {
                            arguments: [
                              {
                                name: "tail",
                                nodeType: "YulIdentifier",
                                src: "11734:4:16",
                              },
                              {
                                name: "pos",
                                nodeType: "YulIdentifier",
                                src: "11740:3:16",
                              },
                            ],
                            functionName: {
                              name: "sub",
                              nodeType: "YulIdentifier",
                              src: "11730:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "11730:14:16",
                          },
                        ],
                        functionName: {
                          name: "mstore",
                          nodeType: "YulIdentifier",
                          src: "11707:6:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "11707:38:16",
                      },
                      nodeType: "YulExpressionStatement",
                      src: "11707:38:16",
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "11758:81:16",
                      value: {
                        arguments: [
                          {
                            name: "memberValue0",
                            nodeType: "YulIdentifier",
                            src: "11820:12:16",
                          },
                          {
                            name: "tail",
                            nodeType: "YulIdentifier",
                            src: "11834:4:16",
                          },
                        ],
                        functionName: {
                          name: "abi_encode_t_string_memory_ptr_to_t_string_memory_ptr",
                          nodeType: "YulIdentifier",
                          src: "11766:53:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "11766:73:16",
                      },
                      variableNames: [
                        {
                          name: "tail",
                          nodeType: "YulIdentifier",
                          src: "11758:4:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "11860:166:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "11897:43:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "11927:5:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "11934:4:16",
                                type: "",
                                value: "0x20",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "11923:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "11923:16:16",
                          },
                        ],
                        functionName: {
                          name: "mload",
                          nodeType: "YulIdentifier",
                          src: "11917:5:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "11917:23:16",
                      },
                      variables: [
                        {
                          name: "memberValue0",
                          nodeType: "YulTypedName",
                          src: "11901:12:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            name: "memberValue0",
                            nodeType: "YulIdentifier",
                            src: "11987:12:16",
                          },
                          {
                            arguments: [
                              {
                                name: "pos",
                                nodeType: "YulIdentifier",
                                src: "12005:3:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "12010:4:16",
                                type: "",
                                value: "0x20",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "12001:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "12001:14:16",
                          },
                        ],
                        functionName: {
                          name: "abi_encode_t_address_to_t_address",
                          nodeType: "YulIdentifier",
                          src: "11953:33:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "11953:63:16",
                      },
                      nodeType: "YulExpressionStatement",
                      src: "11953:63:16",
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "12036:171:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "12078:43:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "12108:5:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "12115:4:16",
                                type: "",
                                value: "0x40",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "12104:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "12104:16:16",
                          },
                        ],
                        functionName: {
                          name: "mload",
                          nodeType: "YulIdentifier",
                          src: "12098:5:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "12098:23:16",
                      },
                      variables: [
                        {
                          name: "memberValue0",
                          nodeType: "YulTypedName",
                          src: "12082:12:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            name: "memberValue0",
                            nodeType: "YulIdentifier",
                            src: "12168:12:16",
                          },
                          {
                            arguments: [
                              {
                                name: "pos",
                                nodeType: "YulIdentifier",
                                src: "12186:3:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "12191:4:16",
                                type: "",
                                value: "0x40",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "12182:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "12182:14:16",
                          },
                        ],
                        functionName: {
                          name: "abi_encode_t_uint256_to_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "12134:33:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "12134:63:16",
                      },
                      nodeType: "YulExpressionStatement",
                      src: "12134:63:16",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "12217:11:16",
                  value: {
                    name: "tail",
                    nodeType: "YulIdentifier",
                    src: "12224:4:16",
                  },
                  variableNames: [
                    {
                      name: "end",
                      nodeType: "YulIdentifier",
                      src: "12217:3:16",
                    },
                  ],
                },
              ],
            },
            name: "abi_encode_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "11548:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "11555:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "11564:3:16",
                type: "",
              },
            ],
            src: "11453:781:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "12440:665:16",
              statements: [
                {
                  nodeType: "YulVariableDeclaration",
                  src: "12450:26:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "12466:3:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "12471:4:16",
                        type: "",
                        value: "0x60",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "12462:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "12462:14:16",
                  },
                  variables: [
                    {
                      name: "tail",
                      nodeType: "YulTypedName",
                      src: "12454:4:16",
                      type: "",
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "12486:235:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "12521:43:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "12551:5:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "12558:4:16",
                                type: "",
                                value: "0x00",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "12547:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "12547:16:16",
                          },
                        ],
                        functionName: {
                          name: "mload",
                          nodeType: "YulIdentifier",
                          src: "12541:5:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "12541:23:16",
                      },
                      variables: [
                        {
                          name: "memberValue0",
                          nodeType: "YulTypedName",
                          src: "12525:12:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "pos",
                                nodeType: "YulIdentifier",
                                src: "12589:3:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "12594:4:16",
                                type: "",
                                value: "0x00",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "12585:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "12585:14:16",
                          },
                          {
                            arguments: [
                              {
                                name: "tail",
                                nodeType: "YulIdentifier",
                                src: "12605:4:16",
                              },
                              {
                                name: "pos",
                                nodeType: "YulIdentifier",
                                src: "12611:3:16",
                              },
                            ],
                            functionName: {
                              name: "sub",
                              nodeType: "YulIdentifier",
                              src: "12601:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "12601:14:16",
                          },
                        ],
                        functionName: {
                          name: "mstore",
                          nodeType: "YulIdentifier",
                          src: "12578:6:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "12578:38:16",
                      },
                      nodeType: "YulExpressionStatement",
                      src: "12578:38:16",
                    },
                    {
                      nodeType: "YulAssignment",
                      src: "12629:81:16",
                      value: {
                        arguments: [
                          {
                            name: "memberValue0",
                            nodeType: "YulIdentifier",
                            src: "12691:12:16",
                          },
                          {
                            name: "tail",
                            nodeType: "YulIdentifier",
                            src: "12705:4:16",
                          },
                        ],
                        functionName: {
                          name: "abi_encode_t_string_memory_ptr_to_t_string_memory_ptr",
                          nodeType: "YulIdentifier",
                          src: "12637:53:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "12637:73:16",
                      },
                      variableNames: [
                        {
                          name: "tail",
                          nodeType: "YulIdentifier",
                          src: "12629:4:16",
                        },
                      ],
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "12731:166:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "12768:43:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "12798:5:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "12805:4:16",
                                type: "",
                                value: "0x20",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "12794:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "12794:16:16",
                          },
                        ],
                        functionName: {
                          name: "mload",
                          nodeType: "YulIdentifier",
                          src: "12788:5:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "12788:23:16",
                      },
                      variables: [
                        {
                          name: "memberValue0",
                          nodeType: "YulTypedName",
                          src: "12772:12:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            name: "memberValue0",
                            nodeType: "YulIdentifier",
                            src: "12858:12:16",
                          },
                          {
                            arguments: [
                              {
                                name: "pos",
                                nodeType: "YulIdentifier",
                                src: "12876:3:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "12881:4:16",
                                type: "",
                                value: "0x20",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "12872:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "12872:14:16",
                          },
                        ],
                        functionName: {
                          name: "abi_encode_t_address_to_t_address",
                          nodeType: "YulIdentifier",
                          src: "12824:33:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "12824:63:16",
                      },
                      nodeType: "YulExpressionStatement",
                      src: "12824:63:16",
                    },
                  ],
                },
                {
                  nodeType: "YulBlock",
                  src: "12907:171:16",
                  statements: [
                    {
                      nodeType: "YulVariableDeclaration",
                      src: "12949:43:16",
                      value: {
                        arguments: [
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "12979:5:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "12986:4:16",
                                type: "",
                                value: "0x40",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "12975:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "12975:16:16",
                          },
                        ],
                        functionName: {
                          name: "mload",
                          nodeType: "YulIdentifier",
                          src: "12969:5:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "12969:23:16",
                      },
                      variables: [
                        {
                          name: "memberValue0",
                          nodeType: "YulTypedName",
                          src: "12953:12:16",
                          type: "",
                        },
                      ],
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            name: "memberValue0",
                            nodeType: "YulIdentifier",
                            src: "13039:12:16",
                          },
                          {
                            arguments: [
                              {
                                name: "pos",
                                nodeType: "YulIdentifier",
                                src: "13057:3:16",
                              },
                              {
                                kind: "number",
                                nodeType: "YulLiteral",
                                src: "13062:4:16",
                                type: "",
                                value: "0x40",
                              },
                            ],
                            functionName: {
                              name: "add",
                              nodeType: "YulIdentifier",
                              src: "13053:3:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "13053:14:16",
                          },
                        ],
                        functionName: {
                          name: "abi_encode_t_uint256_to_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "13005:33:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "13005:63:16",
                      },
                      nodeType: "YulExpressionStatement",
                      src: "13005:63:16",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "13088:11:16",
                  value: {
                    name: "tail",
                    nodeType: "YulIdentifier",
                    src: "13095:4:16",
                  },
                  variableNames: [
                    {
                      name: "end",
                      nodeType: "YulIdentifier",
                      src: "13088:3:16",
                    },
                  ],
                },
              ],
            },
            name: "abi_encode_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "12419:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "12426:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "end",
                nodeType: "YulTypedName",
                src: "12435:3:16",
                type: "",
              },
            ],
            src: "12314:791:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "13166:53:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "13183:3:16",
                      },
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "13206:5:16",
                          },
                        ],
                        functionName: {
                          name: "cleanup_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "13188:17:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "13188:24:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "13176:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "13176:37:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "13176:37:16",
                },
              ],
            },
            name: "abi_encode_t_uint256_to_t_uint256",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "13154:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "13161:3:16",
                type: "",
              },
            ],
            src: "13111:108:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "13290:53:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "13307:3:16",
                      },
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "13330:5:16",
                          },
                        ],
                        functionName: {
                          name: "cleanup_t_uint256",
                          nodeType: "YulIdentifier",
                          src: "13312:17:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "13312:24:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "13300:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "13300:37:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "13300:37:16",
                },
              ],
            },
            name: "abi_encode_t_uint256_to_t_uint256_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "13278:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "13285:3:16",
                type: "",
              },
            ],
            src: "13225:118:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "13410:51:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "13427:3:16",
                      },
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "13448:5:16",
                          },
                        ],
                        functionName: {
                          name: "cleanup_t_uint8",
                          nodeType: "YulIdentifier",
                          src: "13432:15:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "13432:22:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "13420:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "13420:35:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "13420:35:16",
                },
              ],
            },
            name: "abi_encode_t_uint8_to_t_uint8_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "13398:5:16",
                type: "",
              },
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "13405:3:16",
                type: "",
              },
            ],
            src: "13349:112:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "13565:124:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "13575:26:16",
                  value: {
                    arguments: [
                      {
                        name: "headStart",
                        nodeType: "YulIdentifier",
                        src: "13587:9:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "13598:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "13583:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "13583:18:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "13575:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value0",
                        nodeType: "YulIdentifier",
                        src: "13655:6:16",
                      },
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "13668:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "13679:1:16",
                            type: "",
                            value: "0",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "13664:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "13664:17:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_address_to_t_address_fromStack",
                      nodeType: "YulIdentifier",
                      src: "13611:43:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "13611:71:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "13611:71:16",
                },
              ],
            },
            name: "abi_encode_tuple_t_address__to_t_address__fromStack_reversed",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "13537:9:16",
                type: "",
              },
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "13549:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "tail",
                nodeType: "YulTypedName",
                src: "13560:4:16",
                type: "",
              },
            ],
            src: "13467:222:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "13895:277:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "13905:26:16",
                  value: {
                    arguments: [
                      {
                        name: "headStart",
                        nodeType: "YulIdentifier",
                        src: "13917:9:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "13928:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "13913:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "13913:18:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "13905:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "13952:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "13963:1:16",
                            type: "",
                            value: "0",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "13948:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "13948:17:16",
                      },
                      {
                        arguments: [
                          {
                            name: "tail",
                            nodeType: "YulIdentifier",
                            src: "13971:4:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "13977:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "13967:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "13967:20:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "13941:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "13941:47:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "13941:47:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "13997:168:16",
                  value: {
                    arguments: [
                      {
                        name: "value0",
                        nodeType: "YulIdentifier",
                        src: "14151:6:16",
                      },
                      {
                        name: "tail",
                        nodeType: "YulIdentifier",
                        src: "14160:4:16",
                      },
                    ],
                    functionName: {
                      name:
                        "abi_encode_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "14005:145:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "14005:160:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "13997:4:16",
                    },
                  ],
                },
              ],
            },
            name:
              "abi_encode_tuple_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr__to_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr__fromStack_reversed",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "13867:9:16",
                type: "",
              },
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "13879:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "tail",
                nodeType: "YulTypedName",
                src: "13890:4:16",
                type: "",
              },
            ],
            src: "13695:477:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "14270:118:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "14280:26:16",
                  value: {
                    arguments: [
                      {
                        name: "headStart",
                        nodeType: "YulIdentifier",
                        src: "14292:9:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "14303:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "14288:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "14288:18:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "14280:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value0",
                        nodeType: "YulIdentifier",
                        src: "14354:6:16",
                      },
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "14367:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "14378:1:16",
                            type: "",
                            value: "0",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "14363:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "14363:17:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_bool_to_t_bool_fromStack",
                      nodeType: "YulIdentifier",
                      src: "14316:37:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "14316:65:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "14316:65:16",
                },
              ],
            },
            name: "abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "14242:9:16",
                type: "",
              },
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "14254:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "tail",
                nodeType: "YulTypedName",
                src: "14265:4:16",
                type: "",
              },
            ],
            src: "14178:210:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "14580:422:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "14590:26:16",
                  value: {
                    arguments: [
                      {
                        name: "headStart",
                        nodeType: "YulIdentifier",
                        src: "14602:9:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "14613:2:16",
                        type: "",
                        value: "96",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "14598:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "14598:18:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "14590:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "14637:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "14648:1:16",
                            type: "",
                            value: "0",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "14633:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "14633:17:16",
                      },
                      {
                        arguments: [
                          {
                            name: "tail",
                            nodeType: "YulIdentifier",
                            src: "14656:4:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "14662:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "14652:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "14652:20:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "14626:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "14626:47:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "14626:47:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "14682:84:16",
                  value: {
                    arguments: [
                      {
                        name: "value0",
                        nodeType: "YulIdentifier",
                        src: "14752:6:16",
                      },
                      {
                        name: "tail",
                        nodeType: "YulIdentifier",
                        src: "14761:4:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_bytes_memory_ptr_to_t_bytes_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "14690:61:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "14690:76:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "14682:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "14787:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "14798:2:16",
                            type: "",
                            value: "32",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "14783:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "14783:18:16",
                      },
                      {
                        arguments: [
                          {
                            name: "tail",
                            nodeType: "YulIdentifier",
                            src: "14807:4:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "14813:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "14803:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "14803:20:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "14776:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "14776:48:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "14776:48:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "14833:84:16",
                  value: {
                    arguments: [
                      {
                        name: "value1",
                        nodeType: "YulIdentifier",
                        src: "14903:6:16",
                      },
                      {
                        name: "tail",
                        nodeType: "YulIdentifier",
                        src: "14912:4:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_bytes_memory_ptr_to_t_bytes_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "14841:61:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "14841:76:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "14833:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value2",
                        nodeType: "YulIdentifier",
                        src: "14967:6:16",
                      },
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "14980:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "14991:2:16",
                            type: "",
                            value: "64",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "14976:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "14976:18:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_uint8_to_t_uint8_fromStack",
                      nodeType: "YulIdentifier",
                      src: "14927:39:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "14927:68:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "14927:68:16",
                },
              ],
            },
            name:
              "abi_encode_tuple_t_bytes_memory_ptr_t_bytes_memory_ptr_t_uint8__to_t_bytes_memory_ptr_t_bytes_memory_ptr_t_uint8__fromStack_reversed",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "14536:9:16",
                type: "",
              },
              {
                name: "value2",
                nodeType: "YulTypedName",
                src: "14548:6:16",
                type: "",
              },
              {
                name: "value1",
                nodeType: "YulTypedName",
                src: "14556:6:16",
                type: "",
              },
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "14564:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "tail",
                nodeType: "YulTypedName",
                src: "14575:4:16",
                type: "",
              },
            ],
            src: "14394:608:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "15126:195:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "15136:26:16",
                  value: {
                    arguments: [
                      {
                        name: "headStart",
                        nodeType: "YulIdentifier",
                        src: "15148:9:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "15159:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "15144:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "15144:18:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "15136:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "15183:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "15194:1:16",
                            type: "",
                            value: "0",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "15179:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "15179:17:16",
                      },
                      {
                        arguments: [
                          {
                            name: "tail",
                            nodeType: "YulIdentifier",
                            src: "15202:4:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "15208:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "15198:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "15198:20:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "15172:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "15172:47:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "15172:47:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "15228:86:16",
                  value: {
                    arguments: [
                      {
                        name: "value0",
                        nodeType: "YulIdentifier",
                        src: "15300:6:16",
                      },
                      {
                        name: "tail",
                        nodeType: "YulIdentifier",
                        src: "15309:4:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "15236:63:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "15236:78:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "15228:4:16",
                    },
                  ],
                },
              ],
            },
            name: "abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "15098:9:16",
                type: "",
              },
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "15110:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "tail",
                nodeType: "YulTypedName",
                src: "15121:4:16",
                type: "",
              },
            ],
            src: "15008:313:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "15501:359:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "15511:26:16",
                  value: {
                    arguments: [
                      {
                        name: "headStart",
                        nodeType: "YulIdentifier",
                        src: "15523:9:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "15534:2:16",
                        type: "",
                        value: "96",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "15519:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "15519:18:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "15511:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "15558:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "15569:1:16",
                            type: "",
                            value: "0",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "15554:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "15554:17:16",
                      },
                      {
                        arguments: [
                          {
                            name: "tail",
                            nodeType: "YulIdentifier",
                            src: "15577:4:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "15583:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "15573:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "15573:20:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "15547:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "15547:47:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "15547:47:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "15603:86:16",
                  value: {
                    arguments: [
                      {
                        name: "value0",
                        nodeType: "YulIdentifier",
                        src: "15675:6:16",
                      },
                      {
                        name: "tail",
                        nodeType: "YulIdentifier",
                        src: "15684:4:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "15611:63:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "15611:78:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "15603:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value1",
                        nodeType: "YulIdentifier",
                        src: "15743:6:16",
                      },
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "15756:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "15767:2:16",
                            type: "",
                            value: "32",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "15752:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "15752:18:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_address_to_t_address_fromStack",
                      nodeType: "YulIdentifier",
                      src: "15699:43:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "15699:72:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "15699:72:16",
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value2",
                        nodeType: "YulIdentifier",
                        src: "15825:6:16",
                      },
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "15838:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "15849:2:16",
                            type: "",
                            value: "64",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "15834:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "15834:18:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_uint256_to_t_uint256_fromStack",
                      nodeType: "YulIdentifier",
                      src: "15781:43:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "15781:72:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "15781:72:16",
                },
              ],
            },
            name:
              "abi_encode_tuple_t_string_memory_ptr_t_address_t_uint256__to_t_string_memory_ptr_t_address_t_uint256__fromStack_reversed",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "15457:9:16",
                type: "",
              },
              {
                name: "value2",
                nodeType: "YulTypedName",
                src: "15469:6:16",
                type: "",
              },
              {
                name: "value1",
                nodeType: "YulTypedName",
                src: "15477:6:16",
                type: "",
              },
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "15485:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "tail",
                nodeType: "YulTypedName",
                src: "15496:4:16",
                type: "",
              },
            ],
            src: "15327:533:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "16037:248:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "16047:26:16",
                  value: {
                    arguments: [
                      {
                        name: "headStart",
                        nodeType: "YulIdentifier",
                        src: "16059:9:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "16070:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "16055:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "16055:18:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "16047:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "16094:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "16105:1:16",
                            type: "",
                            value: "0",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "16090:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "16090:17:16",
                      },
                      {
                        arguments: [
                          {
                            name: "tail",
                            nodeType: "YulIdentifier",
                            src: "16113:4:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "16119:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "16109:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "16109:20:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "16083:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "16083:47:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "16083:47:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "16139:139:16",
                  value: {
                    arguments: [
                      {
                        name: "tail",
                        nodeType: "YulIdentifier",
                        src: "16273:4:16",
                      },
                    ],
                    functionName: {
                      name:
                        "abi_encode_t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f_to_t_string_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "16147:124:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "16147:131:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "16139:4:16",
                    },
                  ],
                },
              ],
            },
            name:
              "abi_encode_tuple_t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f__to_t_string_memory_ptr__fromStack_reversed",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "16017:9:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "tail",
                nodeType: "YulTypedName",
                src: "16032:4:16",
                type: "",
              },
            ],
            src: "15866:419:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "16441:227:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "16451:26:16",
                  value: {
                    arguments: [
                      {
                        name: "headStart",
                        nodeType: "YulIdentifier",
                        src: "16463:9:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "16474:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "16459:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "16459:18:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "16451:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "16498:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "16509:1:16",
                            type: "",
                            value: "0",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "16494:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "16494:17:16",
                      },
                      {
                        arguments: [
                          {
                            name: "tail",
                            nodeType: "YulIdentifier",
                            src: "16517:4:16",
                          },
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "16523:9:16",
                          },
                        ],
                        functionName: {
                          name: "sub",
                          nodeType: "YulIdentifier",
                          src: "16513:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "16513:20:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "16487:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "16487:47:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "16487:47:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "16543:118:16",
                  value: {
                    arguments: [
                      {
                        name: "value0",
                        nodeType: "YulIdentifier",
                        src: "16647:6:16",
                      },
                      {
                        name: "tail",
                        nodeType: "YulIdentifier",
                        src: "16656:4:16",
                      },
                    ],
                    functionName: {
                      name:
                        "abi_encode_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr_fromStack",
                      nodeType: "YulIdentifier",
                      src: "16551:95:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "16551:110:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "16543:4:16",
                    },
                  ],
                },
              ],
            },
            name:
              "abi_encode_tuple_t_struct$_PixelChain_$58_memory_ptr__to_t_struct$_PixelChain_$58_memory_ptr__fromStack_reversed",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "16413:9:16",
                type: "",
              },
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "16425:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "tail",
                nodeType: "YulTypedName",
                src: "16436:4:16",
                type: "",
              },
            ],
            src: "16291:377:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "16772:124:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "16782:26:16",
                  value: {
                    arguments: [
                      {
                        name: "headStart",
                        nodeType: "YulIdentifier",
                        src: "16794:9:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "16805:2:16",
                        type: "",
                        value: "32",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "16790:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "16790:18:16",
                  },
                  variableNames: [
                    {
                      name: "tail",
                      nodeType: "YulIdentifier",
                      src: "16782:4:16",
                    },
                  ],
                },
                {
                  expression: {
                    arguments: [
                      {
                        name: "value0",
                        nodeType: "YulIdentifier",
                        src: "16862:6:16",
                      },
                      {
                        arguments: [
                          {
                            name: "headStart",
                            nodeType: "YulIdentifier",
                            src: "16875:9:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "16886:1:16",
                            type: "",
                            value: "0",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "16871:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "16871:17:16",
                      },
                    ],
                    functionName: {
                      name: "abi_encode_t_uint256_to_t_uint256_fromStack",
                      nodeType: "YulIdentifier",
                      src: "16818:43:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "16818:71:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "16818:71:16",
                },
              ],
            },
            name: "abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "headStart",
                nodeType: "YulTypedName",
                src: "16744:9:16",
                type: "",
              },
              {
                name: "value0",
                nodeType: "YulTypedName",
                src: "16756:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "tail",
                nodeType: "YulTypedName",
                src: "16767:4:16",
                type: "",
              },
            ],
            src: "16674:222:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "16942:238:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "16952:19:16",
                  value: {
                    arguments: [
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "16968:2:16",
                        type: "",
                        value: "64",
                      },
                    ],
                    functionName: {
                      name: "mload",
                      nodeType: "YulIdentifier",
                      src: "16962:5:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "16962:9:16",
                  },
                  variableNames: [
                    {
                      name: "memPtr",
                      nodeType: "YulIdentifier",
                      src: "16952:6:16",
                    },
                  ],
                },
                {
                  nodeType: "YulVariableDeclaration",
                  src: "16980:35:16",
                  value: {
                    arguments: [
                      {
                        name: "memPtr",
                        nodeType: "YulIdentifier",
                        src: "17002:6:16",
                      },
                      {
                        name: "size",
                        nodeType: "YulIdentifier",
                        src: "17010:4:16",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "16998:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "16998:17:16",
                  },
                  variables: [
                    {
                      name: "newFreePtr",
                      nodeType: "YulTypedName",
                      src: "16984:10:16",
                      type: "",
                    },
                  ],
                },
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "17126:17:16",
                    statements: [
                      {
                        expression: {
                          arguments: [],
                          functionName: {
                            name: "panic_error",
                            nodeType: "YulIdentifier",
                            src: "17128:11:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "17128:13:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "17128:13:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "newFreePtr",
                            nodeType: "YulIdentifier",
                            src: "17069:10:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "17081:18:16",
                            type: "",
                            value: "0xffffffffffffffff",
                          },
                        ],
                        functionName: {
                          name: "gt",
                          nodeType: "YulIdentifier",
                          src: "17066:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "17066:34:16",
                      },
                      {
                        arguments: [
                          {
                            name: "newFreePtr",
                            nodeType: "YulIdentifier",
                            src: "17105:10:16",
                          },
                          {
                            name: "memPtr",
                            nodeType: "YulIdentifier",
                            src: "17117:6:16",
                          },
                        ],
                        functionName: {
                          name: "lt",
                          nodeType: "YulIdentifier",
                          src: "17102:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "17102:22:16",
                      },
                    ],
                    functionName: {
                      name: "or",
                      nodeType: "YulIdentifier",
                      src: "17063:2:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "17063:62:16",
                  },
                  nodeType: "YulIf",
                  src: "17060:2:16",
                },
                {
                  expression: {
                    arguments: [
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "17159:2:16",
                        type: "",
                        value: "64",
                      },
                      {
                        name: "newFreePtr",
                        nodeType: "YulIdentifier",
                        src: "17163:10:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "17152:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "17152:22:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "17152:22:16",
                },
              ],
            },
            name: "allocateMemory",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "size",
                nodeType: "YulTypedName",
                src: "16926:4:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "memPtr",
                nodeType: "YulTypedName",
                src: "16935:6:16",
                type: "",
              },
            ],
            src: "16902:278:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "17252:260:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "17357:17:16",
                    statements: [
                      {
                        expression: {
                          arguments: [],
                          functionName: {
                            name: "panic_error",
                            nodeType: "YulIdentifier",
                            src: "17359:11:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "17359:13:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "17359:13:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "17329:6:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "17337:18:16",
                        type: "",
                        value: "0xffffffffffffffff",
                      },
                    ],
                    functionName: {
                      name: "gt",
                      nodeType: "YulIdentifier",
                      src: "17326:2:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "17326:30:16",
                  },
                  nodeType: "YulIf",
                  src: "17323:2:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "17404:41:16",
                  value: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "17420:6:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "17428:4:16",
                            type: "",
                            value: "0x1f",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "17416:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "17416:17:16",
                      },
                      {
                        arguments: [
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "17439:4:16",
                            type: "",
                            value: "0x1f",
                          },
                        ],
                        functionName: {
                          name: "not",
                          nodeType: "YulIdentifier",
                          src: "17435:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "17435:9:16",
                      },
                    ],
                    functionName: {
                      name: "and",
                      nodeType: "YulIdentifier",
                      src: "17412:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "17412:33:16",
                  },
                  variableNames: [
                    {
                      name: "size",
                      nodeType: "YulIdentifier",
                      src: "17404:4:16",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "17482:23:16",
                  value: {
                    arguments: [
                      {
                        name: "size",
                        nodeType: "YulIdentifier",
                        src: "17494:4:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "17500:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "17490:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "17490:15:16",
                  },
                  variableNames: [
                    {
                      name: "size",
                      nodeType: "YulIdentifier",
                      src: "17482:4:16",
                    },
                  ],
                },
              ],
            },
            name: "array_allocation_size_t_bytes_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "17236:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "size",
                nodeType: "YulTypedName",
                src: "17247:4:16",
                type: "",
              },
            ],
            src: "17186:326:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "17585:260:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "17690:17:16",
                    statements: [
                      {
                        expression: {
                          arguments: [],
                          functionName: {
                            name: "panic_error",
                            nodeType: "YulIdentifier",
                            src: "17692:11:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "17692:13:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "17692:13:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "17662:6:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "17670:18:16",
                        type: "",
                        value: "0xffffffffffffffff",
                      },
                    ],
                    functionName: {
                      name: "gt",
                      nodeType: "YulIdentifier",
                      src: "17659:2:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "17659:30:16",
                  },
                  nodeType: "YulIf",
                  src: "17656:2:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "17737:41:16",
                  value: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "17753:6:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "17761:4:16",
                            type: "",
                            value: "0x1f",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "17749:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "17749:17:16",
                      },
                      {
                        arguments: [
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "17772:4:16",
                            type: "",
                            value: "0x1f",
                          },
                        ],
                        functionName: {
                          name: "not",
                          nodeType: "YulIdentifier",
                          src: "17768:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "17768:9:16",
                      },
                    ],
                    functionName: {
                      name: "and",
                      nodeType: "YulIdentifier",
                      src: "17745:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "17745:33:16",
                  },
                  variableNames: [
                    {
                      name: "size",
                      nodeType: "YulIdentifier",
                      src: "17737:4:16",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "17815:23:16",
                  value: {
                    arguments: [
                      {
                        name: "size",
                        nodeType: "YulIdentifier",
                        src: "17827:4:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "17833:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "17823:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "17823:15:16",
                  },
                  variableNames: [
                    {
                      name: "size",
                      nodeType: "YulIdentifier",
                      src: "17815:4:16",
                    },
                  ],
                },
              ],
            },
            name: "array_allocation_size_t_string_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "17569:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "size",
                nodeType: "YulTypedName",
                src: "17580:4:16",
                type: "",
              },
            ],
            src: "17518:327:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "17949:60:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "17959:11:16",
                  value: {
                    name: "ptr",
                    nodeType: "YulIdentifier",
                    src: "17967:3:16",
                  },
                  variableNames: [
                    {
                      name: "data",
                      nodeType: "YulIdentifier",
                      src: "17959:4:16",
                    },
                  ],
                },
                {
                  nodeType: "YulAssignment",
                  src: "17980:22:16",
                  value: {
                    arguments: [
                      {
                        name: "ptr",
                        nodeType: "YulIdentifier",
                        src: "17992:3:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "17997:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "17988:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "17988:14:16",
                  },
                  variableNames: [
                    {
                      name: "data",
                      nodeType: "YulIdentifier",
                      src: "17980:4:16",
                    },
                  ],
                },
              ],
            },
            name: "array_dataslot_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "ptr",
                nodeType: "YulTypedName",
                src: "17936:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "data",
                nodeType: "YulTypedName",
                src: "17944:4:16",
                type: "",
              },
            ],
            src: "17851:158:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "18115:40:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "18126:22:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "18142:5:16",
                      },
                    ],
                    functionName: {
                      name: "mload",
                      nodeType: "YulIdentifier",
                      src: "18136:5:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "18136:12:16",
                  },
                  variableNames: [
                    {
                      name: "length",
                      nodeType: "YulIdentifier",
                      src: "18126:6:16",
                    },
                  ],
                },
              ],
            },
            name: "array_length_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "18098:5:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "18108:6:16",
                type: "",
              },
            ],
            src: "18015:140:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "18219:40:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "18230:22:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "18246:5:16",
                      },
                    ],
                    functionName: {
                      name: "mload",
                      nodeType: "YulIdentifier",
                      src: "18240:5:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "18240:12:16",
                  },
                  variableNames: [
                    {
                      name: "length",
                      nodeType: "YulIdentifier",
                      src: "18230:6:16",
                    },
                  ],
                },
              ],
            },
            name: "array_length_t_bytes_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "18202:5:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "18212:6:16",
                type: "",
              },
            ],
            src: "18161:98:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "18324:40:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "18335:22:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "18351:5:16",
                      },
                    ],
                    functionName: {
                      name: "mload",
                      nodeType: "YulIdentifier",
                      src: "18345:5:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "18345:12:16",
                  },
                  variableNames: [
                    {
                      name: "length",
                      nodeType: "YulIdentifier",
                      src: "18335:6:16",
                    },
                  ],
                },
              ],
            },
            name: "array_length_t_string_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "18307:5:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "18317:6:16",
                type: "",
              },
            ],
            src: "18265:99:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "18471:38:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "18481:22:16",
                  value: {
                    arguments: [
                      {
                        name: "ptr",
                        nodeType: "YulIdentifier",
                        src: "18493:3:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "18498:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "18489:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "18489:14:16",
                  },
                  variableNames: [
                    {
                      name: "next",
                      nodeType: "YulIdentifier",
                      src: "18481:4:16",
                    },
                  ],
                },
              ],
            },
            name: "array_nextElement_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "ptr",
                nodeType: "YulTypedName",
                src: "18458:3:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "next",
                nodeType: "YulTypedName",
                src: "18466:4:16",
                type: "",
              },
            ],
            src: "18370:139:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "18652:73:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "18669:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "18674:6:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "18662:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "18662:19:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "18662:19:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "18690:29:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "18709:3:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "18714:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "18705:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "18705:14:16",
                  },
                  variableNames: [
                    {
                      name: "updated_pos",
                      nodeType: "YulIdentifier",
                      src: "18690:11:16",
                    },
                  ],
                },
              ],
            },
            name: "array_storeLengthForEncoding_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "18624:3:16",
                type: "",
              },
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "18629:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "updated_pos",
                nodeType: "YulTypedName",
                src: "18640:11:16",
                type: "",
              },
            ],
            src: "18515:210:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "18826:73:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "18843:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "18848:6:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "18836:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "18836:19:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "18836:19:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "18864:29:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "18883:3:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "18888:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "18879:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "18879:14:16",
                  },
                  variableNames: [
                    {
                      name: "updated_pos",
                      nodeType: "YulIdentifier",
                      src: "18864:11:16",
                    },
                  ],
                },
              ],
            },
            name: "array_storeLengthForEncoding_t_bytes_memory_ptr_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "18798:3:16",
                type: "",
              },
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "18803:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "updated_pos",
                nodeType: "YulTypedName",
                src: "18814:11:16",
                type: "",
              },
            ],
            src: "18731:168:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "18991:73:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "19008:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "19013:6:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "19001:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "19001:19:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "19001:19:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "19029:29:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "19048:3:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "19053:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "19044:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "19044:14:16",
                  },
                  variableNames: [
                    {
                      name: "updated_pos",
                      nodeType: "YulIdentifier",
                      src: "19029:11:16",
                    },
                  ],
                },
              ],
            },
            name: "array_storeLengthForEncoding_t_string_memory_ptr",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "18963:3:16",
                type: "",
              },
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "18968:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "updated_pos",
                nodeType: "YulTypedName",
                src: "18979:11:16",
                type: "",
              },
            ],
            src: "18905:159:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "19166:73:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "19183:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "19188:6:16",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "19176:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "19176:19:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "19176:19:16",
                },
                {
                  nodeType: "YulAssignment",
                  src: "19204:29:16",
                  value: {
                    arguments: [
                      {
                        name: "pos",
                        nodeType: "YulIdentifier",
                        src: "19223:3:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "19228:4:16",
                        type: "",
                        value: "0x20",
                      },
                    ],
                    functionName: {
                      name: "add",
                      nodeType: "YulIdentifier",
                      src: "19219:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "19219:14:16",
                  },
                  variableNames: [
                    {
                      name: "updated_pos",
                      nodeType: "YulIdentifier",
                      src: "19204:11:16",
                    },
                  ],
                },
              ],
            },
            name: "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "pos",
                nodeType: "YulTypedName",
                src: "19138:3:16",
                type: "",
              },
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "19143:6:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "updated_pos",
                nodeType: "YulTypedName",
                src: "19154:11:16",
                type: "",
              },
            ],
            src: "19070:169:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "19290:51:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "19300:35:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "19329:5:16",
                      },
                    ],
                    functionName: {
                      name: "cleanup_t_uint160",
                      nodeType: "YulIdentifier",
                      src: "19311:17:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "19311:24:16",
                  },
                  variableNames: [
                    {
                      name: "cleaned",
                      nodeType: "YulIdentifier",
                      src: "19300:7:16",
                    },
                  ],
                },
              ],
            },
            name: "cleanup_t_address",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "19272:5:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "cleaned",
                nodeType: "YulTypedName",
                src: "19282:7:16",
                type: "",
              },
            ],
            src: "19245:96:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "19389:48:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "19399:32:16",
                  value: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "19424:5:16",
                          },
                        ],
                        functionName: {
                          name: "iszero",
                          nodeType: "YulIdentifier",
                          src: "19417:6:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "19417:13:16",
                      },
                    ],
                    functionName: {
                      name: "iszero",
                      nodeType: "YulIdentifier",
                      src: "19410:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "19410:21:16",
                  },
                  variableNames: [
                    {
                      name: "cleaned",
                      nodeType: "YulIdentifier",
                      src: "19399:7:16",
                    },
                  ],
                },
              ],
            },
            name: "cleanup_t_bool",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "19371:5:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "cleaned",
                nodeType: "YulTypedName",
                src: "19381:7:16",
                type: "",
              },
            ],
            src: "19347:90:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "19487:105:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "19497:89:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "19512:5:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "19519:66:16",
                        type: "",
                        value: "0xffffffff00000000000000000000000000000000000000000000000000000000",
                      },
                    ],
                    functionName: {
                      name: "and",
                      nodeType: "YulIdentifier",
                      src: "19508:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "19508:78:16",
                  },
                  variableNames: [
                    {
                      name: "cleaned",
                      nodeType: "YulIdentifier",
                      src: "19497:7:16",
                    },
                  ],
                },
              ],
            },
            name: "cleanup_t_bytes4",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "19469:5:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "cleaned",
                nodeType: "YulTypedName",
                src: "19479:7:16",
                type: "",
              },
            ],
            src: "19443:149:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "19643:81:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "19653:65:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "19668:5:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "19675:42:16",
                        type: "",
                        value: "0xffffffffffffffffffffffffffffffffffffffff",
                      },
                    ],
                    functionName: {
                      name: "and",
                      nodeType: "YulIdentifier",
                      src: "19664:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "19664:54:16",
                  },
                  variableNames: [
                    {
                      name: "cleaned",
                      nodeType: "YulIdentifier",
                      src: "19653:7:16",
                    },
                  ],
                },
              ],
            },
            name: "cleanup_t_uint160",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "19625:5:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "cleaned",
                nodeType: "YulTypedName",
                src: "19635:7:16",
                type: "",
              },
            ],
            src: "19598:126:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "19775:32:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "19785:16:16",
                  value: {
                    name: "value",
                    nodeType: "YulIdentifier",
                    src: "19796:5:16",
                  },
                  variableNames: [
                    {
                      name: "cleaned",
                      nodeType: "YulIdentifier",
                      src: "19785:7:16",
                    },
                  ],
                },
              ],
            },
            name: "cleanup_t_uint256",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "19757:5:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "cleaned",
                nodeType: "YulTypedName",
                src: "19767:7:16",
                type: "",
              },
            ],
            src: "19730:77:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "19856:43:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "19866:27:16",
                  value: {
                    arguments: [
                      {
                        name: "value",
                        nodeType: "YulIdentifier",
                        src: "19881:5:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "19888:4:16",
                        type: "",
                        value: "0xff",
                      },
                    ],
                    functionName: {
                      name: "and",
                      nodeType: "YulIdentifier",
                      src: "19877:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "19877:16:16",
                  },
                  variableNames: [
                    {
                      name: "cleaned",
                      nodeType: "YulIdentifier",
                      src: "19866:7:16",
                    },
                  ],
                },
              ],
            },
            name: "cleanup_t_uint8",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "19838:5:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "cleaned",
                nodeType: "YulTypedName",
                src: "19848:7:16",
                type: "",
              },
            ],
            src: "19813:86:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "19956:103:16",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        name: "dst",
                        nodeType: "YulIdentifier",
                        src: "19979:3:16",
                      },
                      {
                        name: "src",
                        nodeType: "YulIdentifier",
                        src: "19984:3:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "19989:6:16",
                      },
                    ],
                    functionName: {
                      name: "calldatacopy",
                      nodeType: "YulIdentifier",
                      src: "19966:12:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "19966:30:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "19966:30:16",
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "dst",
                            nodeType: "YulIdentifier",
                            src: "20037:3:16",
                          },
                          {
                            name: "length",
                            nodeType: "YulIdentifier",
                            src: "20042:6:16",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "20033:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "20033:16:16",
                      },
                      {
                        kind: "number",
                        nodeType: "YulLiteral",
                        src: "20051:1:16",
                        type: "",
                        value: "0",
                      },
                    ],
                    functionName: {
                      name: "mstore",
                      nodeType: "YulIdentifier",
                      src: "20026:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "20026:27:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "20026:27:16",
                },
              ],
            },
            name: "copy_calldata_to_memory",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "src",
                nodeType: "YulTypedName",
                src: "19938:3:16",
                type: "",
              },
              {
                name: "dst",
                nodeType: "YulTypedName",
                src: "19943:3:16",
                type: "",
              },
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "19948:6:16",
                type: "",
              },
            ],
            src: "19905:154:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "20114:258:16",
              statements: [
                {
                  nodeType: "YulVariableDeclaration",
                  src: "20124:10:16",
                  value: {
                    kind: "number",
                    nodeType: "YulLiteral",
                    src: "20133:1:16",
                    type: "",
                    value: "0",
                  },
                  variables: [
                    {
                      name: "i",
                      nodeType: "YulTypedName",
                      src: "20128:1:16",
                      type: "",
                    },
                  ],
                },
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "20193:63:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              arguments: [
                                {
                                  name: "dst",
                                  nodeType: "YulIdentifier",
                                  src: "20218:3:16",
                                },
                                {
                                  name: "i",
                                  nodeType: "YulIdentifier",
                                  src: "20223:1:16",
                                },
                              ],
                              functionName: {
                                name: "add",
                                nodeType: "YulIdentifier",
                                src: "20214:3:16",
                              },
                              nodeType: "YulFunctionCall",
                              src: "20214:11:16",
                            },
                            {
                              arguments: [
                                {
                                  arguments: [
                                    {
                                      name: "src",
                                      nodeType: "YulIdentifier",
                                      src: "20237:3:16",
                                    },
                                    {
                                      name: "i",
                                      nodeType: "YulIdentifier",
                                      src: "20242:1:16",
                                    },
                                  ],
                                  functionName: {
                                    name: "add",
                                    nodeType: "YulIdentifier",
                                    src: "20233:3:16",
                                  },
                                  nodeType: "YulFunctionCall",
                                  src: "20233:11:16",
                                },
                              ],
                              functionName: {
                                name: "mload",
                                nodeType: "YulIdentifier",
                                src: "20227:5:16",
                              },
                              nodeType: "YulFunctionCall",
                              src: "20227:18:16",
                            },
                          ],
                          functionName: {
                            name: "mstore",
                            nodeType: "YulIdentifier",
                            src: "20207:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "20207:39:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "20207:39:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        name: "i",
                        nodeType: "YulIdentifier",
                        src: "20154:1:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "20157:6:16",
                      },
                    ],
                    functionName: {
                      name: "lt",
                      nodeType: "YulIdentifier",
                      src: "20151:2:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "20151:13:16",
                  },
                  nodeType: "YulForLoop",
                  post: {
                    nodeType: "YulBlock",
                    src: "20165:19:16",
                    statements: [
                      {
                        nodeType: "YulAssignment",
                        src: "20167:15:16",
                        value: {
                          arguments: [
                            {
                              name: "i",
                              nodeType: "YulIdentifier",
                              src: "20176:1:16",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "20179:2:16",
                              type: "",
                              value: "32",
                            },
                          ],
                          functionName: {
                            name: "add",
                            nodeType: "YulIdentifier",
                            src: "20172:3:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "20172:10:16",
                        },
                        variableNames: [
                          {
                            name: "i",
                            nodeType: "YulIdentifier",
                            src: "20167:1:16",
                          },
                        ],
                      },
                    ],
                  },
                  pre: {
                    nodeType: "YulBlock",
                    src: "20147:3:16",
                    statements: [],
                  },
                  src: "20143:113:16",
                },
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "20290:76:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              arguments: [
                                {
                                  name: "dst",
                                  nodeType: "YulIdentifier",
                                  src: "20340:3:16",
                                },
                                {
                                  name: "length",
                                  nodeType: "YulIdentifier",
                                  src: "20345:6:16",
                                },
                              ],
                              functionName: {
                                name: "add",
                                nodeType: "YulIdentifier",
                                src: "20336:3:16",
                              },
                              nodeType: "YulFunctionCall",
                              src: "20336:16:16",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "20354:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "mstore",
                            nodeType: "YulIdentifier",
                            src: "20329:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "20329:27:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "20329:27:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        name: "i",
                        nodeType: "YulIdentifier",
                        src: "20271:1:16",
                      },
                      {
                        name: "length",
                        nodeType: "YulIdentifier",
                        src: "20274:6:16",
                      },
                    ],
                    functionName: {
                      name: "gt",
                      nodeType: "YulIdentifier",
                      src: "20268:2:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "20268:13:16",
                  },
                  nodeType: "YulIf",
                  src: "20265:2:16",
                },
              ],
            },
            name: "copy_memory_to_memory",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "src",
                nodeType: "YulTypedName",
                src: "20096:3:16",
                type: "",
              },
              {
                name: "dst",
                nodeType: "YulTypedName",
                src: "20101:3:16",
                type: "",
              },
              {
                name: "length",
                nodeType: "YulTypedName",
                src: "20106:6:16",
                type: "",
              },
            ],
            src: "20065:307:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "20401:25:16",
              statements: [
                {
                  expression: {
                    arguments: [],
                    functionName: {
                      name: "invalid",
                      nodeType: "YulIdentifier",
                      src: "20411:7:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "20411:9:16",
                  },
                  nodeType: "YulExpressionStatement",
                  src: "20411:9:16",
                },
              ],
            },
            name: "panic_error",
            nodeType: "YulFunctionDefinition",
            src: "20378:48:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "20480:54:16",
              statements: [
                {
                  nodeType: "YulAssignment",
                  src: "20490:38:16",
                  value: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "20508:5:16",
                          },
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "20515:2:16",
                            type: "",
                            value: "31",
                          },
                        ],
                        functionName: {
                          name: "add",
                          nodeType: "YulIdentifier",
                          src: "20504:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "20504:14:16",
                      },
                      {
                        arguments: [
                          {
                            kind: "number",
                            nodeType: "YulLiteral",
                            src: "20524:2:16",
                            type: "",
                            value: "31",
                          },
                        ],
                        functionName: {
                          name: "not",
                          nodeType: "YulIdentifier",
                          src: "20520:3:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "20520:7:16",
                      },
                    ],
                    functionName: {
                      name: "and",
                      nodeType: "YulIdentifier",
                      src: "20500:3:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "20500:28:16",
                  },
                  variableNames: [
                    {
                      name: "result",
                      nodeType: "YulIdentifier",
                      src: "20490:6:16",
                    },
                  ],
                },
              ],
            },
            name: "round_up_to_mul_of_32",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "20463:5:16",
                type: "",
              },
            ],
            returnVariables: [
              {
                name: "result",
                nodeType: "YulTypedName",
                src: "20473:6:16",
                type: "",
              },
            ],
            src: "20432:102:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "20583:79:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "20640:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "20649:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "20652:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "20642:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "20642:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "20642:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "20606:5:16",
                          },
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "20631:5:16",
                              },
                            ],
                            functionName: {
                              name: "cleanup_t_address",
                              nodeType: "YulIdentifier",
                              src: "20613:17:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "20613:24:16",
                          },
                        ],
                        functionName: {
                          name: "eq",
                          nodeType: "YulIdentifier",
                          src: "20603:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "20603:35:16",
                      },
                    ],
                    functionName: {
                      name: "iszero",
                      nodeType: "YulIdentifier",
                      src: "20596:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "20596:43:16",
                  },
                  nodeType: "YulIf",
                  src: "20593:2:16",
                },
              ],
            },
            name: "validator_revert_t_address",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "20576:5:16",
                type: "",
              },
            ],
            src: "20540:122:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "20708:76:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "20762:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "20771:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "20774:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "20764:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "20764:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "20764:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "20731:5:16",
                          },
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "20753:5:16",
                              },
                            ],
                            functionName: {
                              name: "cleanup_t_bool",
                              nodeType: "YulIdentifier",
                              src: "20738:14:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "20738:21:16",
                          },
                        ],
                        functionName: {
                          name: "eq",
                          nodeType: "YulIdentifier",
                          src: "20728:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "20728:32:16",
                      },
                    ],
                    functionName: {
                      name: "iszero",
                      nodeType: "YulIdentifier",
                      src: "20721:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "20721:40:16",
                  },
                  nodeType: "YulIf",
                  src: "20718:2:16",
                },
              ],
            },
            name: "validator_revert_t_bool",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "20701:5:16",
                type: "",
              },
            ],
            src: "20668:116:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "20832:78:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "20888:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "20897:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "20900:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "20890:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "20890:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "20890:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "20855:5:16",
                          },
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "20879:5:16",
                              },
                            ],
                            functionName: {
                              name: "cleanup_t_bytes4",
                              nodeType: "YulIdentifier",
                              src: "20862:16:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "20862:23:16",
                          },
                        ],
                        functionName: {
                          name: "eq",
                          nodeType: "YulIdentifier",
                          src: "20852:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "20852:34:16",
                      },
                    ],
                    functionName: {
                      name: "iszero",
                      nodeType: "YulIdentifier",
                      src: "20845:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "20845:42:16",
                  },
                  nodeType: "YulIf",
                  src: "20842:2:16",
                },
              ],
            },
            name: "validator_revert_t_bytes4",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "20825:5:16",
                type: "",
              },
            ],
            src: "20790:120:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "20959:79:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "21016:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "21025:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "21028:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "21018:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "21018:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "21018:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "20982:5:16",
                          },
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "21007:5:16",
                              },
                            ],
                            functionName: {
                              name: "cleanup_t_uint256",
                              nodeType: "YulIdentifier",
                              src: "20989:17:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "20989:24:16",
                          },
                        ],
                        functionName: {
                          name: "eq",
                          nodeType: "YulIdentifier",
                          src: "20979:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "20979:35:16",
                      },
                    ],
                    functionName: {
                      name: "iszero",
                      nodeType: "YulIdentifier",
                      src: "20972:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "20972:43:16",
                  },
                  nodeType: "YulIf",
                  src: "20969:2:16",
                },
              ],
            },
            name: "validator_revert_t_uint256",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "20952:5:16",
                type: "",
              },
            ],
            src: "20916:122:16",
          },
          {
            body: {
              nodeType: "YulBlock",
              src: "21085:77:16",
              statements: [
                {
                  body: {
                    nodeType: "YulBlock",
                    src: "21140:16:16",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "21149:1:16",
                              type: "",
                              value: "0",
                            },
                            {
                              kind: "number",
                              nodeType: "YulLiteral",
                              src: "21152:1:16",
                              type: "",
                              value: "0",
                            },
                          ],
                          functionName: {
                            name: "revert",
                            nodeType: "YulIdentifier",
                            src: "21142:6:16",
                          },
                          nodeType: "YulFunctionCall",
                          src: "21142:12:16",
                        },
                        nodeType: "YulExpressionStatement",
                        src: "21142:12:16",
                      },
                    ],
                  },
                  condition: {
                    arguments: [
                      {
                        arguments: [
                          {
                            name: "value",
                            nodeType: "YulIdentifier",
                            src: "21108:5:16",
                          },
                          {
                            arguments: [
                              {
                                name: "value",
                                nodeType: "YulIdentifier",
                                src: "21131:5:16",
                              },
                            ],
                            functionName: {
                              name: "cleanup_t_uint8",
                              nodeType: "YulIdentifier",
                              src: "21115:15:16",
                            },
                            nodeType: "YulFunctionCall",
                            src: "21115:22:16",
                          },
                        ],
                        functionName: {
                          name: "eq",
                          nodeType: "YulIdentifier",
                          src: "21105:2:16",
                        },
                        nodeType: "YulFunctionCall",
                        src: "21105:33:16",
                      },
                    ],
                    functionName: {
                      name: "iszero",
                      nodeType: "YulIdentifier",
                      src: "21098:6:16",
                    },
                    nodeType: "YulFunctionCall",
                    src: "21098:41:16",
                  },
                  nodeType: "YulIf",
                  src: "21095:2:16",
                },
              ],
            },
            name: "validator_revert_t_uint8",
            nodeType: "YulFunctionDefinition",
            parameters: [
              {
                name: "value",
                nodeType: "YulTypedName",
                src: "21078:5:16",
                type: "",
              },
            ],
            src: "21044:118:16",
          },
        ],
      },
      contents:
        '{\n\n    function abi_decode_t_address(offset, end) -> value {\n        value := calldataload(offset)\n        validator_revert_t_address(value)\n    }\n\n    function abi_decode_t_bool(offset, end) -> value {\n        value := calldataload(offset)\n        validator_revert_t_bool(value)\n    }\n\n    function abi_decode_t_bytes4(offset, end) -> value {\n        value := calldataload(offset)\n        validator_revert_t_bytes4(value)\n    }\n\n    function abi_decode_t_bytes_memory_ptr(offset, end) -> array {\n        if iszero(slt(add(offset, 0x1f), end)) { revert(0, 0) }\n        let length := calldataload(offset)\n        array := allocateMemory(array_allocation_size_t_bytes_memory_ptr(length))\n        mstore(array, length)\n        let src := add(offset, 0x20)\n        let dst := add(array, 0x20)\n        if gt(add(src, length), end) { revert(0, 0) }\n        copy_calldata_to_memory(src, dst, length)\n    }\n\n    function abi_decode_t_string_memory_ptr(offset, end) -> array {\n        if iszero(slt(add(offset, 0x1f), end)) { revert(0, 0) }\n        let length := calldataload(offset)\n        array := allocateMemory(array_allocation_size_t_string_memory_ptr(length))\n        mstore(array, length)\n        let src := add(offset, 0x20)\n        let dst := add(array, 0x20)\n        if gt(add(src, length), end) { revert(0, 0) }\n        copy_calldata_to_memory(src, dst, length)\n    }\n\n    // struct PixelChainMax.NewPixelChain\n    function abi_decode_t_struct$_NewPixelChain_$67_memory_ptr(headStart, end) -> value {\n        if slt(sub(end, headStart), 0x80) { revert(0, 0) }\n        value := allocateMemory(0x80)\n\n        {\n            // name\n\n            let offset := calldataload(add(headStart, 0))\n            if gt(offset, 0xffffffffffffffff) { revert(0, 0) }\n            mstore(add(value, 0x00), abi_decode_t_string_memory_ptr(add(headStart, offset), end))\n\n        }\n\n        {\n            // data\n\n            let offset := calldataload(add(headStart, 32))\n            if gt(offset, 0xffffffffffffffff) { revert(0, 0) }\n            mstore(add(value, 0x20), abi_decode_t_bytes_memory_ptr(add(headStart, offset), end))\n\n        }\n\n        {\n            // palette\n\n            let offset := calldataload(add(headStart, 64))\n            if gt(offset, 0xffffffffffffffff) { revert(0, 0) }\n            mstore(add(value, 0x40), abi_decode_t_bytes_memory_ptr(add(headStart, offset), end))\n\n        }\n\n        {\n            // version\n\n            let offset := 96\n            mstore(add(value, 0x60), abi_decode_t_uint8(add(headStart, offset), end))\n\n        }\n\n    }\n\n    function abi_decode_t_uint256(offset, end) -> value {\n        value := calldataload(offset)\n        validator_revert_t_uint256(value)\n    }\n\n    function abi_decode_t_uint8(offset, end) -> value {\n        value := calldataload(offset)\n        validator_revert_t_uint8(value)\n    }\n\n    function abi_decode_tuple_t_address(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_addresst_address(headStart, dataEnd) -> value0, value1 {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n        {\n            let offset := 32\n            value1 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_addresst_addresst_uint256(headStart, dataEnd) -> value0, value1, value2 {\n        if slt(sub(dataEnd, headStart), 96) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n        {\n            let offset := 32\n            value1 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n        {\n            let offset := 64\n            value2 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_addresst_addresst_uint256t_bytes_memory_ptr(headStart, dataEnd) -> value0, value1, value2, value3 {\n        if slt(sub(dataEnd, headStart), 128) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n        {\n            let offset := 32\n            value1 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n        {\n            let offset := 64\n            value2 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\n        }\n\n        {\n            let offset := calldataload(add(headStart, 96))\n            if gt(offset, 0xffffffffffffffff) { revert(0, 0) }\n            value3 := abi_decode_t_bytes_memory_ptr(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_addresst_bool(headStart, dataEnd) -> value0, value1 {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n        {\n            let offset := 32\n            value1 := abi_decode_t_bool(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_addresst_uint256(headStart, dataEnd) -> value0, value1 {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n        {\n            let offset := 32\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_bytes4(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_bytes4(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_string_memory_ptr(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n\n        {\n            let offset := calldataload(add(headStart, 0))\n            if gt(offset, 0xffffffffffffffff) { revert(0, 0) }\n            value0 := abi_decode_t_string_memory_ptr(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_struct$_NewPixelChain_$67_memory_ptr(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n\n        {\n            let offset := calldataload(add(headStart, 0))\n            if gt(offset, 0xffffffffffffffff) { revert(0, 0) }\n            value0 := abi_decode_t_struct$_NewPixelChain_$67_memory_ptr(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_uint256(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_uint256t_uint256(headStart, dataEnd) -> value0, value1 {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\n        }\n\n        {\n            let offset := 32\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_uint8(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_uint8(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_uint8t_uint256(headStart, dataEnd) -> value0, value1 {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n\n        {\n            let offset := 0\n            value0 := abi_decode_t_uint8(add(headStart, offset), dataEnd)\n        }\n\n        {\n            let offset := 32\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_encodeUpdatedPos_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr(value0, pos) -> updatedPos {\n        updatedPos := abi_encode_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr(value0, pos)\n    }\n\n    function abi_encode_t_address_to_t_address(value, pos) {\n        mstore(pos, cleanup_t_address(value))\n    }\n\n    function abi_encode_t_address_to_t_address_fromStack(value, pos) {\n        mstore(pos, cleanup_t_address(value))\n    }\n\n    // struct PixelChainMax.PixelChain[] -> struct PixelChainMax.PixelChain[]\n    function abi_encode_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\n        let length := array_length_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr(value)\n        pos := array_storeLengthForEncoding_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\n        let headStart := pos\n        let tail := add(pos, mul(length, 0x20))\n        let baseRef := array_dataslot_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr(value)\n        let srcPtr := baseRef\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\n        {\n            mstore(pos, sub(tail, headStart))\n            let elementValue0 := mload(srcPtr)\n            tail := abi_encodeUpdatedPos_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr(elementValue0, tail)\n            srcPtr := array_nextElement_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr(srcPtr)\n            pos := add(pos, 0x20)\n        }\n        pos := tail\n        end := pos\n    }\n\n    function abi_encode_t_bool_to_t_bool_fromStack(value, pos) {\n        mstore(pos, cleanup_t_bool(value))\n    }\n\n    function abi_encode_t_bytes_memory_ptr_to_t_bytes_memory_ptr_fromStack(value, pos) -> end {\n        let length := array_length_t_bytes_memory_ptr(value)\n        pos := array_storeLengthForEncoding_t_bytes_memory_ptr_fromStack(pos, length)\n        copy_memory_to_memory(add(value, 0x20), pos, length)\n        end := add(pos, round_up_to_mul_of_32(length))\n    }\n\n    function abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(value, pos) -> end {\n        let length := array_length_t_string_memory_ptr(value)\n        pos := array_storeLengthForEncoding_t_string_memory_ptr(pos, length)\n        copy_memory_to_memory(add(value, 0x20), pos, length)\n        end := add(pos, round_up_to_mul_of_32(length))\n    }\n\n    function abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value, pos) -> end {\n        let length := array_length_t_string_memory_ptr(value)\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, length)\n        copy_memory_to_memory(add(value, 0x20), pos, length)\n        end := add(pos, round_up_to_mul_of_32(length))\n    }\n\n    function abi_encode_t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f_to_t_string_memory_ptr_fromStack(pos) -> end {\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 36)\n\n        mstore(add(pos, 0), "Not enough ether to mint this to")\n\n        mstore(add(pos, 32), "ken!")\n\n        end := add(pos, 64)\n    }\n\n    // struct PixelChainMax.PixelChain -> struct PixelChainMax.PixelChain\n    function abi_encode_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr(value, pos)  -> end  {\n        let tail := add(pos, 0x60)\n\n        {\n            // name\n\n            let memberValue0 := mload(add(value, 0x00))\n\n            mstore(add(pos, 0x00), sub(tail, pos))\n            tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(memberValue0, tail)\n\n        }\n\n        {\n            // author\n\n            let memberValue0 := mload(add(value, 0x20))\n            abi_encode_t_address_to_t_address(memberValue0, add(pos, 0x20))\n        }\n\n        {\n            // blockNumber\n\n            let memberValue0 := mload(add(value, 0x40))\n            abi_encode_t_uint256_to_t_uint256(memberValue0, add(pos, 0x40))\n        }\n\n        end := tail\n    }\n\n    // struct PixelChainMax.PixelChain -> struct PixelChainMax.PixelChain\n    function abi_encode_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr_fromStack(value, pos)  -> end  {\n        let tail := add(pos, 0x60)\n\n        {\n            // name\n\n            let memberValue0 := mload(add(value, 0x00))\n\n            mstore(add(pos, 0x00), sub(tail, pos))\n            tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(memberValue0, tail)\n\n        }\n\n        {\n            // author\n\n            let memberValue0 := mload(add(value, 0x20))\n            abi_encode_t_address_to_t_address(memberValue0, add(pos, 0x20))\n        }\n\n        {\n            // blockNumber\n\n            let memberValue0 := mload(add(value, 0x40))\n            abi_encode_t_uint256_to_t_uint256(memberValue0, add(pos, 0x40))\n        }\n\n        end := tail\n    }\n\n    function abi_encode_t_uint256_to_t_uint256(value, pos) {\n        mstore(pos, cleanup_t_uint256(value))\n    }\n\n    function abi_encode_t_uint256_to_t_uint256_fromStack(value, pos) {\n        mstore(pos, cleanup_t_uint256(value))\n    }\n\n    function abi_encode_t_uint8_to_t_uint8_fromStack(value, pos) {\n        mstore(pos, cleanup_t_uint8(value))\n    }\n\n    function abi_encode_tuple_t_address__to_t_address__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        abi_encode_t_address_to_t_address_fromStack(value0,  add(headStart, 0))\n\n    }\n\n    function abi_encode_tuple_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr__to_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_fromStack(value0,  tail)\n\n    }\n\n    function abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        abi_encode_t_bool_to_t_bool_fromStack(value0,  add(headStart, 0))\n\n    }\n\n    function abi_encode_tuple_t_bytes_memory_ptr_t_bytes_memory_ptr_t_uint8__to_t_bytes_memory_ptr_t_bytes_memory_ptr_t_uint8__fromStack_reversed(headStart , value2, value1, value0) -> tail {\n        tail := add(headStart, 96)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_bytes_memory_ptr_to_t_bytes_memory_ptr_fromStack(value0,  tail)\n\n        mstore(add(headStart, 32), sub(tail, headStart))\n        tail := abi_encode_t_bytes_memory_ptr_to_t_bytes_memory_ptr_fromStack(value1,  tail)\n\n        abi_encode_t_uint8_to_t_uint8_fromStack(value2,  add(headStart, 64))\n\n    }\n\n    function abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value0,  tail)\n\n    }\n\n    function abi_encode_tuple_t_string_memory_ptr_t_address_t_uint256__to_t_string_memory_ptr_t_address_t_uint256__fromStack_reversed(headStart , value2, value1, value0) -> tail {\n        tail := add(headStart, 96)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value0,  tail)\n\n        abi_encode_t_address_to_t_address_fromStack(value1,  add(headStart, 32))\n\n        abi_encode_t_uint256_to_t_uint256_fromStack(value2,  add(headStart, 64))\n\n    }\n\n    function abi_encode_tuple_t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f_to_t_string_memory_ptr_fromStack( tail)\n\n    }\n\n    function abi_encode_tuple_t_struct$_PixelChain_$58_memory_ptr__to_t_struct$_PixelChain_$58_memory_ptr__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_struct$_PixelChain_$58_memory_ptr_to_t_struct$_PixelChain_$58_memory_ptr_fromStack(value0,  tail)\n\n    }\n\n    function abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\n\n    }\n\n    function allocateMemory(size) -> memPtr {\n        memPtr := mload(64)\n        let newFreePtr := add(memPtr, size)\n        // protect against overflow\n        if or(gt(newFreePtr, 0xffffffffffffffff), lt(newFreePtr, memPtr)) { panic_error() }\n        mstore(64, newFreePtr)\n    }\n\n    function array_allocation_size_t_bytes_memory_ptr(length) -> size {\n        // Make sure we can allocate memory without overflow\n        if gt(length, 0xffffffffffffffff) { panic_error() }\n\n        // round up\n        size := and(add(length, 0x1f), not(0x1f))\n\n        // add length slot\n        size := add(size, 0x20)\n\n    }\n\n    function array_allocation_size_t_string_memory_ptr(length) -> size {\n        // Make sure we can allocate memory without overflow\n        if gt(length, 0xffffffffffffffff) { panic_error() }\n\n        // round up\n        size := and(add(length, 0x1f), not(0x1f))\n\n        // add length slot\n        size := add(size, 0x20)\n\n    }\n\n    function array_dataslot_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr(ptr) -> data {\n        data := ptr\n\n        data := add(ptr, 0x20)\n\n    }\n\n    function array_length_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr(value) -> length {\n\n        length := mload(value)\n\n    }\n\n    function array_length_t_bytes_memory_ptr(value) -> length {\n\n        length := mload(value)\n\n    }\n\n    function array_length_t_string_memory_ptr(value) -> length {\n\n        length := mload(value)\n\n    }\n\n    function array_nextElement_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr(ptr) -> next {\n        next := add(ptr, 0x20)\n    }\n\n    function array_storeLengthForEncoding_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\n        mstore(pos, length)\n        updated_pos := add(pos, 0x20)\n    }\n\n    function array_storeLengthForEncoding_t_bytes_memory_ptr_fromStack(pos, length) -> updated_pos {\n        mstore(pos, length)\n        updated_pos := add(pos, 0x20)\n    }\n\n    function array_storeLengthForEncoding_t_string_memory_ptr(pos, length) -> updated_pos {\n        mstore(pos, length)\n        updated_pos := add(pos, 0x20)\n    }\n\n    function array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, length) -> updated_pos {\n        mstore(pos, length)\n        updated_pos := add(pos, 0x20)\n    }\n\n    function cleanup_t_address(value) -> cleaned {\n        cleaned := cleanup_t_uint160(value)\n    }\n\n    function cleanup_t_bool(value) -> cleaned {\n        cleaned := iszero(iszero(value))\n    }\n\n    function cleanup_t_bytes4(value) -> cleaned {\n        cleaned := and(value, 0xffffffff00000000000000000000000000000000000000000000000000000000)\n    }\n\n    function cleanup_t_uint160(value) -> cleaned {\n        cleaned := and(value, 0xffffffffffffffffffffffffffffffffffffffff)\n    }\n\n    function cleanup_t_uint256(value) -> cleaned {\n        cleaned := value\n    }\n\n    function cleanup_t_uint8(value) -> cleaned {\n        cleaned := and(value, 0xff)\n    }\n\n    function copy_calldata_to_memory(src, dst, length) {\n        calldatacopy(dst, src, length)\n        // clear end\n        mstore(add(dst, length), 0)\n    }\n\n    function copy_memory_to_memory(src, dst, length) {\n        let i := 0\n        for { } lt(i, length) { i := add(i, 32) }\n        {\n            mstore(add(dst, i), mload(add(src, i)))\n        }\n        if gt(i, length)\n        {\n            // clear end\n            mstore(add(dst, length), 0)\n        }\n    }\n\n    function panic_error() {\n        invalid()\n    }\n\n    function round_up_to_mul_of_32(value) -> result {\n        result := and(add(value, 31), not(31))\n    }\n\n    function validator_revert_t_address(value) {\n        if iszero(eq(value, cleanup_t_address(value))) { revert(0, 0) }\n    }\n\n    function validator_revert_t_bool(value) {\n        if iszero(eq(value, cleanup_t_bool(value))) { revert(0, 0) }\n    }\n\n    function validator_revert_t_bytes4(value) {\n        if iszero(eq(value, cleanup_t_bytes4(value))) { revert(0, 0) }\n    }\n\n    function validator_revert_t_uint256(value) {\n        if iszero(eq(value, cleanup_t_uint256(value))) { revert(0, 0) }\n    }\n\n    function validator_revert_t_uint8(value) {\n        if iszero(eq(value, cleanup_t_uint8(value))) { revert(0, 0) }\n    }\n\n}\n',
      id: 16,
      language: "Yul",
      name: "#utility.yul",
    },
  ],
  sourceMap:
    "203:3355:1:-:0;;;601:1;574:28;;838:49;;;;;;;;;;3567:362:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;751:40:4;427:10;770:20;;751:18;;;:40;;:::i;:::-;3642:5:7;3634;:13;;;;;;;;;;;;:::i;:::-;;3667:7;3657;:17;;;;;;;;;;;;:::i;:::-;;3762:40;2732:10;3781:20;;3762:18;;;:40;;:::i;:::-;3812:49;3064:10;3831:29;;3812:18;;;:49;;:::i;:::-;3871:51;3437:10;3890:31;;3871:18;;;:51;;:::i;:::-;3567:362;;865:17:3;885:12;:10;;;:12;;:::i;:::-;865:32;;916:9;907:6;;:18;;;;;;;;;;;;;;;;;;973:9;940:43;;969:1;940:43;;;;;;;;;;;;840:150;203:3355:1;;1482:198:4;1580:10;1565:25;;:11;:25;;;;;1557:66;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1669:4;1633:20;:33;1654:11;1633:33;;;;;;;;;;;;;;;;;;:40;;;;;;;;;;;;;;;;;;1482:198;:::o;590:104:2:-;643:15;677:10;670:17;;590:104;:::o;203:3355:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;",
  deployedSourceMap:
    "203:3355:1:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;948:140:4;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;4485:90:7;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;7092:209;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;6650:381;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;6160:200;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;7940:300;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;3081:124:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;5937:152:7;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;2239:98:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;2827:124;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;893:617;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;2343:98;;;;;;;;;;;;;:::i;:::-;;2447:106;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;8306:149:7;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;6432:161;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;4256:167;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;3333:122:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;5771:87:7;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;3988:211;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;800:31:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;;:::i;:::-;;;;;;;;1689:145:3;;;;;;;;;;;;;:::i;:::-;;2957:118:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;1066:77:3;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;2120:113:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;4639:94:7;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;7368:290;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;1516:598:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;8521:282:7;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;3211:116:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;4799:740:7;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;2559:138:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;3461:95;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;7724:154:7;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;2703:118:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;1983:240:3;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;948:140:4;1025:4;1048:20;:33;1069:11;1048:33;;;;;;;;;;;;;;;;;;;;;;;;;;;1041:40;;948:140;;;:::o;4485:90:7:-;4531:13;4563:5;4556:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4485:90;:::o;7092:209::-;7160:7;7187:16;7195:7;7187;:16::i;:::-;7179:73;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7270:15;:24;7286:7;7270:24;;;;;;;;;;;;;;;;;;;;;7263:31;;7092:209;;;:::o;6650:381::-;6730:13;6746:16;6754:7;6746;:16::i;:::-;6730:32;;6786:5;6780:11;;:2;:11;;;;6772:57;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6864:5;6848:21;;:12;:10;:12::i;:::-;:21;;;:62;;;;6873:37;6890:5;6897:12;:10;:12::i;:::-;6873:16;:37::i;:::-;6848:62;6840:152;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7003:21;7012:2;7016:7;7003:8;:21::i;:::-;6650:381;;;:::o;6160:200::-;6213:7;6332:21;:12;:19;:21::i;:::-;6325:28;;6160:200;:::o;7940:300::-;8099:41;8118:12;:10;:12::i;:::-;8132:7;8099:18;:41::i;:::-;8091:103;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8205:28;8215:4;8221:2;8225:7;8205:9;:28::i;:::-;7940:300;;;:::o;3081:124:1:-;1280:12:3;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3193:5:1::1;3164:16;:26;3181:8;3164:26;;;;;;;;;;;;;;;;:34;;;;;;;;;;;;;;;;;;3081:124:::0;:::o;5937:152:7:-;6026:7;6052:30;6076:5;6052:13;:20;6066:5;6052:20;;;;;;;;;;;;;;;:23;;:30;;;;:::i;:::-;6045:37;;5937:152;;;;:::o;2239:98:1:-;1280:12:3;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2313:17:1::1;2325:4;2313:11;:17::i;:::-;2239:98:::0;:::o;2827:124::-;1280:12:3;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2939:5:1::1;2910:16;:26;2927:8;2910:26;;;;;;;;;;;;;;;;:34;;;;;;;;;;;;;;;;;;2827:124:::0;:::o;893:617::-;970:17;990:16;;970:36;;1063:1;1020:19;:40;1040:11;:19;;;1020:40;;;;;;;;;;;;;;;;:44;1016:127;;;1092:19;:40;1112:11;:19;;;1092:40;;;;;;;;;;;;;;;;1080:52;;1016:127;1174:9;1161;:22;;1153:71;;;;;;;;;;;;:::i;:::-;;;;;;;;;1235:11;1265:54;;;;;;;;1276:11;:16;;;1265:54;;;;1294:10;1265:54;;;;;;1306:12;1265:54;;;1235:94;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1340:10;1374:1;1353:11;:18;;;;:22;1340:35;;1385:21;1391:10;1403:2;1385:5;:21::i;:::-;1440:2;1422:81;1444:11;:16;;;1462:11;:19;;;1483:11;:19;;;1422:81;;;;;;;;:::i;:::-;;;;;;;;893:617;;;:::o;2343:98::-;1280:12:3;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2392:10:1::1;:19;;:42;2412:21;2392:42;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;2343:98::o:0;2447:106::-;1280:12:3;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2540:6:1::1;2521:16;:25;;;;2447:106:::0;:::o;8306:149:7:-;8409:39;8426:4;8432:2;8436:7;8409:39;;;;;;;;;;;;:16;:39::i;:::-;8306:149;;;:::o;6432:161::-;6499:7;6519:15;6540:22;6556:5;6540:12;:15;;:22;;;;:::i;:::-;6518:44;;;6579:7;6572:14;;;6432:161;;;:::o;4256:167::-;4320:7;4346:70;4363:7;4346:70;;;;;;;;;;;;;;;;;:12;:16;;:70;;;;;:::i;:::-;4339:77;;4256:167;;;:::o;3333:122:1:-;1280:12:3;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3443:5:1::1;3414:16;:26;3431:8;3414:26;;;;;;;;;;;;;;;;:34;;;;;;;;;;;;;;;;;;3333:122:::0;:::o;5771:87:7:-;5811:13;5843:8;5836:15;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5771:87;:::o;3988:211::-;4052:7;4096:1;4079:19;;:5;:19;;;;4071:74;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4163:29;:13;:20;4177:5;4163:20;;;;;;;;;;;;;;;:27;:29::i;:::-;4156:36;;3988:211;;;:::o;800:31:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;1689:145:3:-;1280:12;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1795:1:::1;1758:40;;1779:6;;;;;;;;;;;1758:40;;;;;;;;;;;;1825:1;1808:6;;:19;;;;;;;;;;;;;;;;;;1689:145::o:0;2957:118:1:-;1280:12:3;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3064:4:1::1;3035:16;:26;3052:8;3035:26;;;;;;;;;;;;;;;;:33;;;;;;;;;;;;;;;;;;2957:118:::0;:::o;1066:77:3:-;1104:7;1130:6;;;;;;;;;;;1123:13;;1066:77;:::o;2120:113:1:-;2174:17;;:::i;:::-;2210:11;2222:3;2210:16;;;;;;;;;;;;;;;;;;2203:23;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2120:113;;;:::o;4639:94:7:-;4687:13;4719:7;4712:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4639:94;:::o;7368:290::-;7482:12;:10;:12::i;:::-;7470:24;;:8;:24;;;;7462:62;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7580:8;7535:18;:32;7554:12;:10;:12::i;:::-;7535:32;;;;;;;;;;;;;;;:42;7568:8;7535:42;;;;;;;;;;;;;;;;:53;;;;;;;;;;;;;;;;;;7632:8;7603:48;;7618:12;:10;:12::i;:::-;7603:48;;;7642:8;7603:48;;;;;;;;;;;;;;;;;;;;7368:290;;:::o;1516:598:1:-;1590:19;1621:11;1635:4;1621:18;;1660:11;:18;;;;1653:4;:25;1649:80;;;1700:11;:18;;;;1694:24;;1649:80;1739:17;1779:3;1770:6;:12;1766:111;;;1810:1;1798:13;;1766:111;;;1860:6;1854:3;:12;1842:24;;1766:111;1887:28;1935:9;1918:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;1887:58;;1956:6;1981;1990;1981:15;;1976:106;2002:3;1998:1;:7;1976:106;;;2040:11;2052:1;2040:14;;;;;;;;;;;;;;;;;;2026:28;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:8;2035:1;2026:11;;;;;;;;;;;;;:28;;;;2068:3;;;;;;;2007;;;;;;;1976:106;;;;2099:8;2092:15;;;;;;1516:598;;;;:::o;8521:282:7:-;8652:41;8671:12;:10;:12::i;:::-;8685:7;8652:18;:41::i;:::-;8644:103;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8757:39;8771:4;8777:2;8781:7;8790:5;8757:13;:39::i;:::-;8521:282;;;;:::o;3211:116:1:-;1280:12:3;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3316:4:1::1;3287:16;:26;3304:8;3287:26;;;;;;;;;;;;;;;;:33;;;;;;;;;;;;;;;;;;3211:116:::0;:::o;4799:740:7:-;4864:13;4897:16;4905:7;4897;:16::i;:::-;4889:76;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4976:23;5002:10;:19;5013:7;5002:19;;;;;;;;;;;4976:45;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5120:1;5100:8;5094:22;;;;;;;;;;;;;;;;:27;5090:74;;;5144:9;5137:16;;;;;5090:74;5292:1;5272:9;5266:23;:27;5262:110;;;5340:8;5350:9;5323:37;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5309:52;;;;;5262:110;5502:8;5512:18;:7;:16;:18::i;:::-;5485:46;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5471:61;;;4799:740;;;;:::o;2559:138:1:-;1280:12:3;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2684:6:1::1;2652:19;:29;2672:8;2652:29;;;;;;;;;;;;;;;:38;;;;2559:138:::0;;:::o;3461:95::-;3508:13;3540:9;:7;:9::i;:::-;3533:16;;3461:95;:::o;7724:154:7:-;7813:4;7836:18;:25;7855:5;7836:25;;;;;;;;;;;;;;;:35;7862:8;7836:35;;;;;;;;;;;;;;;;;;;;;;;;;7829:42;;7724:154;;;;:::o;2703:118:1:-;1280:12:3;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2810:4:1::1;2781:16;:26;2798:8;2781:26;;;;;;;;;;;;;;;;:33;;;;;;;;;;;;;;;;;;2703:118:::0;:::o;1983:240:3:-;1280:12;:10;:12::i;:::-;1270:22;;:6;;;;;;;;;;;:22;;;1262:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2091:1:::1;2071:22;;:8;:22;;;;2063:73;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2180:8;2151:38;;2172:6;;;;;;;;;;;2151:38;;;;;;;;;;;;2208:8;2199:6;;:17;;;;;;;;;;;;;;;;;;1983:240:::0;:::o;10237:117:7:-;10294:4;10317:30;10339:7;10317:12;:21;;:30;;;;:::i;:::-;10310:37;;10237:117;;;:::o;590:104:2:-;643:15;677:10;670:17;;590:104;:::o;15893:155:7:-;15985:2;15958:15;:24;15974:7;15958:24;;;;;;;;;;;;:29;;;;;;;;;;;;;;;;;;16033:7;16029:2;16002:39;;16011:16;16019:7;16011;:16::i;:::-;16002:39;;;;;;;;;;;;15893:155;;:::o;7023:121:13:-;7092:7;7118:19;7126:3;:10;;7118:7;:19::i;:::-;7111:26;;7023:121;;;:::o;10512:329:7:-;10597:4;10621:16;10629:7;10621;:16::i;:::-;10613:73;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10696:13;10712:16;10720:7;10712;:16::i;:::-;10696:32;;10757:5;10746:16;;:7;:16;;;:51;;;;10790:7;10766:31;;:20;10778:7;10766:11;:20::i;:::-;:31;;;10746:51;:87;;;;10801:32;10818:5;10825:7;10801:16;:32::i;:::-;10746:87;10738:96;;;10512:329;;;;:::o;13506:559::-;13623:4;13603:24;;:16;13611:7;13603;:16::i;:::-;:24;;;13595:78;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13705:1;13691:16;;:2;:16;;;;13683:65;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13759:39;13780:4;13786:2;13790:7;13759:20;:39::i;:::-;13860:29;13877:1;13881:7;13860:8;:29::i;:::-;13900:35;13927:7;13900:13;:19;13914:4;13900:19;;;;;;;;;;;;;;;:26;;:35;;;;:::i;:::-;;13945:30;13967:7;13945:13;:17;13959:2;13945:17;;;;;;;;;;;;;;;:21;;:30;;;;:::i;:::-;;13986:29;14003:7;14012:2;13986:12;:16;;:29;;;;;:::i;:::-;;14050:7;14046:2;14031:27;;14040:4;14031:27;;;;;;;;;;;;13506:559;;;:::o;7649:135:14:-;7720:7;7754:22;7758:3;:10;;7770:5;7754:3;:22::i;:::-;7746:31;;7739:38;;7649:135;;;;:::o;14647:98:7:-;14730:8;14719;:19;;;;;;;;;;;;:::i;:::-;;14647:98;:::o;12070:393::-;12163:1;12149:16;;:2;:16;;;;12141:61;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;12221:16;12229:7;12221;:16::i;:::-;12220:17;12212:58;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;12281:45;12310:1;12314:2;12318:7;12281:20;:45::i;:::-;12337:30;12359:7;12337:13;:17;12351:2;12337:17;;;;;;;;;;;;;;;:21;;:30;;;;:::i;:::-;;12378:29;12395:7;12404:2;12378:12;:16;;:29;;;;;:::i;:::-;;12448:7;12444:2;12423:33;;12440:1;12423:33;;;;;;;;;;;;12070:393;;:::o;7472:224:13:-;7552:7;7561;7581:11;7594:13;7611:22;7615:3;:10;;7627:5;7611:3;:22::i;:::-;7580:53;;;;7659:3;7651:12;;7681:5;7673:14;;7643:46;;;;;;7472:224;;;;;:::o;8115:202::-;8222:7;8264:44;8269:3;:10;;8289:3;8281:12;;8295;8264:4;:44::i;:::-;8256:53;;8241:69;;8115:202;;;;;:::o;7205:112:14:-;7265:7;7291:19;7299:3;:10;;7291:7;:19::i;:::-;7284:26;;7205:112;;;:::o;9665:269:7:-;9778:28;9788:4;9794:2;9798:7;9778:9;:28::i;:::-;9824:48;9847:4;9853:2;9857:7;9866:5;9824:22;:48::i;:::-;9816:111;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9665:269;;;;:::o;202:723:15:-;258:13;484:1;475:5;:10;471:51;;;501:10;;;;;;;;;;;;;;;;;;;;;471:51;531:12;546:5;531:20;;561:14;585:75;600:1;592:4;:9;585:75;;617:8;;;;;;;647:2;639:10;;;;;;;;;585:75;;;669:19;701:6;691:17;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;669:39;;718:13;743:1;734:6;:10;718:26;;761:5;754:12;;776:112;791:1;783:4;:9;776:112;;849:2;842:4;:9;;;;;;837:2;:14;826:27;;808:6;815:7;;;;;;;808:15;;;;;;;;;;;:45;;;;;;;;;;;875:2;867:10;;;;;;;;;776:112;;;911:6;897:21;;;;;;202:723;;;;:::o;6791:149:13:-;6875:4;6898:35;6908:3;:10;;6928:3;6920:12;;6898:9;:35::i;:::-;6891:42;;6791:149;;;;:::o;4483:108::-;4539:7;4565:3;:12;;:19;;;;4558:26;;4483:108;;;:::o;16644:93:7:-;;;;:::o;6764:135:14:-;6834:4;6857:35;6865:3;:10;;6885:5;6877:14;;6857:7;:35::i;:::-;6850:42;;6764:135;;;;:::o;6467:129::-;6534:4;6557:32;6562:3;:10;;6582:5;6574:14;;6557:4;:32::i;:::-;6550:39;;6467:129;;;;:::o;6239:174:13:-;6328:4;6351:55;6356:3;:10;;6376:3;6368:12;;6398:5;6390:14;;6382:23;;6351:4;:55::i;:::-;6344:62;;6239:174;;;;;:::o;4423:201:14:-;4490:7;4538:5;4517:3;:11;;:18;;;;:26;4509:73;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4599:3;:11;;4611:5;4599:18;;;;;;;;;;;;;;;;4592:25;;4423:201;;;;:::o;4934:274:13:-;5001:7;5010;5059:5;5037:3;:12;;:19;;;;:27;5029:74;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5114:22;5139:3;:12;;5152:5;5139:19;;;;;;;;;;;;;;;;;;5114:44;;5176:5;:10;;;5188:5;:12;;;5168:33;;;;;4934:274;;;;;:::o;5615:315::-;5709:7;5728:16;5747:3;:12;;:17;5760:3;5747:17;;;;;;;;;;;;5728:36;;5794:1;5782:8;:13;;5797:12;5774:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5863:3;:12;;5887:1;5876:8;:12;5863:26;;;;;;;;;;;;;;;;;;:33;;;5856:40;;;5615:315;;;;;:::o;3984:107:14:-;4040:7;4066:3;:11;;:18;;;;4059:25;;3984:107;;;:::o;15298:589:7:-;15418:4;15443:15;:2;:13;;;:15::i;:::-;15438:58;;15481:4;15474:11;;;;15438:58;15505:23;15531:246;15583:45;;;15642:12;:10;:12::i;:::-;15668:4;15686:7;15707:5;15547:175;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;15531:246;;;;;;;;;;;;;;;;;:2;:15;;;;:246;;;;;:::i;:::-;15505:272;;15787:13;15814:10;15803:32;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;15787:48;;1068:10;15863:16;;15853:26;;;:6;:26;;;;15845:35;;;;15298:589;;;;;;;:::o;4270:123:13:-;4341:4;4385:1;4364:3;:12;;:17;4377:3;4364:17;;;;;;;;;;;;:22;;4357:29;;4270:123;;;;:::o;2183:1512:14:-;2249:4;2365:18;2386:3;:12;;:19;2399:5;2386:19;;;;;;;;;;;;2365:40;;2434:1;2420:10;:15;2416:1273;;2777:21;2814:1;2801:10;:14;2777:38;;2829:17;2870:1;2849:3;:11;;:18;;;;:22;2829:42;;3111:17;3131:3;:11;;3143:9;3131:22;;;;;;;;;;;;;;;;3111:42;;3274:9;3245:3;:11;;3257:13;3245:26;;;;;;;;;;;;;;;:38;;;;3391:1;3375:13;:17;3349:3;:12;;:23;3362:9;3349:23;;;;;;;;;;;:43;;;;3498:3;:11;;:17;;;;;;;;;;;;;;;;;;;;;;;;3590:3;:12;;:19;3603:5;3590:19;;;;;;;;;;;3583:26;;;3631:4;3624:11;;;;;;;;2416:1273;3673:5;3666:12;;;2183:1512;;;;;:::o;1611:404::-;1674:4;1695:21;1705:3;1710:5;1695:9;:21::i;:::-;1690:319;;1732:3;:11;;1749:5;1732:23;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1912:3;:11;;:18;;;;1890:3;:12;;:19;1903:5;1890:19;;;;;;;;;;;:40;;;;1951:4;1944:11;;;;1690:319;1993:5;1986:12;;1611:404;;;;;:::o;1828:678:13:-;1904:4;2018:16;2037:3;:12;;:17;2050:3;2037:17;;;;;;;;;;;;2018:36;;2081:1;2069:8;:13;2065:435;;;2135:3;:12;;2153:38;;;;;;;;2170:3;2153:38;;;;2183:5;2153:38;;;2135:57;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2347:3;:12;;:19;;;;2327:3;:12;;:17;2340:3;2327:17;;;;;;;;;;;:39;;;;2387:4;2380:11;;;;;2065:435;2458:5;2422:3;:12;;2446:1;2435:8;:12;2422:26;;;;;;;;;;;;;;;;;;:33;;:41;;;;2484:5;2477:12;;;1828:678;;;;;;:::o;718:610:12:-;778:4;1036:16;1062:19;1084:66;1062:88;;;;1251:7;1239:20;1227:32;;1290:11;1278:8;:23;;:42;;;;;1317:3;1305:15;;:8;:15;;1278:42;1270:51;;;;718:610;;;:::o;3770:194::-;3873:12;3904:53;3927:6;3935:4;3941:1;3944:12;3904:22;:53::i;:::-;3897:60;;3770:194;;;;;:::o;3776:127:14:-;3849:4;3895:1;3872:3;:12;;:19;3885:5;3872:19;;;;;;;;;;;;:24;;3865:31;;3776:127;;;;:::o;5117:958:12:-;5247:12;5279:18;5290:6;5279:10;:18::i;:::-;5271:60;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5402:12;5416:23;5443:6;:11;;5463:8;5474:4;5443:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5401:78;;;;5493:7;5489:580;;;5523:10;5516:17;;;;;;5489:580;5654:1;5634:10;:17;:21;5630:429;;;5892:10;5886:17;5952:15;5939:10;5935:2;5931:19;5924:44;5841:145;6031:12;6024:20;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5117:958;;;;;;;:::o;-1:-1:-1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;7:139:16:-;;91:6;78:20;69:29;;107:33;134:5;107:33;:::i;:::-;59:87;;;;:::o;152:133::-;;233:6;220:20;211:29;;249:30;273:5;249:30;:::i;:::-;201:84;;;;:::o;291:137::-;;374:6;361:20;352:29;;390:32;416:5;390:32;:::i;:::-;342:86;;;;:::o;434:464::-;;538:3;531:4;523:6;519:17;515:27;505:2;;556:1;553;546:12;505:2;596:6;583:20;621:64;636:48;677:6;636:48;:::i;:::-;621:64;:::i;:::-;612:73;;708:6;701:5;694:21;747:4;739:6;735:17;783:4;776:5;772:16;821:3;812:6;807:3;803:16;800:25;797:2;;;838:1;835;828:12;797:2;851:41;885:6;880:3;875;851:41;:::i;:::-;495:403;;;;;;;:::o;904:466::-;;1009:3;1002:4;994:6;990:17;986:27;976:2;;1027:1;1024;1017:12;976:2;1067:6;1054:20;1092:65;1107:49;1149:6;1107:49;:::i;:::-;1092:65;:::i;:::-;1083:74;;1180:6;1173:5;1166:21;1219:4;1211:6;1207:17;1255:4;1248:5;1244:16;1293:3;1284:6;1279:3;1275:16;1272:25;1269:2;;;1310:1;1307;1300:12;1269:2;1323:41;1357:6;1352:3;1347;1323:41;:::i;:::-;966:404;;;;;;;:::o;1418:1139::-;;1540:4;1528:9;1523:3;1519:19;1515:30;1512:2;;;1558:1;1555;1548:12;1512:2;1580:20;1595:4;1580:20;:::i;:::-;1571:29;;1687:1;1676:9;1672:17;1659:31;1717:18;1709:6;1706:30;1703:2;;;1749:1;1746;1739:12;1703:2;1791:59;1846:3;1837:6;1826:9;1822:22;1791:59;:::i;:::-;1784:4;1777:5;1773:16;1766:85;1610:252;1949:2;1938:9;1934:18;1921:32;1980:18;1972:6;1969:30;1966:2;;;2012:1;2009;2002:12;1966:2;2054:58;2108:3;2099:6;2088:9;2084:22;2054:58;:::i;:::-;2047:4;2040:5;2036:16;2029:84;1872:252;2214:2;2203:9;2199:18;2186:32;2245:18;2237:6;2234:30;2231:2;;;2277:1;2274;2267:12;2231:2;2319:58;2373:3;2364:6;2353:9;2349:22;2319:58;:::i;:::-;2312:4;2305:5;2301:16;2294:84;2134:255;2451:2;2491:47;2534:3;2525:6;2514:9;2510:22;2491:47;:::i;:::-;2484:4;2477:5;2473:16;2466:73;2399:151;1502:1055;;;;:::o;2563:139::-;;2647:6;2634:20;2625:29;;2663:33;2690:5;2663:33;:::i;:::-;2615:87;;;;:::o;2708:135::-;;2790:6;2777:20;2768:29;;2806:31;2831:5;2806:31;:::i;:::-;2758:85;;;;:::o;2849:260::-;;2957:2;2945:9;2936:7;2932:23;2928:32;2925:2;;;2973:1;2970;2963:12;2925:2;3015:1;3039:53;3084:7;3075:6;3064:9;3060:22;3039:53;:::i;:::-;3029:63;;2987:115;2915:194;;;;:::o;3115:403::-;;;3240:2;3228:9;3219:7;3215:23;3211:32;3208:2;;;3256:1;3253;3246:12;3208:2;3298:1;3322:53;3367:7;3358:6;3347:9;3343:22;3322:53;:::i;:::-;3312:63;;3270:115;3423:2;3448:53;3493:7;3484:6;3473:9;3469:22;3448:53;:::i;:::-;3438:63;;3395:116;3198:320;;;;;:::o;3524:546::-;;;;3666:2;3654:9;3645:7;3641:23;3637:32;3634:2;;;3682:1;3679;3672:12;3634:2;3724:1;3748:53;3793:7;3784:6;3773:9;3769:22;3748:53;:::i;:::-;3738:63;;3696:115;3849:2;3874:53;3919:7;3910:6;3899:9;3895:22;3874:53;:::i;:::-;3864:63;;3821:116;3975:2;4000:53;4045:7;4036:6;4025:9;4021:22;4000:53;:::i;:::-;3990:63;;3947:116;3624:446;;;;;:::o;4076:801::-;;;;;4244:3;4232:9;4223:7;4219:23;4215:33;4212:2;;;4261:1;4258;4251:12;4212:2;4303:1;4327:53;4372:7;4363:6;4352:9;4348:22;4327:53;:::i;:::-;4317:63;;4275:115;4428:2;4453:53;4498:7;4489:6;4478:9;4474:22;4453:53;:::i;:::-;4443:63;;4400:116;4554:2;4579:53;4624:7;4615:6;4604:9;4600:22;4579:53;:::i;:::-;4569:63;;4526:116;4708:2;4697:9;4693:18;4680:32;4739:18;4731:6;4728:30;4725:2;;;4771:1;4768;4761:12;4725:2;4798:62;4852:7;4843:6;4832:9;4828:22;4798:62;:::i;:::-;4788:72;;4652:218;4202:675;;;;;;;:::o;4883:397::-;;;5005:2;4993:9;4984:7;4980:23;4976:32;4973:2;;;5021:1;5018;5011:12;4973:2;5063:1;5087:53;5132:7;5123:6;5112:9;5108:22;5087:53;:::i;:::-;5077:63;;5035:115;5188:2;5213:50;5255:7;5246:6;5235:9;5231:22;5213:50;:::i;:::-;5203:60;;5160:113;4963:317;;;;;:::o;5286:403::-;;;5411:2;5399:9;5390:7;5386:23;5382:32;5379:2;;;5427:1;5424;5417:12;5379:2;5469:1;5493:53;5538:7;5529:6;5518:9;5514:22;5493:53;:::i;:::-;5483:63;;5441:115;5594:2;5619:53;5664:7;5655:6;5644:9;5640:22;5619:53;:::i;:::-;5609:63;;5566:116;5369:320;;;;;:::o;5695:258::-;;5802:2;5790:9;5781:7;5777:23;5773:32;5770:2;;;5818:1;5815;5808:12;5770:2;5860:1;5884:52;5928:7;5919:6;5908:9;5904:22;5884:52;:::i;:::-;5874:62;;5832:114;5760:193;;;;:::o;5959:373::-;;6077:2;6065:9;6056:7;6052:23;6048:32;6045:2;;;6093:1;6090;6083:12;6045:2;6163:1;6152:9;6148:17;6135:31;6193:18;6185:6;6182:30;6179:2;;;6225:1;6222;6215:12;6179:2;6252:63;6307:7;6298:6;6287:9;6283:22;6252:63;:::i;:::-;6242:73;;6107:218;6035:297;;;;:::o;6338:411::-;;6475:2;6463:9;6454:7;6450:23;6446:32;6443:2;;;6491:1;6488;6481:12;6443:2;6561:1;6550:9;6546:17;6533:31;6591:18;6583:6;6580:30;6577:2;;;6623:1;6620;6613:12;6577:2;6650:82;6724:7;6715:6;6704:9;6700:22;6650:82;:::i;:::-;6640:92;;6505:237;6433:316;;;;:::o;6755:260::-;;6863:2;6851:9;6842:7;6838:23;6834:32;6831:2;;;6879:1;6876;6869:12;6831:2;6921:1;6945:53;6990:7;6981:6;6970:9;6966:22;6945:53;:::i;:::-;6935:63;;6893:115;6821:194;;;;:::o;7021:403::-;;;7146:2;7134:9;7125:7;7121:23;7117:32;7114:2;;;7162:1;7159;7152:12;7114:2;7204:1;7228:53;7273:7;7264:6;7253:9;7249:22;7228:53;:::i;:::-;7218:63;;7176:115;7329:2;7354:53;7399:7;7390:6;7379:9;7375:22;7354:53;:::i;:::-;7344:63;;7301:116;7104:320;;;;;:::o;7430:256::-;;7536:2;7524:9;7515:7;7511:23;7507:32;7504:2;;;7552:1;7549;7542:12;7504:2;7594:1;7618:51;7661:7;7652:6;7641:9;7637:22;7618:51;:::i;:::-;7608:61;;7566:113;7494:192;;;;:::o;7692:399::-;;;7815:2;7803:9;7794:7;7790:23;7786:32;7783:2;;;7831:1;7828;7821:12;7783:2;7873:1;7897:51;7940:7;7931:6;7920:9;7916:22;7897:51;:::i;:::-;7887:61;;7845:113;7996:2;8021:53;8066:7;8057:6;8046:9;8042:22;8021:53;:::i;:::-;8011:63;;7968:116;7773:318;;;;;:::o;8097:260::-;;8253:98;8347:3;8339:6;8253:98;:::i;:::-;8239:112;;8229:128;;;;:::o;8363:108::-;8440:24;8458:5;8440:24;:::i;:::-;8435:3;8428:37;8418:53;;:::o;8477:118::-;8564:24;8582:5;8564:24;:::i;:::-;8559:3;8552:37;8542:53;;:::o;8679:1119::-;;8879:80;8953:5;8879:80;:::i;:::-;8975:112;9080:6;9075:3;8975:112;:::i;:::-;8968:119;;9113:3;9158:4;9150:6;9146:17;9141:3;9137:27;9188:82;9264:5;9188:82;:::i;:::-;9293:7;9324:1;9309:444;9334:6;9331:1;9328:13;9309:444;;;9405:9;9399:4;9395:20;9390:3;9383:33;9456:6;9450:13;9484:116;9595:4;9580:13;9484:116;:::i;:::-;9476:124;;9623:86;9702:6;9623:86;:::i;:::-;9613:96;;9738:4;9733:3;9729:14;9722:21;;9369:384;9356:1;9353;9349:9;9344:14;;9309:444;;;9313:14;9769:4;9762:11;;9789:3;9782:10;;8855:943;;;;;;;;;:::o;9804:109::-;9885:21;9900:5;9885:21;:::i;:::-;9880:3;9873:34;9863:50;;:::o;9919:360::-;;10033:38;10065:5;10033:38;:::i;:::-;10087:70;10150:6;10145:3;10087:70;:::i;:::-;10080:77;;10166:52;10211:6;10206:3;10199:4;10192:5;10188:16;10166:52;:::i;:::-;10243:29;10265:6;10243:29;:::i;:::-;10238:3;10234:39;10227:46;;10009:270;;;;;:::o;10285:344::-;;10391:39;10424:5;10391:39;:::i;:::-;10446:61;10500:6;10495:3;10446:61;:::i;:::-;10439:68;;10516:52;10561:6;10556:3;10549:4;10542:5;10538:16;10516:52;:::i;:::-;10593:29;10615:6;10593:29;:::i;:::-;10588:3;10584:39;10577:46;;10367:262;;;;;:::o;10635:364::-;;10751:39;10784:5;10751:39;:::i;:::-;10806:71;10870:6;10865:3;10806:71;:::i;:::-;10799:78;;10886:52;10931:6;10926:3;10919:4;10912:5;10908:16;10886:52;:::i;:::-;10963:29;10985:6;10963:29;:::i;:::-;10958:3;10954:39;10947:46;;10727:272;;;;;:::o;11005:368::-;;11168:67;11232:2;11227:3;11168:67;:::i;:::-;11161:74;;11265:34;11261:1;11256:3;11252:11;11245:55;11331:6;11326:2;11321:3;11317:12;11310:28;11364:2;11359:3;11355:12;11348:19;;11151:222;;;:::o;11453:781::-;;11600:4;11595:3;11591:14;11687:4;11680:5;11676:16;11670:23;11740:3;11734:4;11730:14;11723:4;11718:3;11714:14;11707:38;11766:73;11834:4;11820:12;11766:73;:::i;:::-;11758:81;;11615:235;11934:4;11927:5;11923:16;11917:23;11953:63;12010:4;12005:3;12001:14;11987:12;11953:63;:::i;:::-;11860:166;12115:4;12108:5;12104:16;12098:23;12134:63;12191:4;12186:3;12182:14;12168:12;12134:63;:::i;:::-;12036:171;12224:4;12217:11;;11569:665;;;;;:::o;12314:791::-;;12471:4;12466:3;12462:14;12558:4;12551:5;12547:16;12541:23;12611:3;12605:4;12601:14;12594:4;12589:3;12585:14;12578:38;12637:73;12705:4;12691:12;12637:73;:::i;:::-;12629:81;;12486:235;12805:4;12798:5;12794:16;12788:23;12824:63;12881:4;12876:3;12872:14;12858:12;12824:63;:::i;:::-;12731:166;12986:4;12979:5;12975:16;12969:23;13005:63;13062:4;13057:3;13053:14;13039:12;13005:63;:::i;:::-;12907:171;13095:4;13088:11;;12440:665;;;;;:::o;13111:108::-;13188:24;13206:5;13188:24;:::i;:::-;13183:3;13176:37;13166:53;;:::o;13225:118::-;13312:24;13330:5;13312:24;:::i;:::-;13307:3;13300:37;13290:53;;:::o;13349:112::-;13432:22;13448:5;13432:22;:::i;:::-;13427:3;13420:35;13410:51;;:::o;13467:222::-;;13598:2;13587:9;13583:18;13575:26;;13611:71;13679:1;13668:9;13664:17;13655:6;13611:71;:::i;:::-;13565:124;;;;:::o;13695:477::-;;13928:2;13917:9;13913:18;13905:26;;13977:9;13971:4;13967:20;13963:1;13952:9;13948:17;13941:47;14005:160;14160:4;14151:6;14005:160;:::i;:::-;13997:168;;13895:277;;;;:::o;14178:210::-;;14303:2;14292:9;14288:18;14280:26;;14316:65;14378:1;14367:9;14363:17;14354:6;14316:65;:::i;:::-;14270:118;;;;:::o;14394:608::-;;14613:2;14602:9;14598:18;14590:26;;14662:9;14656:4;14652:20;14648:1;14637:9;14633:17;14626:47;14690:76;14761:4;14752:6;14690:76;:::i;:::-;14682:84;;14813:9;14807:4;14803:20;14798:2;14787:9;14783:18;14776:48;14841:76;14912:4;14903:6;14841:76;:::i;:::-;14833:84;;14927:68;14991:2;14980:9;14976:18;14967:6;14927:68;:::i;:::-;14580:422;;;;;;:::o;15008:313::-;;15159:2;15148:9;15144:18;15136:26;;15208:9;15202:4;15198:20;15194:1;15183:9;15179:17;15172:47;15236:78;15309:4;15300:6;15236:78;:::i;:::-;15228:86;;15126:195;;;;:::o;15327:533::-;;15534:2;15523:9;15519:18;15511:26;;15583:9;15577:4;15573:20;15569:1;15558:9;15554:17;15547:47;15611:78;15684:4;15675:6;15611:78;:::i;:::-;15603:86;;15699:72;15767:2;15756:9;15752:18;15743:6;15699:72;:::i;:::-;15781;15849:2;15838:9;15834:18;15825:6;15781:72;:::i;:::-;15501:359;;;;;;:::o;15866:419::-;;16070:2;16059:9;16055:18;16047:26;;16119:9;16113:4;16109:20;16105:1;16094:9;16090:17;16083:47;16147:131;16273:4;16147:131;:::i;:::-;16139:139;;16037:248;;;:::o;16291:377::-;;16474:2;16463:9;16459:18;16451:26;;16523:9;16517:4;16513:20;16509:1;16498:9;16494:17;16487:47;16551:110;16656:4;16647:6;16551:110;:::i;:::-;16543:118;;16441:227;;;;:::o;16674:222::-;;16805:2;16794:9;16790:18;16782:26;;16818:71;16886:1;16875:9;16871:17;16862:6;16818:71;:::i;:::-;16772:124;;;;:::o;16902:278::-;;16968:2;16962:9;16952:19;;17010:4;17002:6;16998:17;17117:6;17105:10;17102:22;17081:18;17069:10;17066:34;17063:62;17060:2;;;17128:13;;:::i;:::-;17060:2;17163:10;17159:2;17152:22;16942:238;;;;:::o;17186:326::-;;17337:18;17329:6;17326:30;17323:2;;;17359:13;;:::i;:::-;17323:2;17439:4;17435:9;17428:4;17420:6;17416:17;17412:33;17404:41;;17500:4;17494;17490:15;17482:23;;17252:260;;;:::o;17518:327::-;;17670:18;17662:6;17659:30;17656:2;;;17692:13;;:::i;:::-;17656:2;17772:4;17768:9;17761:4;17753:6;17749:17;17745:33;17737:41;;17833:4;17827;17823:15;17815:23;;17585:260;;;:::o;17851:158::-;;17967:3;17959:11;;17997:4;17992:3;17988:14;17980:22;;17949:60;;;:::o;18015:140::-;;18142:5;18136:12;18126:22;;18115:40;;;:::o;18161:98::-;;18246:5;18240:12;18230:22;;18219:40;;;:::o;18265:99::-;;18351:5;18345:12;18335:22;;18324:40;;;:::o;18370:139::-;;18498:4;18493:3;18489:14;18481:22;;18471:38;;;:::o;18515:210::-;;18674:6;18669:3;18662:19;18714:4;18709:3;18705:14;18690:29;;18652:73;;;;:::o;18731:168::-;;18848:6;18843:3;18836:19;18888:4;18883:3;18879:14;18864:29;;18826:73;;;;:::o;18905:159::-;;19013:6;19008:3;19001:19;19053:4;19048:3;19044:14;19029:29;;18991:73;;;;:::o;19070:169::-;;19188:6;19183:3;19176:19;19228:4;19223:3;19219:14;19204:29;;19166:73;;;;:::o;19245:96::-;;19311:24;19329:5;19311:24;:::i;:::-;19300:35;;19290:51;;;:::o;19347:90::-;;19424:5;19417:13;19410:21;19399:32;;19389:48;;;:::o;19443:149::-;;19519:66;19512:5;19508:78;19497:89;;19487:105;;;:::o;19598:126::-;;19675:42;19668:5;19664:54;19653:65;;19643:81;;;:::o;19730:77::-;;19796:5;19785:16;;19775:32;;;:::o;19813:86::-;;19888:4;19881:5;19877:16;19866:27;;19856:43;;;:::o;19905:154::-;19989:6;19984:3;19979;19966:30;20051:1;20042:6;20037:3;20033:16;20026:27;19956:103;;;:::o;20065:307::-;20133:1;20143:113;20157:6;20154:1;20151:13;20143:113;;;20242:1;20237:3;20233:11;20227:18;20223:1;20218:3;20214:11;20207:39;20179:2;20176:1;20172:10;20167:15;;20143:113;;;20274:6;20271:1;20268:13;20265:2;;;20354:1;20345:6;20340:3;20336:16;20329:27;20265:2;20114:258;;;;:::o;20378:48::-;20411:9;20432:102;;20524:2;20520:7;20515:2;20508:5;20504:14;20500:28;20490:38;;20480:54;;;:::o;20540:122::-;20613:24;20631:5;20613:24;:::i;:::-;20606:5;20603:35;20593:2;;20652:1;20649;20642:12;20593:2;20583:79;:::o;20668:116::-;20738:21;20753:5;20738:21;:::i;:::-;20731:5;20728:32;20718:2;;20774:1;20771;20764:12;20718:2;20708:76;:::o;20790:120::-;20862:23;20879:5;20862:23;:::i;:::-;20855:5;20852:34;20842:2;;20900:1;20897;20890:12;20842:2;20832:78;:::o;20916:122::-;20989:24;21007:5;20989:24;:::i;:::-;20982:5;20979:35;20969:2;;21028:1;21025;21018:12;20969:2;20959:79;:::o;21044:118::-;21115:22;21131:5;21115:22;:::i;:::-;21108:5;21105:33;21095:2;;21152:1;21149;21142:12;21095:2;21085:77;:::o",
  source:
    '// SPDX-License-Identifier: MIT\npragma solidity ^0.7.0;\npragma experimental ABIEncoderV2;\n\nimport "@openzeppelin/contracts/access/Ownable.sol";\nimport "@openzeppelin/contracts/token/ERC721/ERC721.sol";\n\ncontract PixelChainMax is ERC721, Ownable {\n    event PixelChainCreated(uint256 indexed tokenId, bytes data, bytes palette, uint8 version);\n\n    struct PixelChain {\n        string name;\n        address author;\n        uint256 blockNumber;\n    }\n\n    struct NewPixelChain {\n        string name;\n        bytes data;\n        bytes palette;\n        uint8 version;\n    }\n\n    uint256 defaultMintPrice = 0;\n\n    mapping(address => bool) addressBlacklist;\n    mapping(address => bool) addressWhitelist;\n    mapping(uint8 => bool) versionWhitelist;\n    mapping(uint8 => uint256) mintPricePerVersion;\n\n    PixelChain[] public pixelChains;\n\n    constructor() ERC721("PixelChain Max", "PXCM") {}\n\n    function create(NewPixelChain memory _pixelChain) external payable {\n        uint256 mintPrice = defaultMintPrice;\n        if (mintPricePerVersion[_pixelChain.version] > 0) {\n            mintPrice = mintPricePerVersion[_pixelChain.version];\n        }\n\n        require(msg.value >= mintPrice, "Not enough ether to mint this token!");\n\n        pixelChains.push(\n            PixelChain(_pixelChain.name, msg.sender, block.number)\n        );\n\n        uint256 id = pixelChains.length - 1;\n        _mint(msg.sender, id);\n\n        emit PixelChainCreated(id, _pixelChain.data, _pixelChain.palette, _pixelChain.version);\n    }\n\n    function retrieveAll(uint256 _start, uint256 _end) external view returns (PixelChain[] memory) {\n        uint256 end = _end;\n        if (_end > pixelChains.length) {\n            end = pixelChains.length;\n        }\n\n        uint256 arraySize;\n        if (_start > end) {\n            arraySize = 0;\n        } else {\n            arraySize = end - _start;\n        }\n\n        PixelChain[] memory response = new PixelChain[](arraySize);\n\n        uint x = 0;\n        for (uint i = _start; i < end; i++) {\n            response[x] = pixelChains[i];\n            x++;\n        }\n\n        return response;\n    }\n\n    function retrieve(uint256 _id) external view returns (PixelChain memory) {\n        return pixelChains[_id];\n    }\n\n    function setBaseTokenURI(string memory _uri) external onlyOwner {\n        _setBaseURI(_uri);\n    }\n\n    function withdraw() external onlyOwner {\n        msg.sender.transfer(address(this).balance);\n    }\n\n    function setDefaultMintPrice(uint256 _price) external onlyOwner {\n        defaultMintPrice = _price;\n    }\n\n    function setMintPricePerVersion(uint8 _version, uint256 _price) external onlyOwner {\n        mintPricePerVersion[_version] = _price;\n    }\n\n    function addAddressToBlacklist(address _address) external onlyOwner {\n        addressBlacklist[_address] = true;\n    }\n\n    function removeAddressFromBlacklist(address _address) external onlyOwner {\n        addressBlacklist[_address] = false;\n    }\n\n    function addAddressToWhitelist(address _address) external onlyOwner {\n        addressWhitelist[_address] = true;\n    }\n\n    function removeAddressFromWhitelist(address _address) external onlyOwner {\n        addressWhitelist[_address] = false;\n    }\n\n    function addVersionToWhitelist(uint8 _version) external onlyOwner {\n        versionWhitelist[_version] = true;\n    }\n\n    function removeVersionFromWhitelist(uint8 _version) external onlyOwner {\n        versionWhitelist[_version] = false;\n    }\n\n    function baseTokenURI() external view returns (string memory) {\n        return baseURI();\n    }\n}\n',
  sourcePath: "/home/nahuel/3dge/PixelChainMax-Contract/contracts/PixelChainMax.sol",
  ast: {
    absolutePath: "/home/nahuel/3dge/PixelChainMax-Contract/contracts/PixelChainMax.sol",
    exportedSymbols: {
      Address: [2138],
      Context: [437],
      ERC165: [603],
      ERC721: [1742],
      EnumerableMap: [2593],
      EnumerableSet: [2988],
      IERC165: [615],
      IERC721: [1858],
      IERC721Enumerable: [1889],
      IERC721Metadata: [1916],
      IERC721Receiver: [1934],
      Ownable: [546],
      PixelChainMax: [414],
      SafeMath: [811],
      Strings: [3075],
    },
    id: 415,
    license: "MIT",
    nodeType: "SourceUnit",
    nodes: [
      {
        id: 34,
        literals: ["solidity", "^", "0.7", ".0"],
        nodeType: "PragmaDirective",
        src: "32:23:1",
      },
      {
        id: 35,
        literals: ["experimental", "ABIEncoderV2"],
        nodeType: "PragmaDirective",
        src: "56:33:1",
      },
      {
        absolutePath: "@openzeppelin/contracts/access/Ownable.sol",
        file: "@openzeppelin/contracts/access/Ownable.sol",
        id: 36,
        nodeType: "ImportDirective",
        scope: 415,
        sourceUnit: 547,
        src: "91:52:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        absolutePath: "@openzeppelin/contracts/token/ERC721/ERC721.sol",
        file: "@openzeppelin/contracts/token/ERC721/ERC721.sol",
        id: 37,
        nodeType: "ImportDirective",
        scope: 415,
        sourceUnit: 1743,
        src: "144:57:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 38,
              name: "ERC721",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 1742,
              src: "229:6:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_ERC721_$1742",
                typeString: "contract ERC721",
              },
            },
            id: 39,
            nodeType: "InheritanceSpecifier",
            src: "229:6:1",
          },
          {
            baseName: {
              id: 40,
              name: "Ownable",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 546,
              src: "237:7:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_Ownable_$546",
                typeString: "contract Ownable",
              },
            },
            id: 41,
            nodeType: "InheritanceSpecifier",
            src: "237:7:1",
          },
        ],
        contractDependencies: [437, 546, 603, 615, 1742, 1858, 1889, 1916],
        contractKind: "contract",
        fullyImplemented: true,
        id: 414,
        linearizedBaseContracts: [414, 546, 1742, 1889, 1916, 1858, 603, 615, 437],
        name: "PixelChainMax",
        nodeType: "ContractDefinition",
        nodes: [
          {
            anonymous: false,
            id: 51,
            name: "PixelChainCreated",
            nodeType: "EventDefinition",
            parameters: {
              id: 50,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 43,
                  indexed: true,
                  mutability: "mutable",
                  name: "tokenId",
                  nodeType: "VariableDeclaration",
                  scope: 51,
                  src: "275:23:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 42,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "275:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 45,
                  indexed: false,
                  mutability: "mutable",
                  name: "data",
                  nodeType: "VariableDeclaration",
                  scope: 51,
                  src: "300:10:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 44,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "300:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 47,
                  indexed: false,
                  mutability: "mutable",
                  name: "palette",
                  nodeType: "VariableDeclaration",
                  scope: 51,
                  src: "312:13:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 46,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "312:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 49,
                  indexed: false,
                  mutability: "mutable",
                  name: "version",
                  nodeType: "VariableDeclaration",
                  scope: 51,
                  src: "327:13:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8",
                  },
                  typeName: {
                    id: 48,
                    name: "uint8",
                    nodeType: "ElementaryTypeName",
                    src: "327:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "274:67:1",
            },
            src: "251:91:1",
          },
          {
            canonicalName: "PixelChainMax.PixelChain",
            id: 58,
            members: [
              {
                constant: false,
                id: 53,
                mutability: "mutable",
                name: "name",
                nodeType: "VariableDeclaration",
                scope: 58,
                src: "376:11:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_string_storage_ptr",
                  typeString: "string",
                },
                typeName: {
                  id: 52,
                  name: "string",
                  nodeType: "ElementaryTypeName",
                  src: "376:6:1",
                  typeDescriptions: {
                    typeIdentifier: "t_string_storage_ptr",
                    typeString: "string",
                  },
                },
                visibility: "internal",
              },
              {
                constant: false,
                id: 55,
                mutability: "mutable",
                name: "author",
                nodeType: "VariableDeclaration",
                scope: 58,
                src: "397:14:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address",
                },
                typeName: {
                  id: 54,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "397:7:1",
                  stateMutability: "nonpayable",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                },
                visibility: "internal",
              },
              {
                constant: false,
                id: 57,
                mutability: "mutable",
                name: "blockNumber",
                nodeType: "VariableDeclaration",
                scope: 58,
                src: "421:19:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256",
                },
                typeName: {
                  id: 56,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "421:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                },
                visibility: "internal",
              },
            ],
            name: "PixelChain",
            nodeType: "StructDefinition",
            scope: 414,
            src: "348:99:1",
            visibility: "public",
          },
          {
            canonicalName: "PixelChainMax.NewPixelChain",
            id: 67,
            members: [
              {
                constant: false,
                id: 60,
                mutability: "mutable",
                name: "name",
                nodeType: "VariableDeclaration",
                scope: 67,
                src: "484:11:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_string_storage_ptr",
                  typeString: "string",
                },
                typeName: {
                  id: 59,
                  name: "string",
                  nodeType: "ElementaryTypeName",
                  src: "484:6:1",
                  typeDescriptions: {
                    typeIdentifier: "t_string_storage_ptr",
                    typeString: "string",
                  },
                },
                visibility: "internal",
              },
              {
                constant: false,
                id: 62,
                mutability: "mutable",
                name: "data",
                nodeType: "VariableDeclaration",
                scope: 67,
                src: "505:10:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bytes_storage_ptr",
                  typeString: "bytes",
                },
                typeName: {
                  id: 61,
                  name: "bytes",
                  nodeType: "ElementaryTypeName",
                  src: "505:5:1",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_storage_ptr",
                    typeString: "bytes",
                  },
                },
                visibility: "internal",
              },
              {
                constant: false,
                id: 64,
                mutability: "mutable",
                name: "palette",
                nodeType: "VariableDeclaration",
                scope: 67,
                src: "525:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bytes_storage_ptr",
                  typeString: "bytes",
                },
                typeName: {
                  id: 63,
                  name: "bytes",
                  nodeType: "ElementaryTypeName",
                  src: "525:5:1",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_storage_ptr",
                    typeString: "bytes",
                  },
                },
                visibility: "internal",
              },
              {
                constant: false,
                id: 66,
                mutability: "mutable",
                name: "version",
                nodeType: "VariableDeclaration",
                scope: 67,
                src: "548:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint8",
                  typeString: "uint8",
                },
                typeName: {
                  id: 65,
                  name: "uint8",
                  nodeType: "ElementaryTypeName",
                  src: "548:5:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8",
                  },
                },
                visibility: "internal",
              },
            ],
            name: "NewPixelChain",
            nodeType: "StructDefinition",
            scope: 414,
            src: "453:115:1",
            visibility: "public",
          },
          {
            constant: false,
            id: 70,
            mutability: "mutable",
            name: "defaultMintPrice",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "574:28:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256",
            },
            typeName: {
              id: 68,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "574:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256",
              },
            },
            value: {
              hexValue: "30",
              id: 69,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "number",
              lValueRequested: false,
              nodeType: "Literal",
              src: "601:1:1",
              typeDescriptions: {
                typeIdentifier: "t_rational_0_by_1",
                typeString: "int_const 0",
              },
              value: "0",
            },
            visibility: "internal",
          },
          {
            constant: false,
            id: 74,
            mutability: "mutable",
            name: "addressBlacklist",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "609:41:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
              typeString: "mapping(address => bool)",
            },
            typeName: {
              id: 73,
              keyType: {
                id: 71,
                name: "address",
                nodeType: "ElementaryTypeName",
                src: "617:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address",
                },
              },
              nodeType: "Mapping",
              src: "609:24:1",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                typeString: "mapping(address => bool)",
              },
              valueType: {
                id: 72,
                name: "bool",
                nodeType: "ElementaryTypeName",
                src: "628:4:1",
                typeDescriptions: {
                  typeIdentifier: "t_bool",
                  typeString: "bool",
                },
              },
            },
            visibility: "internal",
          },
          {
            constant: false,
            id: 78,
            mutability: "mutable",
            name: "addressWhitelist",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "656:41:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
              typeString: "mapping(address => bool)",
            },
            typeName: {
              id: 77,
              keyType: {
                id: 75,
                name: "address",
                nodeType: "ElementaryTypeName",
                src: "664:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address",
                },
              },
              nodeType: "Mapping",
              src: "656:24:1",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                typeString: "mapping(address => bool)",
              },
              valueType: {
                id: 76,
                name: "bool",
                nodeType: "ElementaryTypeName",
                src: "675:4:1",
                typeDescriptions: {
                  typeIdentifier: "t_bool",
                  typeString: "bool",
                },
              },
            },
            visibility: "internal",
          },
          {
            constant: false,
            id: 82,
            mutability: "mutable",
            name: "versionWhitelist",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "703:39:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint8_$_t_bool_$",
              typeString: "mapping(uint8 => bool)",
            },
            typeName: {
              id: 81,
              keyType: {
                id: 79,
                name: "uint8",
                nodeType: "ElementaryTypeName",
                src: "711:5:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint8",
                  typeString: "uint8",
                },
              },
              nodeType: "Mapping",
              src: "703:22:1",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint8_$_t_bool_$",
                typeString: "mapping(uint8 => bool)",
              },
              valueType: {
                id: 80,
                name: "bool",
                nodeType: "ElementaryTypeName",
                src: "720:4:1",
                typeDescriptions: {
                  typeIdentifier: "t_bool",
                  typeString: "bool",
                },
              },
            },
            visibility: "internal",
          },
          {
            constant: false,
            id: 86,
            mutability: "mutable",
            name: "mintPricePerVersion",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "748:45:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint8_$_t_uint256_$",
              typeString: "mapping(uint8 => uint256)",
            },
            typeName: {
              id: 85,
              keyType: {
                id: 83,
                name: "uint8",
                nodeType: "ElementaryTypeName",
                src: "756:5:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint8",
                  typeString: "uint8",
                },
              },
              nodeType: "Mapping",
              src: "748:25:1",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint8_$_t_uint256_$",
                typeString: "mapping(uint8 => uint256)",
              },
              valueType: {
                id: 84,
                name: "uint256",
                nodeType: "ElementaryTypeName",
                src: "765:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256",
                },
              },
            },
            visibility: "internal",
          },
          {
            constant: false,
            functionSelector: "713b0a1e",
            id: 89,
            mutability: "mutable",
            name: "pixelChains",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "800:31:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
              typeString: "struct PixelChainMax.PixelChain[]",
            },
            typeName: {
              baseType: {
                id: 87,
                name: "PixelChain",
                nodeType: "UserDefinedTypeName",
                referencedDeclaration: 58,
                src: "800:10:1",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_PixelChain_$58_storage_ptr",
                  typeString: "struct PixelChainMax.PixelChain",
                },
              },
              id: 88,
              nodeType: "ArrayTypeName",
              src: "800:12:1",
              typeDescriptions: {
                typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage_ptr",
                typeString: "struct PixelChainMax.PixelChain[]",
              },
            },
            visibility: "public",
          },
          {
            body: {
              id: 96,
              nodeType: "Block",
              src: "885:2:1",
              statements: [],
            },
            id: 97,
            implemented: true,
            kind: "constructor",
            modifiers: [
              {
                arguments: [
                  {
                    hexValue: "506978656c436861696e204d6178",
                    id: 92,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "string",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "859:16:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_stringliteral_c703263a05ee7977fbfbe3667a454c62270a7242afdc563ab7ad5c4237f9762e",
                      typeString: 'literal_string "PixelChain Max"',
                    },
                    value: "PixelChain Max",
                  },
                  {
                    hexValue: "5058434d",
                    id: 93,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "string",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "877:6:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_stringliteral_bf2411a7de82190aaccd0dadb96ea2e5349eb7131390208860b0cf6f0fa221e6",
                      typeString: 'literal_string "PXCM"',
                    },
                    value: "PXCM",
                  },
                ],
                id: 94,
                modifierName: {
                  id: 91,
                  name: "ERC721",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 1742,
                  src: "852:6:1",
                  typeDescriptions: {
                    typeIdentifier: "t_type$_t_contract$_ERC721_$1742_$",
                    typeString: "type(contract ERC721)",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "852:32:1",
              },
            ],
            name: "",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 90,
              nodeType: "ParameterList",
              parameters: [],
              src: "849:2:1",
            },
            returnParameters: {
              id: 95,
              nodeType: "ParameterList",
              parameters: [],
              src: "885:0:1",
            },
            scope: 414,
            src: "838:49:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public",
          },
          {
            body: {
              id: 165,
              nodeType: "Block",
              src: "960:550:1",
              statements: [
                {
                  assignments: [103],
                  declarations: [
                    {
                      constant: false,
                      id: 103,
                      mutability: "mutable",
                      name: "mintPrice",
                      nodeType: "VariableDeclaration",
                      scope: 165,
                      src: "970:17:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 102,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "970:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 105,
                  initialValue: {
                    id: 104,
                    name: "defaultMintPrice",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 70,
                    src: "990:16:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "970:36:1",
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 111,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      baseExpression: {
                        id: 106,
                        name: "mintPricePerVersion",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 86,
                        src: "1020:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint8_$_t_uint256_$",
                          typeString: "mapping(uint8 => uint256)",
                        },
                      },
                      id: 109,
                      indexExpression: {
                        expression: {
                          id: 107,
                          name: "_pixelChain",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 99,
                          src: "1040:11:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                            typeString: "struct PixelChainMax.NewPixelChain memory",
                          },
                        },
                        id: 108,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "version",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 66,
                        src: "1040:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "1020:40:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      hexValue: "30",
                      id: 110,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1063:1:1",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0",
                      },
                      value: "0",
                    },
                    src: "1020:44:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 120,
                  nodeType: "IfStatement",
                  src: "1016:127:1",
                  trueBody: {
                    id: 119,
                    nodeType: "Block",
                    src: "1066:77:1",
                    statements: [
                      {
                        expression: {
                          id: 117,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 112,
                            name: "mintPrice",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1080:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            baseExpression: {
                              id: 113,
                              name: "mintPricePerVersion",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 86,
                              src: "1092:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint8_$_t_uint256_$",
                                typeString: "mapping(uint8 => uint256)",
                              },
                            },
                            id: 116,
                            indexExpression: {
                              expression: {
                                id: 114,
                                name: "_pixelChain",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 99,
                                src: "1112:11:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                                  typeString: "struct PixelChainMax.NewPixelChain memory",
                                },
                              },
                              id: 115,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "version",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 66,
                              src: "1112:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint8",
                                typeString: "uint8",
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "1092:40:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          src: "1080:52:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        id: 118,
                        nodeType: "ExpressionStatement",
                        src: "1080:52:1",
                      },
                    ],
                  },
                },
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        id: 125,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            id: 122,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: -15,
                            src: "1161:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg",
                            },
                          },
                          id: 123,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "value",
                          nodeType: "MemberAccess",
                          src: "1161:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: ">=",
                        rightExpression: {
                          id: 124,
                          name: "mintPrice",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 103,
                          src: "1174:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        src: "1161:22:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        hexValue: "4e6f7420656e6f75676820657468657220746f206d696e74207468697320746f6b656e21",
                        id: 126,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1185:38:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f",
                          typeString: 'literal_string "Not enough ether to mint this token!"',
                        },
                        value: "Not enough ether to mint this token!",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f",
                          typeString: 'literal_string "Not enough ether to mint this token!"',
                        },
                      ],
                      id: 121,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: "1153:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 127,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1153:71:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 128,
                  nodeType: "ExpressionStatement",
                  src: "1153:71:1",
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 133,
                              name: "_pixelChain",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 99,
                              src: "1276:11:1",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                                typeString: "struct PixelChainMax.NewPixelChain memory",
                              },
                            },
                            id: 134,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "name",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 60,
                            src: "1276:16:1",
                            typeDescriptions: {
                              typeIdentifier: "t_string_memory_ptr",
                              typeString: "string memory",
                            },
                          },
                          {
                            expression: {
                              id: 135,
                              name: "msg",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: "1294:3:1",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_message",
                                typeString: "msg",
                              },
                            },
                            id: 136,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "sender",
                            nodeType: "MemberAccess",
                            src: "1294:10:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address_payable",
                              typeString: "address payable",
                            },
                          },
                          {
                            expression: {
                              id: 137,
                              name: "block",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -4,
                              src: "1306:5:1",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_block",
                                typeString: "block",
                              },
                            },
                            id: 138,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "number",
                            nodeType: "MemberAccess",
                            src: "1306:12:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_string_memory_ptr",
                              typeString: "string memory",
                            },
                            {
                              typeIdentifier: "t_address_payable",
                              typeString: "address payable",
                            },
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          ],
                          id: 132,
                          name: "PixelChain",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 58,
                          src: "1265:10:1",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_struct$_PixelChain_$58_storage_ptr_$",
                            typeString: "type(struct PixelChainMax.PixelChain storage pointer)",
                          },
                        },
                        id: 139,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "structConstructorCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "1265:54:1",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_PixelChain_$58_memory_ptr",
                          typeString: "struct PixelChainMax.PixelChain memory",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_struct$_PixelChain_$58_memory_ptr",
                          typeString: "struct PixelChainMax.PixelChain memory",
                        },
                      ],
                      expression: {
                        id: 129,
                        name: "pixelChains",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89,
                        src: "1235:11:1",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                          typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                        },
                      },
                      id: 131,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "push",
                      nodeType: "MemberAccess",
                      src: "1235:16:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_arraypush_nonpayable$_t_struct$_PixelChain_$58_storage_$returns$__$",
                        typeString: "function (struct PixelChainMax.PixelChain storage ref)",
                      },
                    },
                    id: 140,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1235:94:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 141,
                  nodeType: "ExpressionStatement",
                  src: "1235:94:1",
                },
                {
                  assignments: [143],
                  declarations: [
                    {
                      constant: false,
                      id: 143,
                      mutability: "mutable",
                      name: "id",
                      nodeType: "VariableDeclaration",
                      scope: 165,
                      src: "1340:10:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 142,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "1340:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 148,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 147,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 144,
                        name: "pixelChains",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89,
                        src: "1353:11:1",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                          typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                        },
                      },
                      id: 145,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "length",
                      nodeType: "MemberAccess",
                      src: "1353:18:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: "-",
                    rightExpression: {
                      hexValue: "31",
                      id: 146,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1374:1:1",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_1_by_1",
                        typeString: "int_const 1",
                      },
                      value: "1",
                    },
                    src: "1353:22:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1340:35:1",
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 150,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "1391:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg",
                          },
                        },
                        id: 151,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "1391:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                      },
                      {
                        id: 152,
                        name: "id",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 143,
                        src: "1403:2:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      ],
                      id: 149,
                      name: "_mint",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1478,
                      src: "1385:5:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (address,uint256)",
                      },
                    },
                    id: 153,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1385:21:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 154,
                  nodeType: "ExpressionStatement",
                  src: "1385:21:1",
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 156,
                        name: "id",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 143,
                        src: "1440:2:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      {
                        expression: {
                          id: 157,
                          name: "_pixelChain",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 99,
                          src: "1444:11:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                            typeString: "struct PixelChainMax.NewPixelChain memory",
                          },
                        },
                        id: 158,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "data",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 62,
                        src: "1444:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                      },
                      {
                        expression: {
                          id: 159,
                          name: "_pixelChain",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 99,
                          src: "1462:11:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                            typeString: "struct PixelChainMax.NewPixelChain memory",
                          },
                        },
                        id: 160,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "palette",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 64,
                        src: "1462:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                      },
                      {
                        expression: {
                          id: 161,
                          name: "_pixelChain",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 99,
                          src: "1483:11:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                            typeString: "struct PixelChainMax.NewPixelChain memory",
                          },
                        },
                        id: 162,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "version",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 66,
                        src: "1483:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                        {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      ],
                      id: 155,
                      name: "PixelChainCreated",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 51,
                      src: "1422:17:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_event_nonpayable$_t_uint256_$_t_bytes_memory_ptr_$_t_bytes_memory_ptr_$_t_uint8_$returns$__$",
                        typeString: "function (uint256,bytes memory,bytes memory,uint8)",
                      },
                    },
                    id: 163,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1422:81:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 164,
                  nodeType: "EmitStatement",
                  src: "1417:86:1",
                },
              ],
            },
            functionSelector: "38186847",
            id: 166,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "create",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 100,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 99,
                  mutability: "mutable",
                  name: "_pixelChain",
                  nodeType: "VariableDeclaration",
                  scope: 166,
                  src: "909:32:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                    typeString: "struct PixelChainMax.NewPixelChain",
                  },
                  typeName: {
                    id: 98,
                    name: "NewPixelChain",
                    nodeType: "UserDefinedTypeName",
                    referencedDeclaration: 67,
                    src: "909:13:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_NewPixelChain_$67_storage_ptr",
                      typeString: "struct PixelChainMax.NewPixelChain",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "908:34:1",
            },
            returnParameters: {
              id: 101,
              nodeType: "ParameterList",
              parameters: [],
              src: "960:0:1",
            },
            scope: 414,
            src: "893:617:1",
            stateMutability: "payable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 249,
              nodeType: "Block",
              src: "1611:503:1",
              statements: [
                {
                  assignments: [177],
                  declarations: [
                    {
                      constant: false,
                      id: 177,
                      mutability: "mutable",
                      name: "end",
                      nodeType: "VariableDeclaration",
                      scope: 249,
                      src: "1621:11:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 176,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "1621:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 179,
                  initialValue: {
                    id: 178,
                    name: "_end",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 170,
                    src: "1635:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1621:18:1",
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 183,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 180,
                      name: "_end",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 170,
                      src: "1653:4:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      expression: {
                        id: 181,
                        name: "pixelChains",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89,
                        src: "1660:11:1",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                          typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                        },
                      },
                      id: 182,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "length",
                      nodeType: "MemberAccess",
                      src: "1660:18:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "1653:25:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 190,
                  nodeType: "IfStatement",
                  src: "1649:80:1",
                  trueBody: {
                    id: 189,
                    nodeType: "Block",
                    src: "1680:49:1",
                    statements: [
                      {
                        expression: {
                          id: 187,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 184,
                            name: "end",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 177,
                            src: "1694:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              id: 185,
                              name: "pixelChains",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89,
                              src: "1700:11:1",
                              typeDescriptions: {
                                typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                                typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                              },
                            },
                            id: 186,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "length",
                            nodeType: "MemberAccess",
                            src: "1700:18:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          src: "1694:24:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        id: 188,
                        nodeType: "ExpressionStatement",
                        src: "1694:24:1",
                      },
                    ],
                  },
                },
                {
                  assignments: [192],
                  declarations: [
                    {
                      constant: false,
                      id: 192,
                      mutability: "mutable",
                      name: "arraySize",
                      nodeType: "VariableDeclaration",
                      scope: 249,
                      src: "1739:17:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 191,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "1739:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 193,
                  nodeType: "VariableDeclarationStatement",
                  src: "1739:17:1",
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 196,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 194,
                      name: "_start",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 168,
                      src: "1770:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      id: 195,
                      name: "end",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 177,
                      src: "1779:3:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "1770:12:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  falseBody: {
                    id: 208,
                    nodeType: "Block",
                    src: "1828:49:1",
                    statements: [
                      {
                        expression: {
                          id: 206,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 202,
                            name: "arraySize",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 192,
                            src: "1842:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            commonType: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                            id: 205,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              id: 203,
                              name: "end",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 177,
                              src: "1854:3:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                            nodeType: "BinaryOperation",
                            operator: "-",
                            rightExpression: {
                              id: 204,
                              name: "_start",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 168,
                              src: "1860:6:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                            src: "1854:12:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          src: "1842:24:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        id: 207,
                        nodeType: "ExpressionStatement",
                        src: "1842:24:1",
                      },
                    ],
                  },
                  id: 209,
                  nodeType: "IfStatement",
                  src: "1766:111:1",
                  trueBody: {
                    id: 201,
                    nodeType: "Block",
                    src: "1784:38:1",
                    statements: [
                      {
                        expression: {
                          id: 199,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 197,
                            name: "arraySize",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 192,
                            src: "1798:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            hexValue: "30",
                            id: 198,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "1810:1:1",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0",
                            },
                            value: "0",
                          },
                          src: "1798:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        id: 200,
                        nodeType: "ExpressionStatement",
                        src: "1798:13:1",
                      },
                    ],
                  },
                },
                {
                  assignments: [213],
                  declarations: [
                    {
                      constant: false,
                      id: 213,
                      mutability: "mutable",
                      name: "response",
                      nodeType: "VariableDeclaration",
                      scope: 249,
                      src: "1887:28:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                        typeString: "struct PixelChainMax.PixelChain[]",
                      },
                      typeName: {
                        baseType: {
                          id: 211,
                          name: "PixelChain",
                          nodeType: "UserDefinedTypeName",
                          referencedDeclaration: 58,
                          src: "1887:10:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$58_storage_ptr",
                            typeString: "struct PixelChainMax.PixelChain",
                          },
                        },
                        id: 212,
                        nodeType: "ArrayTypeName",
                        src: "1887:12:1",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage_ptr",
                          typeString: "struct PixelChainMax.PixelChain[]",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 219,
                  initialValue: {
                    arguments: [
                      {
                        id: 217,
                        name: "arraySize",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 192,
                        src: "1935:9:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      ],
                      id: 216,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "NewExpression",
                      src: "1918:16:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_$",
                        typeString: "function (uint256) pure returns (struct PixelChainMax.PixelChain memory[] memory)",
                      },
                      typeName: {
                        baseType: {
                          id: 214,
                          name: "PixelChain",
                          nodeType: "UserDefinedTypeName",
                          referencedDeclaration: 58,
                          src: "1922:10:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$58_storage_ptr",
                            typeString: "struct PixelChainMax.PixelChain",
                          },
                        },
                        id: 215,
                        nodeType: "ArrayTypeName",
                        src: "1922:12:1",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage_ptr",
                          typeString: "struct PixelChainMax.PixelChain[]",
                        },
                      },
                    },
                    id: 218,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1918:27:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                      typeString: "struct PixelChainMax.PixelChain memory[] memory",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1887:58:1",
                },
                {
                  assignments: [221],
                  declarations: [
                    {
                      constant: false,
                      id: 221,
                      mutability: "mutable",
                      name: "x",
                      nodeType: "VariableDeclaration",
                      scope: 249,
                      src: "1956:6:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 220,
                        name: "uint",
                        nodeType: "ElementaryTypeName",
                        src: "1956:4:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 223,
                  initialValue: {
                    hexValue: "30",
                    id: 222,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "number",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "1965:1:1",
                    typeDescriptions: {
                      typeIdentifier: "t_rational_0_by_1",
                      typeString: "int_const 0",
                    },
                    value: "0",
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1956:10:1",
                },
                {
                  body: {
                    id: 245,
                    nodeType: "Block",
                    src: "2012:70:1",
                    statements: [
                      {
                        expression: {
                          id: 240,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            baseExpression: {
                              id: 234,
                              name: "response",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 213,
                              src: "2026:8:1",
                              typeDescriptions: {
                                typeIdentifier: "t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                                typeString: "struct PixelChainMax.PixelChain memory[] memory",
                              },
                            },
                            id: 236,
                            indexExpression: {
                              id: 235,
                              name: "x",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 221,
                              src: "2035:1:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            nodeType: "IndexAccess",
                            src: "2026:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_PixelChain_$58_memory_ptr",
                              typeString: "struct PixelChainMax.PixelChain memory",
                            },
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            baseExpression: {
                              id: 237,
                              name: "pixelChains",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89,
                              src: "2040:11:1",
                              typeDescriptions: {
                                typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                                typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                              },
                            },
                            id: 239,
                            indexExpression: {
                              id: 238,
                              name: "i",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 225,
                              src: "2052:1:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "2040:14:1",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_PixelChain_$58_storage",
                              typeString: "struct PixelChainMax.PixelChain storage ref",
                            },
                          },
                          src: "2026:28:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$58_memory_ptr",
                            typeString: "struct PixelChainMax.PixelChain memory",
                          },
                        },
                        id: 241,
                        nodeType: "ExpressionStatement",
                        src: "2026:28:1",
                      },
                      {
                        expression: {
                          id: 243,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "UnaryOperation",
                          operator: "++",
                          prefix: false,
                          src: "2068:3:1",
                          subExpression: {
                            id: 242,
                            name: "x",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 221,
                            src: "2068:1:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        id: 244,
                        nodeType: "ExpressionStatement",
                        src: "2068:3:1",
                      },
                    ],
                  },
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 230,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 228,
                      name: "i",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 225,
                      src: "1998:1:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 229,
                      name: "end",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 177,
                      src: "2002:3:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "1998:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 246,
                  initializationExpression: {
                    assignments: [225],
                    declarations: [
                      {
                        constant: false,
                        id: 225,
                        mutability: "mutable",
                        name: "i",
                        nodeType: "VariableDeclaration",
                        scope: 246,
                        src: "1981:6:1",
                        stateVariable: false,
                        storageLocation: "default",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        typeName: {
                          id: 224,
                          name: "uint",
                          nodeType: "ElementaryTypeName",
                          src: "1981:4:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        visibility: "internal",
                      },
                    ],
                    id: 227,
                    initialValue: {
                      id: 226,
                      name: "_start",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 168,
                      src: "1990:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "VariableDeclarationStatement",
                    src: "1981:15:1",
                  },
                  loopExpression: {
                    expression: {
                      id: 232,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "UnaryOperation",
                      operator: "++",
                      prefix: false,
                      src: "2007:3:1",
                      subExpression: {
                        id: 231,
                        name: "i",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 225,
                        src: "2007:1:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    id: 233,
                    nodeType: "ExpressionStatement",
                    src: "2007:3:1",
                  },
                  nodeType: "ForStatement",
                  src: "1976:106:1",
                },
                {
                  expression: {
                    id: 247,
                    name: "response",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 213,
                    src: "2099:8:1",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                      typeString: "struct PixelChainMax.PixelChain memory[] memory",
                    },
                  },
                  functionReturnParameters: 175,
                  id: 248,
                  nodeType: "Return",
                  src: "2092:15:1",
                },
              ],
            },
            functionSelector: "b81107b9",
            id: 250,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "retrieveAll",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 171,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 168,
                  mutability: "mutable",
                  name: "_start",
                  nodeType: "VariableDeclaration",
                  scope: 250,
                  src: "1537:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 167,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1537:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 170,
                  mutability: "mutable",
                  name: "_end",
                  nodeType: "VariableDeclaration",
                  scope: 250,
                  src: "1553:12:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 169,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1553:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "1536:30:1",
            },
            returnParameters: {
              id: 175,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 174,
                  mutability: "mutable",
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 250,
                  src: "1590:19:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                    typeString: "struct PixelChainMax.PixelChain[]",
                  },
                  typeName: {
                    baseType: {
                      id: 172,
                      name: "PixelChain",
                      nodeType: "UserDefinedTypeName",
                      referencedDeclaration: 58,
                      src: "1590:10:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PixelChain_$58_storage_ptr",
                        typeString: "struct PixelChainMax.PixelChain",
                      },
                    },
                    id: 173,
                    nodeType: "ArrayTypeName",
                    src: "1590:12:1",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage_ptr",
                      typeString: "struct PixelChainMax.PixelChain[]",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "1589:21:1",
            },
            scope: 414,
            src: "1516:598:1",
            stateMutability: "view",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 261,
              nodeType: "Block",
              src: "2193:40:1",
              statements: [
                {
                  expression: {
                    baseExpression: {
                      id: 257,
                      name: "pixelChains",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89,
                      src: "2210:11:1",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                        typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                      },
                    },
                    id: 259,
                    indexExpression: {
                      id: 258,
                      name: "_id",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 252,
                      src: "2222:3:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "2210:16:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PixelChain_$58_storage",
                      typeString: "struct PixelChainMax.PixelChain storage ref",
                    },
                  },
                  functionReturnParameters: 256,
                  id: 260,
                  nodeType: "Return",
                  src: "2203:23:1",
                },
              ],
            },
            functionSelector: "8f88708b",
            id: 262,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "retrieve",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 253,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 252,
                  mutability: "mutable",
                  name: "_id",
                  nodeType: "VariableDeclaration",
                  scope: 262,
                  src: "2138:11:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 251,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2138:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2137:13:1",
            },
            returnParameters: {
              id: 256,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 255,
                  mutability: "mutable",
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 262,
                  src: "2174:17:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_PixelChain_$58_memory_ptr",
                    typeString: "struct PixelChainMax.PixelChain",
                  },
                  typeName: {
                    id: 254,
                    name: "PixelChain",
                    nodeType: "UserDefinedTypeName",
                    referencedDeclaration: 58,
                    src: "2174:10:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PixelChain_$58_storage_ptr",
                      typeString: "struct PixelChainMax.PixelChain",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2173:19:1",
            },
            scope: 414,
            src: "2120:113:1",
            stateMutability: "view",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 273,
              nodeType: "Block",
              src: "2303:34:1",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 270,
                        name: "_uri",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 264,
                        src: "2325:4:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      ],
                      id: 269,
                      name: "_setBaseURI",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1650,
                      src: "2313:11:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (string memory)",
                      },
                    },
                    id: 271,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2313:17:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 272,
                  nodeType: "ExpressionStatement",
                  src: "2313:17:1",
                },
              ],
            },
            functionSelector: "30176e13",
            id: 274,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 267,
                modifierName: {
                  id: 266,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2293:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2293:9:1",
              },
            ],
            name: "setBaseTokenURI",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 265,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 264,
                  mutability: "mutable",
                  name: "_uri",
                  nodeType: "VariableDeclaration",
                  scope: 274,
                  src: "2264:18:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 263,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "2264:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2263:20:1",
            },
            returnParameters: {
              id: 268,
              nodeType: "ParameterList",
              parameters: [],
              src: "2303:0:1",
            },
            scope: 414,
            src: "2239:98:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 291,
              nodeType: "Block",
              src: "2382:59:1",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          arguments: [
                            {
                              id: 286,
                              name: "this",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -28,
                              src: "2420:4:1",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_PixelChainMax_$414",
                                typeString: "contract PixelChainMax",
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_contract$_PixelChainMax_$414",
                                typeString: "contract PixelChainMax",
                              },
                            ],
                            id: 285,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "2412:7:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_address_$",
                              typeString: "type(address)",
                            },
                            typeName: {
                              id: 284,
                              name: "address",
                              nodeType: "ElementaryTypeName",
                              src: "2412:7:1",
                              typeDescriptions: {},
                            },
                          },
                          id: 287,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "2412:13:1",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address",
                          },
                        },
                        id: 288,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "balance",
                        nodeType: "MemberAccess",
                        src: "2412:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      ],
                      expression: {
                        expression: {
                          id: 279,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "2392:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg",
                          },
                        },
                        id: 282,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "2392:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                      },
                      id: 283,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "transfer",
                      nodeType: "MemberAccess",
                      src: "2392:19:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
                        typeString: "function (uint256)",
                      },
                    },
                    id: 289,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2392:42:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 290,
                  nodeType: "ExpressionStatement",
                  src: "2392:42:1",
                },
              ],
            },
            functionSelector: "3ccfd60b",
            id: 292,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 277,
                modifierName: {
                  id: 276,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2372:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2372:9:1",
              },
            ],
            name: "withdraw",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 275,
              nodeType: "ParameterList",
              parameters: [],
              src: "2360:2:1",
            },
            returnParameters: {
              id: 278,
              nodeType: "ParameterList",
              parameters: [],
              src: "2382:0:1",
            },
            scope: 414,
            src: "2343:98:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 303,
              nodeType: "Block",
              src: "2511:42:1",
              statements: [
                {
                  expression: {
                    id: 301,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 299,
                      name: "defaultMintPrice",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 70,
                      src: "2521:16:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 300,
                      name: "_price",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 294,
                      src: "2540:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "2521:25:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  id: 302,
                  nodeType: "ExpressionStatement",
                  src: "2521:25:1",
                },
              ],
            },
            functionSelector: "3ea02d0f",
            id: 304,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 297,
                modifierName: {
                  id: 296,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2501:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2501:9:1",
              },
            ],
            name: "setDefaultMintPrice",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 295,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 294,
                  mutability: "mutable",
                  name: "_price",
                  nodeType: "VariableDeclaration",
                  scope: 304,
                  src: "2476:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 293,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2476:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2475:16:1",
            },
            returnParameters: {
              id: 298,
              nodeType: "ParameterList",
              parameters: [],
              src: "2511:0:1",
            },
            scope: 414,
            src: "2447:106:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 319,
              nodeType: "Block",
              src: "2642:55:1",
              statements: [
                {
                  expression: {
                    id: 317,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 313,
                        name: "mintPricePerVersion",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 86,
                        src: "2652:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint8_$_t_uint256_$",
                          typeString: "mapping(uint8 => uint256)",
                        },
                      },
                      id: 315,
                      indexExpression: {
                        id: 314,
                        name: "_version",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 306,
                        src: "2672:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "2652:29:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 316,
                      name: "_price",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 308,
                      src: "2684:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "2652:38:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  id: 318,
                  nodeType: "ExpressionStatement",
                  src: "2652:38:1",
                },
              ],
            },
            functionSelector: "d3fb43c6",
            id: 320,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 311,
                modifierName: {
                  id: 310,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2632:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2632:9:1",
              },
            ],
            name: "setMintPricePerVersion",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 309,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 306,
                  mutability: "mutable",
                  name: "_version",
                  nodeType: "VariableDeclaration",
                  scope: 320,
                  src: "2591:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8",
                  },
                  typeName: {
                    id: 305,
                    name: "uint8",
                    nodeType: "ElementaryTypeName",
                    src: "2591:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 308,
                  mutability: "mutable",
                  name: "_price",
                  nodeType: "VariableDeclaration",
                  scope: 320,
                  src: "2607:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 307,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2607:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2590:32:1",
            },
            returnParameters: {
              id: 312,
              nodeType: "ParameterList",
              parameters: [],
              src: "2642:0:1",
            },
            scope: 414,
            src: "2559:138:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 333,
              nodeType: "Block",
              src: "2771:50:1",
              statements: [
                {
                  expression: {
                    id: 331,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 327,
                        name: "addressBlacklist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74,
                        src: "2781:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                          typeString: "mapping(address => bool)",
                        },
                      },
                      id: 329,
                      indexExpression: {
                        id: 328,
                        name: "_address",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 322,
                        src: "2798:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "2781:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "74727565",
                      id: 330,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "2810:4:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "true",
                    },
                    src: "2781:33:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 332,
                  nodeType: "ExpressionStatement",
                  src: "2781:33:1",
                },
              ],
            },
            functionSelector: "f2c816ae",
            id: 334,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 325,
                modifierName: {
                  id: 324,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2761:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2761:9:1",
              },
            ],
            name: "addAddressToBlacklist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 323,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 322,
                  mutability: "mutable",
                  name: "_address",
                  nodeType: "VariableDeclaration",
                  scope: 334,
                  src: "2734:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 321,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2734:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2733:18:1",
            },
            returnParameters: {
              id: 326,
              nodeType: "ParameterList",
              parameters: [],
              src: "2771:0:1",
            },
            scope: 414,
            src: "2703:118:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 347,
              nodeType: "Block",
              src: "2900:51:1",
              statements: [
                {
                  expression: {
                    id: 345,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 341,
                        name: "addressBlacklist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74,
                        src: "2910:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                          typeString: "mapping(address => bool)",
                        },
                      },
                      id: 343,
                      indexExpression: {
                        id: 342,
                        name: "_address",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 336,
                        src: "2927:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "2910:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "66616c7365",
                      id: 344,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "2939:5:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "false",
                    },
                    src: "2910:34:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 346,
                  nodeType: "ExpressionStatement",
                  src: "2910:34:1",
                },
              ],
            },
            functionSelector: "35e82f3a",
            id: 348,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 339,
                modifierName: {
                  id: 338,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2890:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2890:9:1",
              },
            ],
            name: "removeAddressFromBlacklist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 337,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 336,
                  mutability: "mutable",
                  name: "_address",
                  nodeType: "VariableDeclaration",
                  scope: 348,
                  src: "2863:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 335,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2863:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2862:18:1",
            },
            returnParameters: {
              id: 340,
              nodeType: "ParameterList",
              parameters: [],
              src: "2900:0:1",
            },
            scope: 414,
            src: "2827:124:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 361,
              nodeType: "Block",
              src: "3025:50:1",
              statements: [
                {
                  expression: {
                    id: 359,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 355,
                        name: "addressWhitelist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 78,
                        src: "3035:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                          typeString: "mapping(address => bool)",
                        },
                      },
                      id: 357,
                      indexExpression: {
                        id: 356,
                        name: "_address",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 350,
                        src: "3052:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "3035:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "74727565",
                      id: 358,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "3064:4:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "true",
                    },
                    src: "3035:33:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 360,
                  nodeType: "ExpressionStatement",
                  src: "3035:33:1",
                },
              ],
            },
            functionSelector: "7b9417c8",
            id: 362,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 353,
                modifierName: {
                  id: 352,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "3015:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "3015:9:1",
              },
            ],
            name: "addAddressToWhitelist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 351,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 350,
                  mutability: "mutable",
                  name: "_address",
                  nodeType: "VariableDeclaration",
                  scope: 362,
                  src: "2988:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 349,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2988:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2987:18:1",
            },
            returnParameters: {
              id: 354,
              nodeType: "ParameterList",
              parameters: [],
              src: "3025:0:1",
            },
            scope: 414,
            src: "2957:118:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 375,
              nodeType: "Block",
              src: "3154:51:1",
              statements: [
                {
                  expression: {
                    id: 373,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 369,
                        name: "addressWhitelist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 78,
                        src: "3164:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                          typeString: "mapping(address => bool)",
                        },
                      },
                      id: 371,
                      indexExpression: {
                        id: 370,
                        name: "_address",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 364,
                        src: "3181:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "3164:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "66616c7365",
                      id: 372,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "3193:5:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "false",
                    },
                    src: "3164:34:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 374,
                  nodeType: "ExpressionStatement",
                  src: "3164:34:1",
                },
              ],
            },
            functionSelector: "286dd3f5",
            id: 376,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 367,
                modifierName: {
                  id: 366,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "3144:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "3144:9:1",
              },
            ],
            name: "removeAddressFromWhitelist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 365,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 364,
                  mutability: "mutable",
                  name: "_address",
                  nodeType: "VariableDeclaration",
                  scope: 376,
                  src: "3117:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 363,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "3117:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "3116:18:1",
            },
            returnParameters: {
              id: 368,
              nodeType: "ParameterList",
              parameters: [],
              src: "3154:0:1",
            },
            scope: 414,
            src: "3081:124:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 389,
              nodeType: "Block",
              src: "3277:50:1",
              statements: [
                {
                  expression: {
                    id: 387,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 383,
                        name: "versionWhitelist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82,
                        src: "3287:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint8_$_t_bool_$",
                          typeString: "mapping(uint8 => bool)",
                        },
                      },
                      id: 385,
                      indexExpression: {
                        id: 384,
                        name: "_version",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 378,
                        src: "3304:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "3287:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "74727565",
                      id: 386,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "3316:4:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "true",
                    },
                    src: "3287:33:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 388,
                  nodeType: "ExpressionStatement",
                  src: "3287:33:1",
                },
              ],
            },
            functionSelector: "b8f2716f",
            id: 390,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 381,
                modifierName: {
                  id: 380,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "3267:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "3267:9:1",
              },
            ],
            name: "addVersionToWhitelist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 379,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 378,
                  mutability: "mutable",
                  name: "_version",
                  nodeType: "VariableDeclaration",
                  scope: 390,
                  src: "3242:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8",
                  },
                  typeName: {
                    id: 377,
                    name: "uint8",
                    nodeType: "ElementaryTypeName",
                    src: "3242:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "3241:16:1",
            },
            returnParameters: {
              id: 382,
              nodeType: "ParameterList",
              parameters: [],
              src: "3277:0:1",
            },
            scope: 414,
            src: "3211:116:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 403,
              nodeType: "Block",
              src: "3404:51:1",
              statements: [
                {
                  expression: {
                    id: 401,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 397,
                        name: "versionWhitelist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82,
                        src: "3414:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint8_$_t_bool_$",
                          typeString: "mapping(uint8 => bool)",
                        },
                      },
                      id: 399,
                      indexExpression: {
                        id: 398,
                        name: "_version",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 392,
                        src: "3431:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "3414:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "66616c7365",
                      id: 400,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "3443:5:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "false",
                    },
                    src: "3414:34:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 402,
                  nodeType: "ExpressionStatement",
                  src: "3414:34:1",
                },
              ],
            },
            functionSelector: "6a66005a",
            id: 404,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 395,
                modifierName: {
                  id: 394,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "3394:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "3394:9:1",
              },
            ],
            name: "removeVersionFromWhitelist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 393,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 392,
                  mutability: "mutable",
                  name: "_version",
                  nodeType: "VariableDeclaration",
                  scope: 404,
                  src: "3369:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8",
                  },
                  typeName: {
                    id: 391,
                    name: "uint8",
                    nodeType: "ElementaryTypeName",
                    src: "3369:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "3368:16:1",
            },
            returnParameters: {
              id: 396,
              nodeType: "ParameterList",
              parameters: [],
              src: "3404:0:1",
            },
            scope: 414,
            src: "3333:122:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 412,
              nodeType: "Block",
              src: "3523:33:1",
              statements: [
                {
                  expression: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      id: 409,
                      name: "baseURI",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1051,
                      src: "3540:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$__$returns$_t_string_memory_ptr_$",
                        typeString: "function () view returns (string memory)",
                      },
                    },
                    id: 410,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3540:9:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory",
                    },
                  },
                  functionReturnParameters: 408,
                  id: 411,
                  nodeType: "Return",
                  src: "3533:16:1",
                },
              ],
            },
            functionSelector: "d547cfb7",
            id: 413,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "baseTokenURI",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 405,
              nodeType: "ParameterList",
              parameters: [],
              src: "3482:2:1",
            },
            returnParameters: {
              id: 408,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 407,
                  mutability: "mutable",
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 413,
                  src: "3508:13:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 406,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "3508:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "3507:15:1",
            },
            scope: 414,
            src: "3461:95:1",
            stateMutability: "view",
            virtual: false,
            visibility: "external",
          },
        ],
        scope: 415,
        src: "203:3355:1",
      },
    ],
    src: "32:3527:1",
  },
  legacyAST: {
    absolutePath: "/home/nahuel/3dge/PixelChainMax-Contract/contracts/PixelChainMax.sol",
    exportedSymbols: {
      Address: [2138],
      Context: [437],
      ERC165: [603],
      ERC721: [1742],
      EnumerableMap: [2593],
      EnumerableSet: [2988],
      IERC165: [615],
      IERC721: [1858],
      IERC721Enumerable: [1889],
      IERC721Metadata: [1916],
      IERC721Receiver: [1934],
      Ownable: [546],
      PixelChainMax: [414],
      SafeMath: [811],
      Strings: [3075],
    },
    id: 415,
    license: "MIT",
    nodeType: "SourceUnit",
    nodes: [
      {
        id: 34,
        literals: ["solidity", "^", "0.7", ".0"],
        nodeType: "PragmaDirective",
        src: "32:23:1",
      },
      {
        id: 35,
        literals: ["experimental", "ABIEncoderV2"],
        nodeType: "PragmaDirective",
        src: "56:33:1",
      },
      {
        absolutePath: "@openzeppelin/contracts/access/Ownable.sol",
        file: "@openzeppelin/contracts/access/Ownable.sol",
        id: 36,
        nodeType: "ImportDirective",
        scope: 415,
        sourceUnit: 547,
        src: "91:52:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        absolutePath: "@openzeppelin/contracts/token/ERC721/ERC721.sol",
        file: "@openzeppelin/contracts/token/ERC721/ERC721.sol",
        id: 37,
        nodeType: "ImportDirective",
        scope: 415,
        sourceUnit: 1743,
        src: "144:57:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 38,
              name: "ERC721",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 1742,
              src: "229:6:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_ERC721_$1742",
                typeString: "contract ERC721",
              },
            },
            id: 39,
            nodeType: "InheritanceSpecifier",
            src: "229:6:1",
          },
          {
            baseName: {
              id: 40,
              name: "Ownable",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 546,
              src: "237:7:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_Ownable_$546",
                typeString: "contract Ownable",
              },
            },
            id: 41,
            nodeType: "InheritanceSpecifier",
            src: "237:7:1",
          },
        ],
        contractDependencies: [437, 546, 603, 615, 1742, 1858, 1889, 1916],
        contractKind: "contract",
        fullyImplemented: true,
        id: 414,
        linearizedBaseContracts: [414, 546, 1742, 1889, 1916, 1858, 603, 615, 437],
        name: "PixelChainMax",
        nodeType: "ContractDefinition",
        nodes: [
          {
            anonymous: false,
            id: 51,
            name: "PixelChainCreated",
            nodeType: "EventDefinition",
            parameters: {
              id: 50,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 43,
                  indexed: true,
                  mutability: "mutable",
                  name: "tokenId",
                  nodeType: "VariableDeclaration",
                  scope: 51,
                  src: "275:23:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 42,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "275:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 45,
                  indexed: false,
                  mutability: "mutable",
                  name: "data",
                  nodeType: "VariableDeclaration",
                  scope: 51,
                  src: "300:10:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 44,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "300:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 47,
                  indexed: false,
                  mutability: "mutable",
                  name: "palette",
                  nodeType: "VariableDeclaration",
                  scope: 51,
                  src: "312:13:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 46,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "312:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 49,
                  indexed: false,
                  mutability: "mutable",
                  name: "version",
                  nodeType: "VariableDeclaration",
                  scope: 51,
                  src: "327:13:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8",
                  },
                  typeName: {
                    id: 48,
                    name: "uint8",
                    nodeType: "ElementaryTypeName",
                    src: "327:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "274:67:1",
            },
            src: "251:91:1",
          },
          {
            canonicalName: "PixelChainMax.PixelChain",
            id: 58,
            members: [
              {
                constant: false,
                id: 53,
                mutability: "mutable",
                name: "name",
                nodeType: "VariableDeclaration",
                scope: 58,
                src: "376:11:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_string_storage_ptr",
                  typeString: "string",
                },
                typeName: {
                  id: 52,
                  name: "string",
                  nodeType: "ElementaryTypeName",
                  src: "376:6:1",
                  typeDescriptions: {
                    typeIdentifier: "t_string_storage_ptr",
                    typeString: "string",
                  },
                },
                visibility: "internal",
              },
              {
                constant: false,
                id: 55,
                mutability: "mutable",
                name: "author",
                nodeType: "VariableDeclaration",
                scope: 58,
                src: "397:14:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address",
                },
                typeName: {
                  id: 54,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "397:7:1",
                  stateMutability: "nonpayable",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                },
                visibility: "internal",
              },
              {
                constant: false,
                id: 57,
                mutability: "mutable",
                name: "blockNumber",
                nodeType: "VariableDeclaration",
                scope: 58,
                src: "421:19:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256",
                },
                typeName: {
                  id: 56,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "421:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                },
                visibility: "internal",
              },
            ],
            name: "PixelChain",
            nodeType: "StructDefinition",
            scope: 414,
            src: "348:99:1",
            visibility: "public",
          },
          {
            canonicalName: "PixelChainMax.NewPixelChain",
            id: 67,
            members: [
              {
                constant: false,
                id: 60,
                mutability: "mutable",
                name: "name",
                nodeType: "VariableDeclaration",
                scope: 67,
                src: "484:11:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_string_storage_ptr",
                  typeString: "string",
                },
                typeName: {
                  id: 59,
                  name: "string",
                  nodeType: "ElementaryTypeName",
                  src: "484:6:1",
                  typeDescriptions: {
                    typeIdentifier: "t_string_storage_ptr",
                    typeString: "string",
                  },
                },
                visibility: "internal",
              },
              {
                constant: false,
                id: 62,
                mutability: "mutable",
                name: "data",
                nodeType: "VariableDeclaration",
                scope: 67,
                src: "505:10:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bytes_storage_ptr",
                  typeString: "bytes",
                },
                typeName: {
                  id: 61,
                  name: "bytes",
                  nodeType: "ElementaryTypeName",
                  src: "505:5:1",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_storage_ptr",
                    typeString: "bytes",
                  },
                },
                visibility: "internal",
              },
              {
                constant: false,
                id: 64,
                mutability: "mutable",
                name: "palette",
                nodeType: "VariableDeclaration",
                scope: 67,
                src: "525:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bytes_storage_ptr",
                  typeString: "bytes",
                },
                typeName: {
                  id: 63,
                  name: "bytes",
                  nodeType: "ElementaryTypeName",
                  src: "525:5:1",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_storage_ptr",
                    typeString: "bytes",
                  },
                },
                visibility: "internal",
              },
              {
                constant: false,
                id: 66,
                mutability: "mutable",
                name: "version",
                nodeType: "VariableDeclaration",
                scope: 67,
                src: "548:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint8",
                  typeString: "uint8",
                },
                typeName: {
                  id: 65,
                  name: "uint8",
                  nodeType: "ElementaryTypeName",
                  src: "548:5:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8",
                  },
                },
                visibility: "internal",
              },
            ],
            name: "NewPixelChain",
            nodeType: "StructDefinition",
            scope: 414,
            src: "453:115:1",
            visibility: "public",
          },
          {
            constant: false,
            id: 70,
            mutability: "mutable",
            name: "defaultMintPrice",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "574:28:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256",
            },
            typeName: {
              id: 68,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "574:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256",
              },
            },
            value: {
              hexValue: "30",
              id: 69,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "number",
              lValueRequested: false,
              nodeType: "Literal",
              src: "601:1:1",
              typeDescriptions: {
                typeIdentifier: "t_rational_0_by_1",
                typeString: "int_const 0",
              },
              value: "0",
            },
            visibility: "internal",
          },
          {
            constant: false,
            id: 74,
            mutability: "mutable",
            name: "addressBlacklist",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "609:41:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
              typeString: "mapping(address => bool)",
            },
            typeName: {
              id: 73,
              keyType: {
                id: 71,
                name: "address",
                nodeType: "ElementaryTypeName",
                src: "617:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address",
                },
              },
              nodeType: "Mapping",
              src: "609:24:1",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                typeString: "mapping(address => bool)",
              },
              valueType: {
                id: 72,
                name: "bool",
                nodeType: "ElementaryTypeName",
                src: "628:4:1",
                typeDescriptions: {
                  typeIdentifier: "t_bool",
                  typeString: "bool",
                },
              },
            },
            visibility: "internal",
          },
          {
            constant: false,
            id: 78,
            mutability: "mutable",
            name: "addressWhitelist",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "656:41:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
              typeString: "mapping(address => bool)",
            },
            typeName: {
              id: 77,
              keyType: {
                id: 75,
                name: "address",
                nodeType: "ElementaryTypeName",
                src: "664:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address",
                },
              },
              nodeType: "Mapping",
              src: "656:24:1",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                typeString: "mapping(address => bool)",
              },
              valueType: {
                id: 76,
                name: "bool",
                nodeType: "ElementaryTypeName",
                src: "675:4:1",
                typeDescriptions: {
                  typeIdentifier: "t_bool",
                  typeString: "bool",
                },
              },
            },
            visibility: "internal",
          },
          {
            constant: false,
            id: 82,
            mutability: "mutable",
            name: "versionWhitelist",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "703:39:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint8_$_t_bool_$",
              typeString: "mapping(uint8 => bool)",
            },
            typeName: {
              id: 81,
              keyType: {
                id: 79,
                name: "uint8",
                nodeType: "ElementaryTypeName",
                src: "711:5:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint8",
                  typeString: "uint8",
                },
              },
              nodeType: "Mapping",
              src: "703:22:1",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint8_$_t_bool_$",
                typeString: "mapping(uint8 => bool)",
              },
              valueType: {
                id: 80,
                name: "bool",
                nodeType: "ElementaryTypeName",
                src: "720:4:1",
                typeDescriptions: {
                  typeIdentifier: "t_bool",
                  typeString: "bool",
                },
              },
            },
            visibility: "internal",
          },
          {
            constant: false,
            id: 86,
            mutability: "mutable",
            name: "mintPricePerVersion",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "748:45:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint8_$_t_uint256_$",
              typeString: "mapping(uint8 => uint256)",
            },
            typeName: {
              id: 85,
              keyType: {
                id: 83,
                name: "uint8",
                nodeType: "ElementaryTypeName",
                src: "756:5:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint8",
                  typeString: "uint8",
                },
              },
              nodeType: "Mapping",
              src: "748:25:1",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint8_$_t_uint256_$",
                typeString: "mapping(uint8 => uint256)",
              },
              valueType: {
                id: 84,
                name: "uint256",
                nodeType: "ElementaryTypeName",
                src: "765:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256",
                },
              },
            },
            visibility: "internal",
          },
          {
            constant: false,
            functionSelector: "713b0a1e",
            id: 89,
            mutability: "mutable",
            name: "pixelChains",
            nodeType: "VariableDeclaration",
            scope: 414,
            src: "800:31:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
              typeString: "struct PixelChainMax.PixelChain[]",
            },
            typeName: {
              baseType: {
                id: 87,
                name: "PixelChain",
                nodeType: "UserDefinedTypeName",
                referencedDeclaration: 58,
                src: "800:10:1",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_PixelChain_$58_storage_ptr",
                  typeString: "struct PixelChainMax.PixelChain",
                },
              },
              id: 88,
              nodeType: "ArrayTypeName",
              src: "800:12:1",
              typeDescriptions: {
                typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage_ptr",
                typeString: "struct PixelChainMax.PixelChain[]",
              },
            },
            visibility: "public",
          },
          {
            body: {
              id: 96,
              nodeType: "Block",
              src: "885:2:1",
              statements: [],
            },
            id: 97,
            implemented: true,
            kind: "constructor",
            modifiers: [
              {
                arguments: [
                  {
                    hexValue: "506978656c436861696e204d6178",
                    id: 92,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "string",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "859:16:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_stringliteral_c703263a05ee7977fbfbe3667a454c62270a7242afdc563ab7ad5c4237f9762e",
                      typeString: 'literal_string "PixelChain Max"',
                    },
                    value: "PixelChain Max",
                  },
                  {
                    hexValue: "5058434d",
                    id: 93,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "string",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "877:6:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_stringliteral_bf2411a7de82190aaccd0dadb96ea2e5349eb7131390208860b0cf6f0fa221e6",
                      typeString: 'literal_string "PXCM"',
                    },
                    value: "PXCM",
                  },
                ],
                id: 94,
                modifierName: {
                  id: 91,
                  name: "ERC721",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 1742,
                  src: "852:6:1",
                  typeDescriptions: {
                    typeIdentifier: "t_type$_t_contract$_ERC721_$1742_$",
                    typeString: "type(contract ERC721)",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "852:32:1",
              },
            ],
            name: "",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 90,
              nodeType: "ParameterList",
              parameters: [],
              src: "849:2:1",
            },
            returnParameters: {
              id: 95,
              nodeType: "ParameterList",
              parameters: [],
              src: "885:0:1",
            },
            scope: 414,
            src: "838:49:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public",
          },
          {
            body: {
              id: 165,
              nodeType: "Block",
              src: "960:550:1",
              statements: [
                {
                  assignments: [103],
                  declarations: [
                    {
                      constant: false,
                      id: 103,
                      mutability: "mutable",
                      name: "mintPrice",
                      nodeType: "VariableDeclaration",
                      scope: 165,
                      src: "970:17:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 102,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "970:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 105,
                  initialValue: {
                    id: 104,
                    name: "defaultMintPrice",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 70,
                    src: "990:16:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "970:36:1",
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 111,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      baseExpression: {
                        id: 106,
                        name: "mintPricePerVersion",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 86,
                        src: "1020:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint8_$_t_uint256_$",
                          typeString: "mapping(uint8 => uint256)",
                        },
                      },
                      id: 109,
                      indexExpression: {
                        expression: {
                          id: 107,
                          name: "_pixelChain",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 99,
                          src: "1040:11:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                            typeString: "struct PixelChainMax.NewPixelChain memory",
                          },
                        },
                        id: 108,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "version",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 66,
                        src: "1040:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "1020:40:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      hexValue: "30",
                      id: 110,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1063:1:1",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0",
                      },
                      value: "0",
                    },
                    src: "1020:44:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 120,
                  nodeType: "IfStatement",
                  src: "1016:127:1",
                  trueBody: {
                    id: 119,
                    nodeType: "Block",
                    src: "1066:77:1",
                    statements: [
                      {
                        expression: {
                          id: 117,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 112,
                            name: "mintPrice",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1080:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            baseExpression: {
                              id: 113,
                              name: "mintPricePerVersion",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 86,
                              src: "1092:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint8_$_t_uint256_$",
                                typeString: "mapping(uint8 => uint256)",
                              },
                            },
                            id: 116,
                            indexExpression: {
                              expression: {
                                id: 114,
                                name: "_pixelChain",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 99,
                                src: "1112:11:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                                  typeString: "struct PixelChainMax.NewPixelChain memory",
                                },
                              },
                              id: 115,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "version",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 66,
                              src: "1112:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint8",
                                typeString: "uint8",
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "1092:40:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          src: "1080:52:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        id: 118,
                        nodeType: "ExpressionStatement",
                        src: "1080:52:1",
                      },
                    ],
                  },
                },
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        id: 125,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            id: 122,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: -15,
                            src: "1161:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg",
                            },
                          },
                          id: 123,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "value",
                          nodeType: "MemberAccess",
                          src: "1161:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: ">=",
                        rightExpression: {
                          id: 124,
                          name: "mintPrice",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 103,
                          src: "1174:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        src: "1161:22:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        hexValue: "4e6f7420656e6f75676820657468657220746f206d696e74207468697320746f6b656e21",
                        id: 126,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1185:38:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f",
                          typeString: 'literal_string "Not enough ether to mint this token!"',
                        },
                        value: "Not enough ether to mint this token!",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f",
                          typeString: 'literal_string "Not enough ether to mint this token!"',
                        },
                      ],
                      id: 121,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: "1153:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 127,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1153:71:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 128,
                  nodeType: "ExpressionStatement",
                  src: "1153:71:1",
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 133,
                              name: "_pixelChain",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 99,
                              src: "1276:11:1",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                                typeString: "struct PixelChainMax.NewPixelChain memory",
                              },
                            },
                            id: 134,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "name",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 60,
                            src: "1276:16:1",
                            typeDescriptions: {
                              typeIdentifier: "t_string_memory_ptr",
                              typeString: "string memory",
                            },
                          },
                          {
                            expression: {
                              id: 135,
                              name: "msg",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: "1294:3:1",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_message",
                                typeString: "msg",
                              },
                            },
                            id: 136,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "sender",
                            nodeType: "MemberAccess",
                            src: "1294:10:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address_payable",
                              typeString: "address payable",
                            },
                          },
                          {
                            expression: {
                              id: 137,
                              name: "block",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -4,
                              src: "1306:5:1",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_block",
                                typeString: "block",
                              },
                            },
                            id: 138,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "number",
                            nodeType: "MemberAccess",
                            src: "1306:12:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_string_memory_ptr",
                              typeString: "string memory",
                            },
                            {
                              typeIdentifier: "t_address_payable",
                              typeString: "address payable",
                            },
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          ],
                          id: 132,
                          name: "PixelChain",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 58,
                          src: "1265:10:1",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_struct$_PixelChain_$58_storage_ptr_$",
                            typeString: "type(struct PixelChainMax.PixelChain storage pointer)",
                          },
                        },
                        id: 139,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "structConstructorCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "1265:54:1",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_PixelChain_$58_memory_ptr",
                          typeString: "struct PixelChainMax.PixelChain memory",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_struct$_PixelChain_$58_memory_ptr",
                          typeString: "struct PixelChainMax.PixelChain memory",
                        },
                      ],
                      expression: {
                        id: 129,
                        name: "pixelChains",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89,
                        src: "1235:11:1",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                          typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                        },
                      },
                      id: 131,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "push",
                      nodeType: "MemberAccess",
                      src: "1235:16:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_arraypush_nonpayable$_t_struct$_PixelChain_$58_storage_$returns$__$",
                        typeString: "function (struct PixelChainMax.PixelChain storage ref)",
                      },
                    },
                    id: 140,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1235:94:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 141,
                  nodeType: "ExpressionStatement",
                  src: "1235:94:1",
                },
                {
                  assignments: [143],
                  declarations: [
                    {
                      constant: false,
                      id: 143,
                      mutability: "mutable",
                      name: "id",
                      nodeType: "VariableDeclaration",
                      scope: 165,
                      src: "1340:10:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 142,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "1340:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 148,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 147,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 144,
                        name: "pixelChains",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89,
                        src: "1353:11:1",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                          typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                        },
                      },
                      id: 145,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "length",
                      nodeType: "MemberAccess",
                      src: "1353:18:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: "-",
                    rightExpression: {
                      hexValue: "31",
                      id: 146,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1374:1:1",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_1_by_1",
                        typeString: "int_const 1",
                      },
                      value: "1",
                    },
                    src: "1353:22:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1340:35:1",
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 150,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "1391:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg",
                          },
                        },
                        id: 151,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "1391:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                      },
                      {
                        id: 152,
                        name: "id",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 143,
                        src: "1403:2:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      ],
                      id: 149,
                      name: "_mint",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1478,
                      src: "1385:5:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (address,uint256)",
                      },
                    },
                    id: 153,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1385:21:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 154,
                  nodeType: "ExpressionStatement",
                  src: "1385:21:1",
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 156,
                        name: "id",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 143,
                        src: "1440:2:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      {
                        expression: {
                          id: 157,
                          name: "_pixelChain",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 99,
                          src: "1444:11:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                            typeString: "struct PixelChainMax.NewPixelChain memory",
                          },
                        },
                        id: 158,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "data",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 62,
                        src: "1444:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                      },
                      {
                        expression: {
                          id: 159,
                          name: "_pixelChain",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 99,
                          src: "1462:11:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                            typeString: "struct PixelChainMax.NewPixelChain memory",
                          },
                        },
                        id: 160,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "palette",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 64,
                        src: "1462:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                      },
                      {
                        expression: {
                          id: 161,
                          name: "_pixelChain",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 99,
                          src: "1483:11:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                            typeString: "struct PixelChainMax.NewPixelChain memory",
                          },
                        },
                        id: 162,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "version",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 66,
                        src: "1483:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                        {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      ],
                      id: 155,
                      name: "PixelChainCreated",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 51,
                      src: "1422:17:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_event_nonpayable$_t_uint256_$_t_bytes_memory_ptr_$_t_bytes_memory_ptr_$_t_uint8_$returns$__$",
                        typeString: "function (uint256,bytes memory,bytes memory,uint8)",
                      },
                    },
                    id: 163,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1422:81:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 164,
                  nodeType: "EmitStatement",
                  src: "1417:86:1",
                },
              ],
            },
            functionSelector: "38186847",
            id: 166,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "create",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 100,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 99,
                  mutability: "mutable",
                  name: "_pixelChain",
                  nodeType: "VariableDeclaration",
                  scope: 166,
                  src: "909:32:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_NewPixelChain_$67_memory_ptr",
                    typeString: "struct PixelChainMax.NewPixelChain",
                  },
                  typeName: {
                    id: 98,
                    name: "NewPixelChain",
                    nodeType: "UserDefinedTypeName",
                    referencedDeclaration: 67,
                    src: "909:13:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_NewPixelChain_$67_storage_ptr",
                      typeString: "struct PixelChainMax.NewPixelChain",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "908:34:1",
            },
            returnParameters: {
              id: 101,
              nodeType: "ParameterList",
              parameters: [],
              src: "960:0:1",
            },
            scope: 414,
            src: "893:617:1",
            stateMutability: "payable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 249,
              nodeType: "Block",
              src: "1611:503:1",
              statements: [
                {
                  assignments: [177],
                  declarations: [
                    {
                      constant: false,
                      id: 177,
                      mutability: "mutable",
                      name: "end",
                      nodeType: "VariableDeclaration",
                      scope: 249,
                      src: "1621:11:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 176,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "1621:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 179,
                  initialValue: {
                    id: 178,
                    name: "_end",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 170,
                    src: "1635:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1621:18:1",
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 183,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 180,
                      name: "_end",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 170,
                      src: "1653:4:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      expression: {
                        id: 181,
                        name: "pixelChains",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89,
                        src: "1660:11:1",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                          typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                        },
                      },
                      id: 182,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "length",
                      nodeType: "MemberAccess",
                      src: "1660:18:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "1653:25:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 190,
                  nodeType: "IfStatement",
                  src: "1649:80:1",
                  trueBody: {
                    id: 189,
                    nodeType: "Block",
                    src: "1680:49:1",
                    statements: [
                      {
                        expression: {
                          id: 187,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 184,
                            name: "end",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 177,
                            src: "1694:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              id: 185,
                              name: "pixelChains",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89,
                              src: "1700:11:1",
                              typeDescriptions: {
                                typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                                typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                              },
                            },
                            id: 186,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "length",
                            nodeType: "MemberAccess",
                            src: "1700:18:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          src: "1694:24:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        id: 188,
                        nodeType: "ExpressionStatement",
                        src: "1694:24:1",
                      },
                    ],
                  },
                },
                {
                  assignments: [192],
                  declarations: [
                    {
                      constant: false,
                      id: 192,
                      mutability: "mutable",
                      name: "arraySize",
                      nodeType: "VariableDeclaration",
                      scope: 249,
                      src: "1739:17:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 191,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "1739:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 193,
                  nodeType: "VariableDeclarationStatement",
                  src: "1739:17:1",
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 196,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 194,
                      name: "_start",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 168,
                      src: "1770:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      id: 195,
                      name: "end",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 177,
                      src: "1779:3:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "1770:12:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  falseBody: {
                    id: 208,
                    nodeType: "Block",
                    src: "1828:49:1",
                    statements: [
                      {
                        expression: {
                          id: 206,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 202,
                            name: "arraySize",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 192,
                            src: "1842:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            commonType: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                            id: 205,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              id: 203,
                              name: "end",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 177,
                              src: "1854:3:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                            nodeType: "BinaryOperation",
                            operator: "-",
                            rightExpression: {
                              id: 204,
                              name: "_start",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 168,
                              src: "1860:6:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                            src: "1854:12:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          src: "1842:24:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        id: 207,
                        nodeType: "ExpressionStatement",
                        src: "1842:24:1",
                      },
                    ],
                  },
                  id: 209,
                  nodeType: "IfStatement",
                  src: "1766:111:1",
                  trueBody: {
                    id: 201,
                    nodeType: "Block",
                    src: "1784:38:1",
                    statements: [
                      {
                        expression: {
                          id: 199,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 197,
                            name: "arraySize",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 192,
                            src: "1798:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            hexValue: "30",
                            id: 198,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "1810:1:1",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0",
                            },
                            value: "0",
                          },
                          src: "1798:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        id: 200,
                        nodeType: "ExpressionStatement",
                        src: "1798:13:1",
                      },
                    ],
                  },
                },
                {
                  assignments: [213],
                  declarations: [
                    {
                      constant: false,
                      id: 213,
                      mutability: "mutable",
                      name: "response",
                      nodeType: "VariableDeclaration",
                      scope: 249,
                      src: "1887:28:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                        typeString: "struct PixelChainMax.PixelChain[]",
                      },
                      typeName: {
                        baseType: {
                          id: 211,
                          name: "PixelChain",
                          nodeType: "UserDefinedTypeName",
                          referencedDeclaration: 58,
                          src: "1887:10:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$58_storage_ptr",
                            typeString: "struct PixelChainMax.PixelChain",
                          },
                        },
                        id: 212,
                        nodeType: "ArrayTypeName",
                        src: "1887:12:1",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage_ptr",
                          typeString: "struct PixelChainMax.PixelChain[]",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 219,
                  initialValue: {
                    arguments: [
                      {
                        id: 217,
                        name: "arraySize",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 192,
                        src: "1935:9:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      ],
                      id: 216,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "NewExpression",
                      src: "1918:16:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr_$",
                        typeString: "function (uint256) pure returns (struct PixelChainMax.PixelChain memory[] memory)",
                      },
                      typeName: {
                        baseType: {
                          id: 214,
                          name: "PixelChain",
                          nodeType: "UserDefinedTypeName",
                          referencedDeclaration: 58,
                          src: "1922:10:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$58_storage_ptr",
                            typeString: "struct PixelChainMax.PixelChain",
                          },
                        },
                        id: 215,
                        nodeType: "ArrayTypeName",
                        src: "1922:12:1",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage_ptr",
                          typeString: "struct PixelChainMax.PixelChain[]",
                        },
                      },
                    },
                    id: 218,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1918:27:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                      typeString: "struct PixelChainMax.PixelChain memory[] memory",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1887:58:1",
                },
                {
                  assignments: [221],
                  declarations: [
                    {
                      constant: false,
                      id: 221,
                      mutability: "mutable",
                      name: "x",
                      nodeType: "VariableDeclaration",
                      scope: 249,
                      src: "1956:6:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 220,
                        name: "uint",
                        nodeType: "ElementaryTypeName",
                        src: "1956:4:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      visibility: "internal",
                    },
                  ],
                  id: 223,
                  initialValue: {
                    hexValue: "30",
                    id: 222,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "number",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "1965:1:1",
                    typeDescriptions: {
                      typeIdentifier: "t_rational_0_by_1",
                      typeString: "int_const 0",
                    },
                    value: "0",
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1956:10:1",
                },
                {
                  body: {
                    id: 245,
                    nodeType: "Block",
                    src: "2012:70:1",
                    statements: [
                      {
                        expression: {
                          id: 240,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            baseExpression: {
                              id: 234,
                              name: "response",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 213,
                              src: "2026:8:1",
                              typeDescriptions: {
                                typeIdentifier: "t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                                typeString: "struct PixelChainMax.PixelChain memory[] memory",
                              },
                            },
                            id: 236,
                            indexExpression: {
                              id: 235,
                              name: "x",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 221,
                              src: "2035:1:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            nodeType: "IndexAccess",
                            src: "2026:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_PixelChain_$58_memory_ptr",
                              typeString: "struct PixelChainMax.PixelChain memory",
                            },
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            baseExpression: {
                              id: 237,
                              name: "pixelChains",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89,
                              src: "2040:11:1",
                              typeDescriptions: {
                                typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                                typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                              },
                            },
                            id: 239,
                            indexExpression: {
                              id: 238,
                              name: "i",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 225,
                              src: "2052:1:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "2040:14:1",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_PixelChain_$58_storage",
                              typeString: "struct PixelChainMax.PixelChain storage ref",
                            },
                          },
                          src: "2026:28:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$58_memory_ptr",
                            typeString: "struct PixelChainMax.PixelChain memory",
                          },
                        },
                        id: 241,
                        nodeType: "ExpressionStatement",
                        src: "2026:28:1",
                      },
                      {
                        expression: {
                          id: 243,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "UnaryOperation",
                          operator: "++",
                          prefix: false,
                          src: "2068:3:1",
                          subExpression: {
                            id: 242,
                            name: "x",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 221,
                            src: "2068:1:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        id: 244,
                        nodeType: "ExpressionStatement",
                        src: "2068:3:1",
                      },
                    ],
                  },
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 230,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 228,
                      name: "i",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 225,
                      src: "1998:1:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 229,
                      name: "end",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 177,
                      src: "2002:3:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "1998:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 246,
                  initializationExpression: {
                    assignments: [225],
                    declarations: [
                      {
                        constant: false,
                        id: 225,
                        mutability: "mutable",
                        name: "i",
                        nodeType: "VariableDeclaration",
                        scope: 246,
                        src: "1981:6:1",
                        stateVariable: false,
                        storageLocation: "default",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        typeName: {
                          id: 224,
                          name: "uint",
                          nodeType: "ElementaryTypeName",
                          src: "1981:4:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        visibility: "internal",
                      },
                    ],
                    id: 227,
                    initialValue: {
                      id: 226,
                      name: "_start",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 168,
                      src: "1990:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "VariableDeclarationStatement",
                    src: "1981:15:1",
                  },
                  loopExpression: {
                    expression: {
                      id: 232,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "UnaryOperation",
                      operator: "++",
                      prefix: false,
                      src: "2007:3:1",
                      subExpression: {
                        id: 231,
                        name: "i",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 225,
                        src: "2007:1:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    id: 233,
                    nodeType: "ExpressionStatement",
                    src: "2007:3:1",
                  },
                  nodeType: "ForStatement",
                  src: "1976:106:1",
                },
                {
                  expression: {
                    id: 247,
                    name: "response",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 213,
                    src: "2099:8:1",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                      typeString: "struct PixelChainMax.PixelChain memory[] memory",
                    },
                  },
                  functionReturnParameters: 175,
                  id: 248,
                  nodeType: "Return",
                  src: "2092:15:1",
                },
              ],
            },
            functionSelector: "b81107b9",
            id: 250,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "retrieveAll",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 171,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 168,
                  mutability: "mutable",
                  name: "_start",
                  nodeType: "VariableDeclaration",
                  scope: 250,
                  src: "1537:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 167,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1537:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 170,
                  mutability: "mutable",
                  name: "_end",
                  nodeType: "VariableDeclaration",
                  scope: 250,
                  src: "1553:12:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 169,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1553:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "1536:30:1",
            },
            returnParameters: {
              id: 175,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 174,
                  mutability: "mutable",
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 250,
                  src: "1590:19:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_struct$_PixelChain_$58_memory_ptr_$dyn_memory_ptr",
                    typeString: "struct PixelChainMax.PixelChain[]",
                  },
                  typeName: {
                    baseType: {
                      id: 172,
                      name: "PixelChain",
                      nodeType: "UserDefinedTypeName",
                      referencedDeclaration: 58,
                      src: "1590:10:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PixelChain_$58_storage_ptr",
                        typeString: "struct PixelChainMax.PixelChain",
                      },
                    },
                    id: 173,
                    nodeType: "ArrayTypeName",
                    src: "1590:12:1",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage_ptr",
                      typeString: "struct PixelChainMax.PixelChain[]",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "1589:21:1",
            },
            scope: 414,
            src: "1516:598:1",
            stateMutability: "view",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 261,
              nodeType: "Block",
              src: "2193:40:1",
              statements: [
                {
                  expression: {
                    baseExpression: {
                      id: 257,
                      name: "pixelChains",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89,
                      src: "2210:11:1",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_struct$_PixelChain_$58_storage_$dyn_storage",
                        typeString: "struct PixelChainMax.PixelChain storage ref[] storage ref",
                      },
                    },
                    id: 259,
                    indexExpression: {
                      id: 258,
                      name: "_id",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 252,
                      src: "2222:3:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "2210:16:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PixelChain_$58_storage",
                      typeString: "struct PixelChainMax.PixelChain storage ref",
                    },
                  },
                  functionReturnParameters: 256,
                  id: 260,
                  nodeType: "Return",
                  src: "2203:23:1",
                },
              ],
            },
            functionSelector: "8f88708b",
            id: 262,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "retrieve",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 253,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 252,
                  mutability: "mutable",
                  name: "_id",
                  nodeType: "VariableDeclaration",
                  scope: 262,
                  src: "2138:11:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 251,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2138:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2137:13:1",
            },
            returnParameters: {
              id: 256,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 255,
                  mutability: "mutable",
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 262,
                  src: "2174:17:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_PixelChain_$58_memory_ptr",
                    typeString: "struct PixelChainMax.PixelChain",
                  },
                  typeName: {
                    id: 254,
                    name: "PixelChain",
                    nodeType: "UserDefinedTypeName",
                    referencedDeclaration: 58,
                    src: "2174:10:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PixelChain_$58_storage_ptr",
                      typeString: "struct PixelChainMax.PixelChain",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2173:19:1",
            },
            scope: 414,
            src: "2120:113:1",
            stateMutability: "view",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 273,
              nodeType: "Block",
              src: "2303:34:1",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 270,
                        name: "_uri",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 264,
                        src: "2325:4:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      ],
                      id: 269,
                      name: "_setBaseURI",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1650,
                      src: "2313:11:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (string memory)",
                      },
                    },
                    id: 271,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2313:17:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 272,
                  nodeType: "ExpressionStatement",
                  src: "2313:17:1",
                },
              ],
            },
            functionSelector: "30176e13",
            id: 274,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 267,
                modifierName: {
                  id: 266,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2293:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2293:9:1",
              },
            ],
            name: "setBaseTokenURI",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 265,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 264,
                  mutability: "mutable",
                  name: "_uri",
                  nodeType: "VariableDeclaration",
                  scope: 274,
                  src: "2264:18:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 263,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "2264:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2263:20:1",
            },
            returnParameters: {
              id: 268,
              nodeType: "ParameterList",
              parameters: [],
              src: "2303:0:1",
            },
            scope: 414,
            src: "2239:98:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 291,
              nodeType: "Block",
              src: "2382:59:1",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          arguments: [
                            {
                              id: 286,
                              name: "this",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -28,
                              src: "2420:4:1",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_PixelChainMax_$414",
                                typeString: "contract PixelChainMax",
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_contract$_PixelChainMax_$414",
                                typeString: "contract PixelChainMax",
                              },
                            ],
                            id: 285,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "2412:7:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_address_$",
                              typeString: "type(address)",
                            },
                            typeName: {
                              id: 284,
                              name: "address",
                              nodeType: "ElementaryTypeName",
                              src: "2412:7:1",
                              typeDescriptions: {},
                            },
                          },
                          id: 287,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "2412:13:1",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address",
                          },
                        },
                        id: 288,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "balance",
                        nodeType: "MemberAccess",
                        src: "2412:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      ],
                      expression: {
                        expression: {
                          id: 279,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "2392:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg",
                          },
                        },
                        id: 282,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "2392:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                      },
                      id: 283,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "transfer",
                      nodeType: "MemberAccess",
                      src: "2392:19:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
                        typeString: "function (uint256)",
                      },
                    },
                    id: 289,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2392:42:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 290,
                  nodeType: "ExpressionStatement",
                  src: "2392:42:1",
                },
              ],
            },
            functionSelector: "3ccfd60b",
            id: 292,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 277,
                modifierName: {
                  id: 276,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2372:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2372:9:1",
              },
            ],
            name: "withdraw",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 275,
              nodeType: "ParameterList",
              parameters: [],
              src: "2360:2:1",
            },
            returnParameters: {
              id: 278,
              nodeType: "ParameterList",
              parameters: [],
              src: "2382:0:1",
            },
            scope: 414,
            src: "2343:98:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 303,
              nodeType: "Block",
              src: "2511:42:1",
              statements: [
                {
                  expression: {
                    id: 301,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 299,
                      name: "defaultMintPrice",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 70,
                      src: "2521:16:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 300,
                      name: "_price",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 294,
                      src: "2540:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "2521:25:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  id: 302,
                  nodeType: "ExpressionStatement",
                  src: "2521:25:1",
                },
              ],
            },
            functionSelector: "3ea02d0f",
            id: 304,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 297,
                modifierName: {
                  id: 296,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2501:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2501:9:1",
              },
            ],
            name: "setDefaultMintPrice",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 295,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 294,
                  mutability: "mutable",
                  name: "_price",
                  nodeType: "VariableDeclaration",
                  scope: 304,
                  src: "2476:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 293,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2476:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2475:16:1",
            },
            returnParameters: {
              id: 298,
              nodeType: "ParameterList",
              parameters: [],
              src: "2511:0:1",
            },
            scope: 414,
            src: "2447:106:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 319,
              nodeType: "Block",
              src: "2642:55:1",
              statements: [
                {
                  expression: {
                    id: 317,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 313,
                        name: "mintPricePerVersion",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 86,
                        src: "2652:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint8_$_t_uint256_$",
                          typeString: "mapping(uint8 => uint256)",
                        },
                      },
                      id: 315,
                      indexExpression: {
                        id: 314,
                        name: "_version",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 306,
                        src: "2672:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "2652:29:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 316,
                      name: "_price",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 308,
                      src: "2684:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "2652:38:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  id: 318,
                  nodeType: "ExpressionStatement",
                  src: "2652:38:1",
                },
              ],
            },
            functionSelector: "d3fb43c6",
            id: 320,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 311,
                modifierName: {
                  id: 310,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2632:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2632:9:1",
              },
            ],
            name: "setMintPricePerVersion",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 309,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 306,
                  mutability: "mutable",
                  name: "_version",
                  nodeType: "VariableDeclaration",
                  scope: 320,
                  src: "2591:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8",
                  },
                  typeName: {
                    id: 305,
                    name: "uint8",
                    nodeType: "ElementaryTypeName",
                    src: "2591:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8",
                    },
                  },
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 308,
                  mutability: "mutable",
                  name: "_price",
                  nodeType: "VariableDeclaration",
                  scope: 320,
                  src: "2607:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 307,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2607:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2590:32:1",
            },
            returnParameters: {
              id: 312,
              nodeType: "ParameterList",
              parameters: [],
              src: "2642:0:1",
            },
            scope: 414,
            src: "2559:138:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 333,
              nodeType: "Block",
              src: "2771:50:1",
              statements: [
                {
                  expression: {
                    id: 331,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 327,
                        name: "addressBlacklist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74,
                        src: "2781:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                          typeString: "mapping(address => bool)",
                        },
                      },
                      id: 329,
                      indexExpression: {
                        id: 328,
                        name: "_address",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 322,
                        src: "2798:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "2781:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "74727565",
                      id: 330,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "2810:4:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "true",
                    },
                    src: "2781:33:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 332,
                  nodeType: "ExpressionStatement",
                  src: "2781:33:1",
                },
              ],
            },
            functionSelector: "f2c816ae",
            id: 334,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 325,
                modifierName: {
                  id: 324,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2761:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2761:9:1",
              },
            ],
            name: "addAddressToBlacklist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 323,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 322,
                  mutability: "mutable",
                  name: "_address",
                  nodeType: "VariableDeclaration",
                  scope: 334,
                  src: "2734:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 321,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2734:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2733:18:1",
            },
            returnParameters: {
              id: 326,
              nodeType: "ParameterList",
              parameters: [],
              src: "2771:0:1",
            },
            scope: 414,
            src: "2703:118:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 347,
              nodeType: "Block",
              src: "2900:51:1",
              statements: [
                {
                  expression: {
                    id: 345,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 341,
                        name: "addressBlacklist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74,
                        src: "2910:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                          typeString: "mapping(address => bool)",
                        },
                      },
                      id: 343,
                      indexExpression: {
                        id: 342,
                        name: "_address",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 336,
                        src: "2927:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "2910:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "66616c7365",
                      id: 344,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "2939:5:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "false",
                    },
                    src: "2910:34:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 346,
                  nodeType: "ExpressionStatement",
                  src: "2910:34:1",
                },
              ],
            },
            functionSelector: "35e82f3a",
            id: 348,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 339,
                modifierName: {
                  id: 338,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "2890:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2890:9:1",
              },
            ],
            name: "removeAddressFromBlacklist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 337,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 336,
                  mutability: "mutable",
                  name: "_address",
                  nodeType: "VariableDeclaration",
                  scope: 348,
                  src: "2863:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 335,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2863:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2862:18:1",
            },
            returnParameters: {
              id: 340,
              nodeType: "ParameterList",
              parameters: [],
              src: "2900:0:1",
            },
            scope: 414,
            src: "2827:124:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 361,
              nodeType: "Block",
              src: "3025:50:1",
              statements: [
                {
                  expression: {
                    id: 359,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 355,
                        name: "addressWhitelist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 78,
                        src: "3035:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                          typeString: "mapping(address => bool)",
                        },
                      },
                      id: 357,
                      indexExpression: {
                        id: 356,
                        name: "_address",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 350,
                        src: "3052:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "3035:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "74727565",
                      id: 358,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "3064:4:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "true",
                    },
                    src: "3035:33:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 360,
                  nodeType: "ExpressionStatement",
                  src: "3035:33:1",
                },
              ],
            },
            functionSelector: "7b9417c8",
            id: 362,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 353,
                modifierName: {
                  id: 352,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "3015:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "3015:9:1",
              },
            ],
            name: "addAddressToWhitelist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 351,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 350,
                  mutability: "mutable",
                  name: "_address",
                  nodeType: "VariableDeclaration",
                  scope: 362,
                  src: "2988:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 349,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2988:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "2987:18:1",
            },
            returnParameters: {
              id: 354,
              nodeType: "ParameterList",
              parameters: [],
              src: "3025:0:1",
            },
            scope: 414,
            src: "2957:118:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 375,
              nodeType: "Block",
              src: "3154:51:1",
              statements: [
                {
                  expression: {
                    id: 373,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 369,
                        name: "addressWhitelist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 78,
                        src: "3164:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
                          typeString: "mapping(address => bool)",
                        },
                      },
                      id: 371,
                      indexExpression: {
                        id: 370,
                        name: "_address",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 364,
                        src: "3181:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "3164:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "66616c7365",
                      id: 372,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "3193:5:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "false",
                    },
                    src: "3164:34:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 374,
                  nodeType: "ExpressionStatement",
                  src: "3164:34:1",
                },
              ],
            },
            functionSelector: "286dd3f5",
            id: 376,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 367,
                modifierName: {
                  id: 366,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "3144:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "3144:9:1",
              },
            ],
            name: "removeAddressFromWhitelist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 365,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 364,
                  mutability: "mutable",
                  name: "_address",
                  nodeType: "VariableDeclaration",
                  scope: 376,
                  src: "3117:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 363,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "3117:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "3116:18:1",
            },
            returnParameters: {
              id: 368,
              nodeType: "ParameterList",
              parameters: [],
              src: "3154:0:1",
            },
            scope: 414,
            src: "3081:124:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 389,
              nodeType: "Block",
              src: "3277:50:1",
              statements: [
                {
                  expression: {
                    id: 387,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 383,
                        name: "versionWhitelist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82,
                        src: "3287:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint8_$_t_bool_$",
                          typeString: "mapping(uint8 => bool)",
                        },
                      },
                      id: 385,
                      indexExpression: {
                        id: 384,
                        name: "_version",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 378,
                        src: "3304:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "3287:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "74727565",
                      id: 386,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "3316:4:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "true",
                    },
                    src: "3287:33:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 388,
                  nodeType: "ExpressionStatement",
                  src: "3287:33:1",
                },
              ],
            },
            functionSelector: "b8f2716f",
            id: 390,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 381,
                modifierName: {
                  id: 380,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "3267:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "3267:9:1",
              },
            ],
            name: "addVersionToWhitelist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 379,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 378,
                  mutability: "mutable",
                  name: "_version",
                  nodeType: "VariableDeclaration",
                  scope: 390,
                  src: "3242:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8",
                  },
                  typeName: {
                    id: 377,
                    name: "uint8",
                    nodeType: "ElementaryTypeName",
                    src: "3242:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "3241:16:1",
            },
            returnParameters: {
              id: 382,
              nodeType: "ParameterList",
              parameters: [],
              src: "3277:0:1",
            },
            scope: 414,
            src: "3211:116:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 403,
              nodeType: "Block",
              src: "3404:51:1",
              statements: [
                {
                  expression: {
                    id: 401,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 397,
                        name: "versionWhitelist",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82,
                        src: "3414:16:1",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint8_$_t_bool_$",
                          typeString: "mapping(uint8 => bool)",
                        },
                      },
                      id: 399,
                      indexExpression: {
                        id: 398,
                        name: "_version",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 392,
                        src: "3431:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint8",
                          typeString: "uint8",
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "3414:26:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "66616c7365",
                      id: 400,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "3443:5:1",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool",
                      },
                      value: "false",
                    },
                    src: "3414:34:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  id: 402,
                  nodeType: "ExpressionStatement",
                  src: "3414:34:1",
                },
              ],
            },
            functionSelector: "6a66005a",
            id: 404,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 395,
                modifierName: {
                  id: 394,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 495,
                  src: "3394:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "3394:9:1",
              },
            ],
            name: "removeVersionFromWhitelist",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 393,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 392,
                  mutability: "mutable",
                  name: "_version",
                  nodeType: "VariableDeclaration",
                  scope: 404,
                  src: "3369:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8",
                  },
                  typeName: {
                    id: 391,
                    name: "uint8",
                    nodeType: "ElementaryTypeName",
                    src: "3369:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "3368:16:1",
            },
            returnParameters: {
              id: 396,
              nodeType: "ParameterList",
              parameters: [],
              src: "3404:0:1",
            },
            scope: 414,
            src: "3333:122:1",
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external",
          },
          {
            body: {
              id: 412,
              nodeType: "Block",
              src: "3523:33:1",
              statements: [
                {
                  expression: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      id: 409,
                      name: "baseURI",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 1051,
                      src: "3540:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$__$returns$_t_string_memory_ptr_$",
                        typeString: "function () view returns (string memory)",
                      },
                    },
                    id: 410,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3540:9:1",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory",
                    },
                  },
                  functionReturnParameters: 408,
                  id: 411,
                  nodeType: "Return",
                  src: "3533:16:1",
                },
              ],
            },
            functionSelector: "d547cfb7",
            id: 413,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "baseTokenURI",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 405,
              nodeType: "ParameterList",
              parameters: [],
              src: "3482:2:1",
            },
            returnParameters: {
              id: 408,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 407,
                  mutability: "mutable",
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 413,
                  src: "3508:13:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 406,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "3508:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  visibility: "internal",
                },
              ],
              src: "3507:15:1",
            },
            scope: 414,
            src: "3461:95:1",
            stateMutability: "view",
            virtual: false,
            visibility: "external",
          },
        ],
        scope: 415,
        src: "203:3355:1",
      },
    ],
    src: "32:3527:1",
  },
  compiler: {
    name: "solc",
    version: "0.7.5+commit.eb77ed08.Emscripten.clang",
  },
  networks: {
    4: {
      events: {
        "0x8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925": {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "owner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "approved",
              type: "address",
            },
            {
              indexed: true,
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
            },
          ],
          name: "Approval",
          type: "event",
        },
        "0x17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31": {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "owner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "operator",
              type: "address",
            },
            {
              indexed: false,
              internalType: "bool",
              name: "approved",
              type: "bool",
            },
          ],
          name: "ApprovalForAll",
          type: "event",
        },
        "0x8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0": {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "previousOwner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "newOwner",
              type: "address",
            },
          ],
          name: "OwnershipTransferred",
          type: "event",
        },
        "0x8e20869f6c702b2db8862f4bdd2603bec29ff2a0ad38c0606618eab9e0d3ec50": {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "bytes",
              name: "data",
              type: "bytes",
            },
            {
              indexed: false,
              internalType: "bytes",
              name: "palette",
              type: "bytes",
            },
            {
              indexed: false,
              internalType: "uint8",
              name: "version",
              type: "uint8",
            },
          ],
          name: "PixelChainCreated",
          type: "event",
        },
        "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef": {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "from",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "to",
              type: "address",
            },
            {
              indexed: true,
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
            },
          ],
          name: "Transfer",
          type: "event",
        },
      },
      links: {},
      address: "0x1acD678c7c82175F609Bed8166675eB45C61C365",
      transactionHash: "0x6f1082d5781940a1f2bfd42976d89b492abded2c0df7b8c61ae89dcf561499bd",
    },
  },
  schemaVersion: "3.3.1",
  updatedAt: "2020-11-29T19:02:43.847Z",
  networkType: "ethereum",
  devdoc: {
    kind: "dev",
    methods: {
      "approve(address,uint256)": {
        details: "See {IERC721-approve}.",
      },
      "balanceOf(address)": {
        details: "See {IERC721-balanceOf}.",
      },
      "baseURI()": {
        details:
          "Returns the base URI set via {_setBaseURI}. This will be automatically added as a prefix in {tokenURI} to each token's URI, or to the token ID if no specific URI is set for that token ID.",
      },
      "getApproved(uint256)": {
        details: "See {IERC721-getApproved}.",
      },
      "isApprovedForAll(address,address)": {
        details: "See {IERC721-isApprovedForAll}.",
      },
      "name()": {
        details: "See {IERC721Metadata-name}.",
      },
      "owner()": {
        details: "Returns the address of the current owner.",
      },
      "ownerOf(uint256)": {
        details: "See {IERC721-ownerOf}.",
      },
      "renounceOwnership()": {
        details:
          "Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner.",
      },
      "safeTransferFrom(address,address,uint256)": {
        details: "See {IERC721-safeTransferFrom}.",
      },
      "safeTransferFrom(address,address,uint256,bytes)": {
        details: "See {IERC721-safeTransferFrom}.",
      },
      "setApprovalForAll(address,bool)": {
        details: "See {IERC721-setApprovalForAll}.",
      },
      "supportsInterface(bytes4)": {
        details:
          "See {IERC165-supportsInterface}. Time complexity O(1), guaranteed to always use less than 30 000 gas.",
      },
      "symbol()": {
        details: "See {IERC721Metadata-symbol}.",
      },
      "tokenByIndex(uint256)": {
        details: "See {IERC721Enumerable-tokenByIndex}.",
      },
      "tokenOfOwnerByIndex(address,uint256)": {
        details: "See {IERC721Enumerable-tokenOfOwnerByIndex}.",
      },
      "tokenURI(uint256)": {
        details: "See {IERC721Metadata-tokenURI}.",
      },
      "totalSupply()": {
        details: "See {IERC721Enumerable-totalSupply}.",
      },
      "transferFrom(address,address,uint256)": {
        details: "See {IERC721-transferFrom}.",
      },
      "transferOwnership(address)": {
        details:
          "Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner.",
      },
    },
    version: 1,
  },
  userdoc: {
    kind: "user",
    methods: {},
    version: 1,
  },
};
